var on = Object.defineProperty, ln = Object.defineProperties;
var cn = Object.getOwnPropertyDescriptors;
var ke = Object.getOwnPropertySymbols;
var Jt = Object.prototype.hasOwnProperty, Qt = Object.prototype.propertyIsEnumerable;
var Xt = (u, e, t) => e in u ? on(u, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : u[e] = t, U = (u, e) => {
  for (var t in e || (e = {}))
    Jt.call(e, t) && Xt(u, t, e[t]);
  if (ke)
    for (var t of ke(e))
      Qt.call(e, t) && Xt(u, t, e[t]);
  return u;
}, _u = (u, e) => ln(u, cn(e));
var Pu = (u, e) => {
  var t = {};
  for (var n in u)
    Jt.call(u, n) && e.indexOf(n) < 0 && (t[n] = u[n]);
  if (u != null && ke)
    for (var n of ke(u))
      e.indexOf(n) < 0 && Qt.call(u, n) && (t[n] = u[n]);
  return t;
};
import * as F from "react";
import Eu, { useRef as je, useContext as Ke, createElement as Fn, useState as ju, useEffect as Zu, useLayoutEffect as En, Component as Cn, createContext as dn } from "react";
import "react-dom";
import Ru from "react-player";
import Yu from "moment";
import An from "@microlink/react";
var pn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ne(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var Ct = { exports: {} }, le = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var tt, u0;
function T0() {
  if (u0) return tt;
  u0 = 1;
  var u = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function D() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var o = Object.getOwnPropertyNames(i).map(function(g) {
        return i[g];
      });
      if (o.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(g) {
        c[g] = g;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch (g) {
      return !1;
    }
  }
  return tt = D() ? Object.assign : function(s, i) {
    for (var a, o = n(s), c, g = 1; g < arguments.length; g++) {
      a = Object(arguments[g]);
      for (var m in a)
        e.call(a, m) && (o[m] = a[m]);
      if (u) {
        c = u(a);
        for (var v = 0; v < c.length; v++)
          t.call(a, c[v]) && (o[c[v]] = a[c[v]]);
      }
    }
    return o;
  }, tt;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e0;
function fn() {
  if (e0) return le;
  e0 = 1, T0();
  var u = Eu, e = 60103;
  if (le.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    e = t("react.element"), le.Fragment = t("react.fragment");
  }
  var n = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, D = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(a, o, c) {
    var g, m = {}, v = null, l = null;
    c !== void 0 && (v = "" + c), o.key !== void 0 && (v = "" + o.key), o.ref !== void 0 && (l = o.ref);
    for (g in o) D.call(o, g) && !s.hasOwnProperty(g) && (m[g] = o[g]);
    if (a && a.defaultProps) for (g in o = a.defaultProps, o) m[g] === void 0 && (m[g] = o[g]);
    return { $$typeof: e, type: a, key: v, ref: l, props: m, _owner: n.current };
  }
  return le.jsx = i, le.jsxs = i, le;
}
var rt = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t0;
function hn() {
  return t0 || (t0 = 1, function(u) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Eu, t = T0(), n = 60103, D = 60106;
      u.Fragment = 60107;
      var s = 60108, i = 60114, a = 60109, o = 60110, c = 60112, g = 60113, m = 60120, v = 60115, l = 60116, p = 60121, h = 60122, E = 60117, w = 60129, C = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var d = Symbol.for;
        n = d("react.element"), D = d("react.portal"), u.Fragment = d("react.fragment"), s = d("react.strict_mode"), i = d("react.profiler"), a = d("react.provider"), o = d("react.context"), c = d("react.forward_ref"), g = d("react.suspense"), m = d("react.suspense_list"), v = d("react.memo"), l = d("react.lazy"), p = d("react.block"), h = d("react.server.block"), E = d("react.fundamental"), d("react.scope"), d("react.opaque.id"), w = d("react.debug_trace_mode"), d("react.offscreen"), C = d("react.legacy_hidden");
      }
      var f = typeof Symbol == "function" && Symbol.iterator, B = "@@iterator";
      function j(A) {
        if (A === null || typeof A != "object")
          return null;
        var _ = f && A[f] || A[B];
        return typeof _ == "function" ? _ : null;
      }
      var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function T(A) {
        {
          for (var _ = arguments.length, O = new Array(_ > 1 ? _ - 1 : 0), K = 1; K < _; K++)
            O[K - 1] = arguments[K];
          q("error", A, O);
        }
      }
      function q(A, _, O) {
        {
          var K = I.ReactDebugCurrentFrame, fu = K.getStackAddendum();
          fu !== "" && (_ += "%s", O = O.concat([fu]));
          var Au = O.map(function(Du) {
            return "" + Du;
          });
          Au.unshift("Warning: " + _), Function.prototype.apply.call(console[A], console, Au);
        }
      }
      var V = !1;
      function X(A) {
        return !!(typeof A == "string" || typeof A == "function" || A === u.Fragment || A === i || A === w || A === s || A === g || A === m || A === C || V || typeof A == "object" && A !== null && (A.$$typeof === l || A.$$typeof === v || A.$$typeof === a || A.$$typeof === o || A.$$typeof === c || A.$$typeof === E || A.$$typeof === p || A[0] === h));
      }
      function G(A, _, O) {
        var K = _.displayName || _.name || "";
        return A.displayName || (K !== "" ? O + "(" + K + ")" : O);
      }
      function J(A) {
        return A.displayName || "Context";
      }
      function Q(A) {
        if (A == null)
          return null;
        if (typeof A.tag == "number" && T("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof A == "function")
          return A.displayName || A.name || null;
        if (typeof A == "string")
          return A;
        switch (A) {
          case u.Fragment:
            return "Fragment";
          case D:
            return "Portal";
          case i:
            return "Profiler";
          case s:
            return "StrictMode";
          case g:
            return "Suspense";
          case m:
            return "SuspenseList";
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case o:
              var _ = A;
              return J(_) + ".Consumer";
            case a:
              var O = A;
              return J(O._context) + ".Provider";
            case c:
              return G(A, A.render, "ForwardRef");
            case v:
              return Q(A.type);
            case p:
              return Q(A._render);
            case l: {
              var K = A, fu = K._payload, Au = K._init;
              try {
                return Q(Au(fu));
              } catch (Du) {
                return null;
              }
            }
          }
        return null;
      }
      var tu = 0, Fu, lu, nu, gu, xu, vu, R;
      function $() {
      }
      $.__reactDisabledLog = !0;
      function P() {
        {
          if (tu === 0) {
            Fu = console.log, lu = console.info, nu = console.warn, gu = console.error, xu = console.group, vu = console.groupCollapsed, R = console.groupEnd;
            var A = {
              configurable: !0,
              enumerable: !0,
              value: $,
              writable: !0
            };
            Object.defineProperties(console, {
              info: A,
              log: A,
              warn: A,
              error: A,
              group: A,
              groupCollapsed: A,
              groupEnd: A
            });
          }
          tu++;
        }
      }
      function W() {
        {
          if (tu--, tu === 0) {
            var A = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t({}, A, {
                value: Fu
              }),
              info: t({}, A, {
                value: lu
              }),
              warn: t({}, A, {
                value: nu
              }),
              error: t({}, A, {
                value: gu
              }),
              group: t({}, A, {
                value: xu
              }),
              groupCollapsed: t({}, A, {
                value: vu
              }),
              groupEnd: t({}, A, {
                value: R
              })
            });
          }
          tu < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var x = I.ReactCurrentDispatcher, Z;
      function S(A, _, O) {
        {
          if (Z === void 0)
            try {
              throw Error();
            } catch (fu) {
              var K = fu.stack.trim().match(/\n( *(at )?)/);
              Z = K && K[1] || "";
            }
          return `
` + Z + A;
        }
      }
      var M = !1, z;
      {
        var H = typeof WeakMap == "function" ? WeakMap : Map;
        z = new H();
      }
      function y(A, _) {
        if (!A || M)
          return "";
        {
          var O = z.get(A);
          if (O !== void 0)
            return O;
        }
        var K;
        M = !0;
        var fu = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Au;
        Au = x.current, x.current = null, P();
        try {
          if (_) {
            var Du = function() {
              throw Error();
            };
            if (Object.defineProperty(Du.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Du, []);
              } catch (Wu) {
                K = Wu;
              }
              Reflect.construct(A, [], Du);
            } else {
              try {
                Du.call();
              } catch (Wu) {
                K = Wu;
              }
              A.call(Du.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Wu) {
              K = Wu;
            }
            A();
          }
        } catch (Wu) {
          if (Wu && K && typeof Wu.stack == "string") {
            for (var ru = Wu.stack.split(`
`), ku = K.stack.split(`
`), yu = ru.length - 1, wu = ku.length - 1; yu >= 1 && wu >= 0 && ru[yu] !== ku[wu]; )
              wu--;
            for (; yu >= 1 && wu >= 0; yu--, wu--)
              if (ru[yu] !== ku[wu]) {
                if (yu !== 1 || wu !== 1)
                  do
                    if (yu--, wu--, wu < 0 || ru[yu] !== ku[wu]) {
                      var Vu = `
` + ru[yu].replace(" at new ", " at ");
                      return typeof A == "function" && z.set(A, Vu), Vu;
                    }
                  while (yu >= 1 && wu >= 0);
                break;
              }
          }
        } finally {
          M = !1, x.current = Au, W(), Error.prepareStackTrace = fu;
        }
        var oe = A ? A.displayName || A.name : "", Kt = oe ? S(oe) : "";
        return typeof A == "function" && z.set(A, Kt), Kt;
      }
      function uu(A, _, O) {
        return y(A, !1);
      }
      function N(A) {
        var _ = A.prototype;
        return !!(_ && _.isReactComponent);
      }
      function L(A, _, O) {
        if (A == null)
          return "";
        if (typeof A == "function")
          return y(A, N(A));
        if (typeof A == "string")
          return S(A);
        switch (A) {
          case g:
            return S("Suspense");
          case m:
            return S("SuspenseList");
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case c:
              return uu(A.render);
            case v:
              return L(A.type, _, O);
            case p:
              return uu(A._render);
            case l: {
              var K = A, fu = K._payload, Au = K._init;
              try {
                return L(Au(fu), _, O);
              } catch (Du) {
              }
            }
          }
        return "";
      }
      var Cu = {}, eu = I.ReactDebugCurrentFrame;
      function mu(A) {
        if (A) {
          var _ = A._owner, O = L(A.type, A._source, _ ? _.type : null);
          eu.setExtraStackFrame(O);
        } else
          eu.setExtraStackFrame(null);
      }
      function Uu(A, _, O, K, fu) {
        {
          var Au = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Du in A)
            if (Au(A, Du)) {
              var ru = void 0;
              try {
                if (typeof A[Du] != "function") {
                  var ku = Error((K || "React class") + ": " + O + " type `" + Du + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[Du] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ku.name = "Invariant Violation", ku;
                }
                ru = A[Du](_, Du, K, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (yu) {
                ru = yu;
              }
              ru && !(ru instanceof Error) && (mu(fu), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", K || "React class", O, Du, typeof ru), mu(null)), ru instanceof Error && !(ru.message in Cu) && (Cu[ru.message] = !0, mu(fu), T("Failed %s type: %s", O, ru.message), mu(null));
            }
        }
      }
      var pu = I.ReactCurrentOwner, Iu = Object.prototype.hasOwnProperty, Hu = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Su, Y, du;
      du = {};
      function Ju(A) {
        if (Iu.call(A, "ref")) {
          var _ = Object.getOwnPropertyDescriptor(A, "ref").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return A.ref !== void 0;
      }
      function Qu(A) {
        if (Iu.call(A, "key")) {
          var _ = Object.getOwnPropertyDescriptor(A, "key").get;
          if (_ && _.isReactWarning)
            return !1;
        }
        return A.key !== void 0;
      }
      function $u(A, _) {
        if (typeof A.ref == "string" && pu.current && _ && pu.current.stateNode !== _) {
          var O = Q(pu.current.type);
          du[O] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Q(pu.current.type), A.ref), du[O] = !0);
        }
      }
      function ie(A, _) {
        {
          var O = function() {
            Su || (Su = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
          };
          O.isReactWarning = !0, Object.defineProperty(A, "key", {
            get: O,
            configurable: !0
          });
        }
      }
      function $e(A, _) {
        {
          var O = function() {
            Y || (Y = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
          };
          O.isReactWarning = !0, Object.defineProperty(A, "ref", {
            get: O,
            configurable: !0
          });
        }
      }
      var Ku = function(A, _, O, K, fu, Au, Du) {
        var ru = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: A,
          key: _,
          ref: O,
          props: Du,
          // Record the component responsible for creating this element.
          _owner: Au
        };
        return ru._store = {}, Object.defineProperty(ru._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ru, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: K
        }), Object.defineProperty(ru, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: fu
        }), Object.freeze && (Object.freeze(ru.props), Object.freeze(ru)), ru;
      };
      function Je(A, _, O, K, fu) {
        {
          var Au, Du = {}, ru = null, ku = null;
          O !== void 0 && (ru = "" + O), Qu(_) && (ru = "" + _.key), Ju(_) && (ku = _.ref, $u(_, fu));
          for (Au in _)
            Iu.call(_, Au) && !Hu.hasOwnProperty(Au) && (Du[Au] = _[Au]);
          if (A && A.defaultProps) {
            var yu = A.defaultProps;
            for (Au in yu)
              Du[Au] === void 0 && (Du[Au] = yu[Au]);
          }
          if (ru || ku) {
            var wu = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
            ru && ie(Du, wu), ku && $e(Du, wu);
          }
          return Ku(A, ru, ku, fu, K, pu.current, Du);
        }
      }
      var Qe = I.ReactCurrentOwner, Vt = I.ReactDebugCurrentFrame;
      function ae(A) {
        if (A) {
          var _ = A._owner, O = L(A.type, A._source, _ ? _.type : null);
          Vt.setExtraStackFrame(O);
        } else
          Vt.setExtraStackFrame(null);
      }
      var ut;
      ut = !1;
      function et(A) {
        return typeof A == "object" && A !== null && A.$$typeof === n;
      }
      function Wt() {
        {
          if (Qe.current) {
            var A = Q(Qe.current.type);
            if (A)
              return `

Check the render method of \`` + A + "`.";
          }
          return "";
        }
      }
      function un(A) {
        return "";
      }
      var Gt = {};
      function en(A) {
        {
          var _ = Wt();
          if (!_) {
            var O = typeof A == "string" ? A : A.displayName || A.name;
            O && (_ = `

Check the top-level render call using <` + O + ">.");
          }
          return _;
        }
      }
      function Yt(A, _) {
        {
          if (!A._store || A._store.validated || A.key != null)
            return;
          A._store.validated = !0;
          var O = en(_);
          if (Gt[O])
            return;
          Gt[O] = !0;
          var K = "";
          A && A._owner && A._owner !== Qe.current && (K = " It was passed a child from " + Q(A._owner.type) + "."), ae(A), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, K), ae(null);
        }
      }
      function qt(A, _) {
        {
          if (typeof A != "object")
            return;
          if (Array.isArray(A))
            for (var O = 0; O < A.length; O++) {
              var K = A[O];
              et(K) && Yt(K, _);
            }
          else if (et(A))
            A._store && (A._store.validated = !0);
          else if (A) {
            var fu = j(A);
            if (typeof fu == "function" && fu !== A.entries)
              for (var Au = fu.call(A), Du; !(Du = Au.next()).done; )
                et(Du.value) && Yt(Du.value, _);
          }
        }
      }
      function tn(A) {
        {
          var _ = A.type;
          if (_ == null || typeof _ == "string")
            return;
          var O;
          if (typeof _ == "function")
            O = _.propTypes;
          else if (typeof _ == "object" && (_.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          _.$$typeof === v))
            O = _.propTypes;
          else
            return;
          if (O) {
            var K = Q(_);
            Uu(O, A.props, "prop", K, A);
          } else if (_.PropTypes !== void 0 && !ut) {
            ut = !0;
            var fu = Q(_);
            T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", fu || "Unknown");
          }
          typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function rn(A) {
        {
          for (var _ = Object.keys(A.props), O = 0; O < _.length; O++) {
            var K = _[O];
            if (K !== "children" && K !== "key") {
              ae(A), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", K), ae(null);
              break;
            }
          }
          A.ref !== null && (ae(A), T("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
        }
      }
      function Zt(A, _, O, K, fu, Au) {
        {
          var Du = X(A);
          if (!Du) {
            var ru = "";
            (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (ru += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ku = un();
            ku ? ru += ku : ru += Wt();
            var yu;
            A === null ? yu = "null" : Array.isArray(A) ? yu = "array" : A !== void 0 && A.$$typeof === n ? (yu = "<" + (Q(A.type) || "Unknown") + " />", ru = " Did you accidentally export a JSX literal instead of a component?") : yu = typeof A, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", yu, ru);
          }
          var wu = Je(A, _, O, fu, Au);
          if (wu == null)
            return wu;
          if (Du) {
            var Vu = _.children;
            if (Vu !== void 0)
              if (K)
                if (Array.isArray(Vu)) {
                  for (var oe = 0; oe < Vu.length; oe++)
                    qt(Vu[oe], A);
                  Object.freeze && Object.freeze(Vu);
                } else
                  T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                qt(Vu, A);
          }
          return A === u.Fragment ? rn(wu) : tn(wu), wu;
        }
      }
      function nn(A, _, O) {
        return Zt(A, _, O, !0);
      }
      function Dn(A, _, O) {
        return Zt(A, _, O, !1);
      }
      var sn = Dn, an = nn;
      u.jsx = sn, u.jsxs = an;
    }();
  }(rt)), rt;
}
process.env.NODE_ENV === "production" ? Ct.exports = fn() : Ct.exports = hn();
var r = Ct.exports, dt = { exports: {} }, su = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var r0;
function mn() {
  if (r0) return su;
  r0 = 1;
  var u = Symbol.for("react.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), i = Symbol.for("react.context"), a = Symbol.for("react.server_context"), o = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function h(E) {
    if (typeof E == "object" && E !== null) {
      var w = E.$$typeof;
      switch (w) {
        case u:
          switch (E = E.type, E) {
            case t:
            case D:
            case n:
            case c:
            case g:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case a:
                case i:
                case o:
                case v:
                case m:
                case s:
                  return E;
                default:
                  return w;
              }
          }
        case e:
          return w;
      }
    }
  }
  return su.ContextConsumer = i, su.ContextProvider = s, su.Element = u, su.ForwardRef = o, su.Fragment = t, su.Lazy = v, su.Memo = m, su.Portal = e, su.Profiler = D, su.StrictMode = n, su.Suspense = c, su.SuspenseList = g, su.isAsyncMode = function() {
    return !1;
  }, su.isConcurrentMode = function() {
    return !1;
  }, su.isContextConsumer = function(E) {
    return h(E) === i;
  }, su.isContextProvider = function(E) {
    return h(E) === s;
  }, su.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === u;
  }, su.isForwardRef = function(E) {
    return h(E) === o;
  }, su.isFragment = function(E) {
    return h(E) === t;
  }, su.isLazy = function(E) {
    return h(E) === v;
  }, su.isMemo = function(E) {
    return h(E) === m;
  }, su.isPortal = function(E) {
    return h(E) === e;
  }, su.isProfiler = function(E) {
    return h(E) === D;
  }, su.isStrictMode = function(E) {
    return h(E) === n;
  }, su.isSuspense = function(E) {
    return h(E) === c;
  }, su.isSuspenseList = function(E) {
    return h(E) === g;
  }, su.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === t || E === D || E === n || E === c || E === g || E === l || typeof E == "object" && E !== null && (E.$$typeof === v || E.$$typeof === m || E.$$typeof === s || E.$$typeof === i || E.$$typeof === o || E.$$typeof === p || E.getModuleId !== void 0);
  }, su.typeOf = h, su;
}
var iu = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var n0;
function Bn() {
  return n0 || (n0 = 1, process.env.NODE_ENV !== "production" && function() {
    var u = !1, e = !1, t = !1, n = !1, D = !1, s = Symbol.for("react.element"), i = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), m = Symbol.for("react.context"), v = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), d;
    d = Symbol.for("react.module.reference");
    function f(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === a || N === c || D || N === o || N === p || N === h || n || N === C || u || e || t || typeof N == "object" && N !== null && (N.$$typeof === w || N.$$typeof === E || N.$$typeof === g || N.$$typeof === m || N.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === d || N.getModuleId !== void 0));
    }
    function B(N) {
      if (typeof N == "object" && N !== null) {
        var L = N.$$typeof;
        switch (L) {
          case s:
            var Cu = N.type;
            switch (Cu) {
              case a:
              case c:
              case o:
              case p:
              case h:
                return Cu;
              default:
                var eu = Cu && Cu.$$typeof;
                switch (eu) {
                  case v:
                  case m:
                  case l:
                  case w:
                  case E:
                  case g:
                    return eu;
                  default:
                    return L;
                }
            }
          case i:
            return L;
        }
      }
    }
    var j = m, I = g, T = s, q = l, V = a, X = w, G = E, J = i, Q = c, tu = o, Fu = p, lu = h, nu = !1, gu = !1;
    function xu(N) {
      return nu || (nu = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function vu(N) {
      return gu || (gu = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function R(N) {
      return B(N) === m;
    }
    function $(N) {
      return B(N) === g;
    }
    function P(N) {
      return typeof N == "object" && N !== null && N.$$typeof === s;
    }
    function W(N) {
      return B(N) === l;
    }
    function x(N) {
      return B(N) === a;
    }
    function Z(N) {
      return B(N) === w;
    }
    function S(N) {
      return B(N) === E;
    }
    function M(N) {
      return B(N) === i;
    }
    function z(N) {
      return B(N) === c;
    }
    function H(N) {
      return B(N) === o;
    }
    function y(N) {
      return B(N) === p;
    }
    function uu(N) {
      return B(N) === h;
    }
    iu.ContextConsumer = j, iu.ContextProvider = I, iu.Element = T, iu.ForwardRef = q, iu.Fragment = V, iu.Lazy = X, iu.Memo = G, iu.Portal = J, iu.Profiler = Q, iu.StrictMode = tu, iu.Suspense = Fu, iu.SuspenseList = lu, iu.isAsyncMode = xu, iu.isConcurrentMode = vu, iu.isContextConsumer = R, iu.isContextProvider = $, iu.isElement = P, iu.isForwardRef = W, iu.isFragment = x, iu.isLazy = Z, iu.isMemo = S, iu.isPortal = M, iu.isProfiler = z, iu.isStrictMode = H, iu.isSuspense = y, iu.isSuspenseList = uu, iu.isValidElementType = f, iu.typeOf = B;
  }()), iu;
}
process.env.NODE_ENV === "production" ? dt.exports = mn() : dt.exports = Bn();
var $t = dt.exports;
function gn(u) {
  function e(R, $, P, W, x) {
    for (var Z = 0, S = 0, M = 0, z = 0, H, y, uu = 0, N = 0, L, Cu = L = H = 0, eu = 0, mu = 0, Uu = 0, pu = 0, Iu = P.length, Hu = Iu - 1, Su, Y = "", du = "", Ju = "", Qu = "", $u; eu < Iu; ) {
      if (y = P.charCodeAt(eu), eu === Hu && S + z + M + Z !== 0 && (S !== 0 && (y = S === 47 ? 10 : 47), z = M = Z = 0, Iu++, Hu++), S + z + M + Z === 0) {
        if (eu === Hu && (0 < mu && (Y = Y.replace(v, "")), 0 < Y.trim().length)) {
          switch (y) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Y += P.charAt(eu);
          }
          y = 59;
        }
        switch (y) {
          case 123:
            for (Y = Y.trim(), H = Y.charCodeAt(0), L = 1, pu = ++eu; eu < Iu; ) {
              switch (y = P.charCodeAt(eu)) {
                case 123:
                  L++;
                  break;
                case 125:
                  L--;
                  break;
                case 47:
                  switch (y = P.charCodeAt(eu + 1)) {
                    case 42:
                    case 47:
                      u: {
                        for (Cu = eu + 1; Cu < Hu; ++Cu)
                          switch (P.charCodeAt(Cu)) {
                            case 47:
                              if (y === 42 && P.charCodeAt(Cu - 1) === 42 && eu + 2 !== Cu) {
                                eu = Cu + 1;
                                break u;
                              }
                              break;
                            case 10:
                              if (y === 47) {
                                eu = Cu + 1;
                                break u;
                              }
                          }
                        eu = Cu;
                      }
                  }
                  break;
                case 91:
                  y++;
                case 40:
                  y++;
                case 34:
                case 39:
                  for (; eu++ < Hu && P.charCodeAt(eu) !== y; )
                    ;
              }
              if (L === 0) break;
              eu++;
            }
            switch (L = P.substring(pu, eu), H === 0 && (H = (Y = Y.replace(m, "").trim()).charCodeAt(0)), H) {
              case 64:
                switch (0 < mu && (Y = Y.replace(v, "")), y = Y.charCodeAt(1), y) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    mu = $;
                    break;
                  default:
                    mu = Fu;
                }
                if (L = e($, mu, L, y, x + 1), pu = L.length, 0 < nu && (mu = t(Fu, Y, Uu), $u = a(3, L, mu, $, J, G, pu, y, x, W), Y = mu.join(""), $u !== void 0 && (pu = (L = $u.trim()).length) === 0 && (y = 0, L = "")), 0 < pu) switch (y) {
                  case 115:
                    Y = Y.replace(j, i);
                  case 100:
                  case 109:
                  case 45:
                    L = Y + "{" + L + "}";
                    break;
                  case 107:
                    Y = Y.replace(C, "$1 $2"), L = Y + "{" + L + "}", L = tu === 1 || tu === 2 && s("@" + L, 3) ? "@-webkit-" + L + "@" + L : "@" + L;
                    break;
                  default:
                    L = Y + L, W === 112 && (L = (du += L, ""));
                }
                else L = "";
                break;
              default:
                L = e($, t($, Y, Uu), L, W, x + 1);
            }
            Ju += L, L = Uu = mu = Cu = H = 0, Y = "", y = P.charCodeAt(++eu);
            break;
          case 125:
          case 59:
            if (Y = (0 < mu ? Y.replace(v, "") : Y).trim(), 1 < (pu = Y.length)) switch (Cu === 0 && (H = Y.charCodeAt(0), H === 45 || 96 < H && 123 > H) && (pu = (Y = Y.replace(" ", ":")).length), 0 < nu && ($u = a(1, Y, $, R, J, G, du.length, W, x, W)) !== void 0 && (pu = (Y = $u.trim()).length) === 0 && (Y = "\0\0"), H = Y.charCodeAt(0), y = Y.charCodeAt(1), H) {
              case 0:
                break;
              case 64:
                if (y === 105 || y === 99) {
                  Qu += Y + P.charAt(eu);
                  break;
                }
              default:
                Y.charCodeAt(pu - 1) !== 58 && (du += D(Y, H, y, Y.charCodeAt(2)));
            }
            Uu = mu = Cu = H = 0, Y = "", y = P.charCodeAt(++eu);
        }
      }
      switch (y) {
        case 13:
        case 10:
          S === 47 ? S = 0 : 1 + H === 0 && W !== 107 && 0 < Y.length && (mu = 1, Y += "\0"), 0 < nu * xu && a(0, Y, $, R, J, G, du.length, W, x, W), G = 1, J++;
          break;
        case 59:
        case 125:
          if (S + z + M + Z === 0) {
            G++;
            break;
          }
        default:
          switch (G++, Su = P.charAt(eu), y) {
            case 9:
            case 32:
              if (z + Z + S === 0) switch (uu) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Su = "";
                  break;
                default:
                  y !== 32 && (Su = " ");
              }
              break;
            case 0:
              Su = "\\0";
              break;
            case 12:
              Su = "\\f";
              break;
            case 11:
              Su = "\\v";
              break;
            case 38:
              z + S + Z === 0 && (mu = Uu = 1, Su = "\f" + Su);
              break;
            case 108:
              if (z + S + Z + Q === 0 && 0 < Cu) switch (eu - Cu) {
                case 2:
                  uu === 112 && P.charCodeAt(eu - 3) === 58 && (Q = uu);
                case 8:
                  N === 111 && (Q = N);
              }
              break;
            case 58:
              z + S + Z === 0 && (Cu = eu);
              break;
            case 44:
              S + M + z + Z === 0 && (mu = 1, Su += "\r");
              break;
            case 34:
            case 39:
              S === 0 && (z = z === y ? 0 : z === 0 ? y : z);
              break;
            case 91:
              z + S + M === 0 && Z++;
              break;
            case 93:
              z + S + M === 0 && Z--;
              break;
            case 41:
              z + S + Z === 0 && M--;
              break;
            case 40:
              if (z + S + Z === 0) {
                if (H === 0) switch (2 * uu + 3 * N) {
                  case 533:
                    break;
                  default:
                    H = 1;
                }
                M++;
              }
              break;
            case 64:
              S + M + z + Z + Cu + L === 0 && (L = 1);
              break;
            case 42:
            case 47:
              if (!(0 < z + Z + M)) switch (S) {
                case 0:
                  switch (2 * y + 3 * P.charCodeAt(eu + 1)) {
                    case 235:
                      S = 47;
                      break;
                    case 220:
                      pu = eu, S = 42;
                  }
                  break;
                case 42:
                  y === 47 && uu === 42 && pu + 2 !== eu && (P.charCodeAt(pu + 2) === 33 && (du += P.substring(pu, eu + 1)), Su = "", S = 0);
              }
          }
          S === 0 && (Y += Su);
      }
      N = uu, uu = y, eu++;
    }
    if (pu = du.length, 0 < pu) {
      if (mu = $, 0 < nu && ($u = a(2, du, mu, R, J, G, pu, W, x, W), $u !== void 0 && (du = $u).length === 0)) return Qu + du + Ju;
      if (du = mu.join(",") + "{" + du + "}", tu * Q !== 0) {
        switch (tu !== 2 || s(du, 2) || (Q = 0), Q) {
          case 111:
            du = du.replace(f, ":-moz-$1") + du;
            break;
          case 112:
            du = du.replace(d, "::-webkit-input-$1") + du.replace(d, "::-moz-$1") + du.replace(d, ":-ms-input-$1") + du;
        }
        Q = 0;
      }
    }
    return Qu + du + Ju;
  }
  function t(R, $, P) {
    var W = $.trim().split(E);
    $ = W;
    var x = W.length, Z = R.length;
    switch (Z) {
      case 0:
      case 1:
        var S = 0;
        for (R = Z === 0 ? "" : R[0] + " "; S < x; ++S)
          $[S] = n(R, $[S], P).trim();
        break;
      default:
        var M = S = 0;
        for ($ = []; S < x; ++S)
          for (var z = 0; z < Z; ++z)
            $[M++] = n(R[z] + " ", W[S], P).trim();
    }
    return $;
  }
  function n(R, $, P) {
    var W = $.charCodeAt(0);
    switch (33 > W && (W = ($ = $.trim()).charCodeAt(0)), W) {
      case 38:
        return $.replace(w, "$1" + R.trim());
      case 58:
        return R.trim() + $.replace(w, "$1" + R.trim());
      default:
        if (0 < 1 * P && 0 < $.indexOf("\f")) return $.replace(w, (R.charCodeAt(0) === 58 ? "" : "$1") + R.trim());
    }
    return R + $;
  }
  function D(R, $, P, W) {
    var x = R + ";", Z = 2 * $ + 3 * P + 4 * W;
    if (Z === 944) {
      R = x.indexOf(":", 9) + 1;
      var S = x.substring(R, x.length - 1).trim();
      return S = x.substring(0, R).trim() + S + ";", tu === 1 || tu === 2 && s(S, 1) ? "-webkit-" + S + S : S;
    }
    if (tu === 0 || tu === 2 && !s(x, 1)) return x;
    switch (Z) {
      case 1015:
        return x.charCodeAt(10) === 97 ? "-webkit-" + x + x : x;
      case 951:
        return x.charCodeAt(3) === 116 ? "-webkit-" + x + x : x;
      case 963:
        return x.charCodeAt(5) === 110 ? "-webkit-" + x + x : x;
      case 1009:
        if (x.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + x + x;
      case 978:
        return "-webkit-" + x + "-moz-" + x + x;
      case 1019:
      case 983:
        return "-webkit-" + x + "-moz-" + x + "-ms-" + x + x;
      case 883:
        if (x.charCodeAt(8) === 45) return "-webkit-" + x + x;
        if (0 < x.indexOf("image-set(", 11)) return x.replace(X, "$1-webkit-$2") + x;
        break;
      case 932:
        if (x.charCodeAt(4) === 45) switch (x.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + x.replace("-grow", "") + "-webkit-" + x + "-ms-" + x.replace("grow", "positive") + x;
          case 115:
            return "-webkit-" + x + "-ms-" + x.replace("shrink", "negative") + x;
          case 98:
            return "-webkit-" + x + "-ms-" + x.replace("basis", "preferred-size") + x;
        }
        return "-webkit-" + x + "-ms-" + x + x;
      case 964:
        return "-webkit-" + x + "-ms-flex-" + x + x;
      case 1023:
        if (x.charCodeAt(8) !== 99) break;
        return S = x.substring(x.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + S + "-webkit-" + x + "-ms-flex-pack" + S + x;
      case 1005:
        return p.test(x) ? x.replace(l, ":-webkit-") + x.replace(l, ":-moz-") + x : x;
      case 1e3:
        switch (S = x.substring(13).trim(), $ = S.indexOf("-") + 1, S.charCodeAt(0) + S.charCodeAt($)) {
          case 226:
            S = x.replace(B, "tb");
            break;
          case 232:
            S = x.replace(B, "tb-rl");
            break;
          case 220:
            S = x.replace(B, "lr");
            break;
          default:
            return x;
        }
        return "-webkit-" + x + "-ms-" + S + x;
      case 1017:
        if (x.indexOf("sticky", 9) === -1) break;
      case 975:
        switch ($ = (x = R).length - 10, S = (x.charCodeAt($) === 33 ? x.substring(0, $) : x).substring(R.indexOf(":", 7) + 1).trim(), Z = S.charCodeAt(0) + (S.charCodeAt(7) | 0)) {
          case 203:
            if (111 > S.charCodeAt(8)) break;
          case 115:
            x = x.replace(S, "-webkit-" + S) + ";" + x;
            break;
          case 207:
          case 102:
            x = x.replace(S, "-webkit-" + (102 < Z ? "inline-" : "") + "box") + ";" + x.replace(S, "-webkit-" + S) + ";" + x.replace(S, "-ms-" + S + "box") + ";" + x;
        }
        return x + ";";
      case 938:
        if (x.charCodeAt(5) === 45) switch (x.charCodeAt(6)) {
          case 105:
            return S = x.replace("-items", ""), "-webkit-" + x + "-webkit-box-" + S + "-ms-flex-" + S + x;
          case 115:
            return "-webkit-" + x + "-ms-flex-item-" + x.replace(T, "") + x;
          default:
            return "-webkit-" + x + "-ms-flex-line-pack" + x.replace("align-content", "").replace(T, "") + x;
        }
        break;
      case 973:
      case 989:
        if (x.charCodeAt(3) !== 45 || x.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (V.test(R) === !0) return (S = R.substring(R.indexOf(":") + 1)).charCodeAt(0) === 115 ? D(R.replace("stretch", "fill-available"), $, P, W).replace(":fill-available", ":stretch") : x.replace(S, "-webkit-" + S) + x.replace(S, "-moz-" + S.replace("fill-", "")) + x;
        break;
      case 962:
        if (x = "-webkit-" + x + (x.charCodeAt(5) === 102 ? "-ms-" + x : "") + x, P + W === 211 && x.charCodeAt(13) === 105 && 0 < x.indexOf("transform", 10)) return x.substring(0, x.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + x;
    }
    return x;
  }
  function s(R, $) {
    var P = R.indexOf($ === 1 ? ":" : "{"), W = R.substring(0, $ !== 3 ? P : 10);
    return P = R.substring(P + 1, R.length - 1), gu($ !== 2 ? W : W.replace(q, "$1"), P, $);
  }
  function i(R, $) {
    var P = D($, $.charCodeAt(0), $.charCodeAt(1), $.charCodeAt(2));
    return P !== $ + ";" ? P.replace(I, " or ($1)").substring(4) : "(" + $ + ")";
  }
  function a(R, $, P, W, x, Z, S, M, z, H) {
    for (var y = 0, uu = $, N; y < nu; ++y)
      switch (N = lu[y].call(g, R, uu, P, W, x, Z, S, M, z, H)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          uu = N;
      }
    if (uu !== $) return uu;
  }
  function o(R) {
    switch (R) {
      case void 0:
      case null:
        nu = lu.length = 0;
        break;
      default:
        if (typeof R == "function") lu[nu++] = R;
        else if (typeof R == "object") for (var $ = 0, P = R.length; $ < P; ++$)
          o(R[$]);
        else xu = !!R | 0;
    }
    return o;
  }
  function c(R) {
    return R = R.prefix, R !== void 0 && (gu = null, R ? typeof R != "function" ? tu = 1 : (tu = 2, gu = R) : tu = 0), c;
  }
  function g(R, $) {
    var P = R;
    if (33 > P.charCodeAt(0) && (P = P.trim()), vu = P, P = [vu], 0 < nu) {
      var W = a(-1, $, P, P, J, G, 0, 0, 0, 0);
      W !== void 0 && typeof W == "string" && ($ = W);
    }
    var x = e(Fu, P, $, 0, 0);
    return 0 < nu && (W = a(-2, x, P, P, J, G, x.length, 0, 0, 0), W !== void 0 && (x = W)), vu = "", Q = 0, G = J = 1, x;
  }
  var m = /^\0+/g, v = /[\0\r\f]/g, l = /: */g, p = /zoo|gra/, h = /([,: ])(transform)/g, E = /,\r+?/g, w = /([\t\r\n ])*\f?&/g, C = /@(k\w+)\s*(\S*)\s*/, d = /::(place)/g, f = /:(read-only)/g, B = /[svh]\w+-[tblr]{2}/, j = /\(\s*(.*)\s*\)/g, I = /([\s\S]*?);/g, T = /-self|flex-/g, q = /[^]*?(:[rp][el]a[\w-]+)[^]*/, V = /stretch|:\s*\w+\-(?:conte|avail)/, X = /([^-])(image-set\()/, G = 1, J = 1, Q = 0, tu = 1, Fu = [], lu = [], nu = 0, gu = null, xu = 0, vu = "";
  return g.use = o, g.set = c, u !== void 0 && c(u), g;
}
var xn = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function vn(u) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] === void 0 && (e[t] = u(t)), e[t];
  };
}
var yn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, D0 = /* @__PURE__ */ vn(
  function(u) {
    return yn.test(u) || u.charCodeAt(0) === 111 && u.charCodeAt(1) === 110 && u.charCodeAt(2) < 91;
  }
  /* Z+1 */
), At = { exports: {} }, au = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s0;
function wn() {
  if (s0) return au;
  s0 = 1;
  var u = typeof Symbol == "function" && Symbol.for, e = u ? Symbol.for("react.element") : 60103, t = u ? Symbol.for("react.portal") : 60106, n = u ? Symbol.for("react.fragment") : 60107, D = u ? Symbol.for("react.strict_mode") : 60108, s = u ? Symbol.for("react.profiler") : 60114, i = u ? Symbol.for("react.provider") : 60109, a = u ? Symbol.for("react.context") : 60110, o = u ? Symbol.for("react.async_mode") : 60111, c = u ? Symbol.for("react.concurrent_mode") : 60111, g = u ? Symbol.for("react.forward_ref") : 60112, m = u ? Symbol.for("react.suspense") : 60113, v = u ? Symbol.for("react.suspense_list") : 60120, l = u ? Symbol.for("react.memo") : 60115, p = u ? Symbol.for("react.lazy") : 60116, h = u ? Symbol.for("react.block") : 60121, E = u ? Symbol.for("react.fundamental") : 60117, w = u ? Symbol.for("react.responder") : 60118, C = u ? Symbol.for("react.scope") : 60119;
  function d(B) {
    if (typeof B == "object" && B !== null) {
      var j = B.$$typeof;
      switch (j) {
        case e:
          switch (B = B.type, B) {
            case o:
            case c:
            case n:
            case s:
            case D:
            case m:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case a:
                case g:
                case p:
                case l:
                case i:
                  return B;
                default:
                  return j;
              }
          }
        case t:
          return j;
      }
    }
  }
  function f(B) {
    return d(B) === c;
  }
  return au.AsyncMode = o, au.ConcurrentMode = c, au.ContextConsumer = a, au.ContextProvider = i, au.Element = e, au.ForwardRef = g, au.Fragment = n, au.Lazy = p, au.Memo = l, au.Portal = t, au.Profiler = s, au.StrictMode = D, au.Suspense = m, au.isAsyncMode = function(B) {
    return f(B) || d(B) === o;
  }, au.isConcurrentMode = f, au.isContextConsumer = function(B) {
    return d(B) === a;
  }, au.isContextProvider = function(B) {
    return d(B) === i;
  }, au.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === e;
  }, au.isForwardRef = function(B) {
    return d(B) === g;
  }, au.isFragment = function(B) {
    return d(B) === n;
  }, au.isLazy = function(B) {
    return d(B) === p;
  }, au.isMemo = function(B) {
    return d(B) === l;
  }, au.isPortal = function(B) {
    return d(B) === t;
  }, au.isProfiler = function(B) {
    return d(B) === s;
  }, au.isStrictMode = function(B) {
    return d(B) === D;
  }, au.isSuspense = function(B) {
    return d(B) === m;
  }, au.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === n || B === c || B === s || B === D || B === m || B === v || typeof B == "object" && B !== null && (B.$$typeof === p || B.$$typeof === l || B.$$typeof === i || B.$$typeof === a || B.$$typeof === g || B.$$typeof === E || B.$$typeof === w || B.$$typeof === C || B.$$typeof === h);
  }, au.typeOf = d, au;
}
var ou = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i0;
function bn() {
  return i0 || (i0 = 1, process.env.NODE_ENV !== "production" && function() {
    var u = typeof Symbol == "function" && Symbol.for, e = u ? Symbol.for("react.element") : 60103, t = u ? Symbol.for("react.portal") : 60106, n = u ? Symbol.for("react.fragment") : 60107, D = u ? Symbol.for("react.strict_mode") : 60108, s = u ? Symbol.for("react.profiler") : 60114, i = u ? Symbol.for("react.provider") : 60109, a = u ? Symbol.for("react.context") : 60110, o = u ? Symbol.for("react.async_mode") : 60111, c = u ? Symbol.for("react.concurrent_mode") : 60111, g = u ? Symbol.for("react.forward_ref") : 60112, m = u ? Symbol.for("react.suspense") : 60113, v = u ? Symbol.for("react.suspense_list") : 60120, l = u ? Symbol.for("react.memo") : 60115, p = u ? Symbol.for("react.lazy") : 60116, h = u ? Symbol.for("react.block") : 60121, E = u ? Symbol.for("react.fundamental") : 60117, w = u ? Symbol.for("react.responder") : 60118, C = u ? Symbol.for("react.scope") : 60119;
    function d(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === n || y === c || y === s || y === D || y === m || y === v || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === l || y.$$typeof === i || y.$$typeof === a || y.$$typeof === g || y.$$typeof === E || y.$$typeof === w || y.$$typeof === C || y.$$typeof === h);
    }
    function f(y) {
      if (typeof y == "object" && y !== null) {
        var uu = y.$$typeof;
        switch (uu) {
          case e:
            var N = y.type;
            switch (N) {
              case o:
              case c:
              case n:
              case s:
              case D:
              case m:
                return N;
              default:
                var L = N && N.$$typeof;
                switch (L) {
                  case a:
                  case g:
                  case p:
                  case l:
                  case i:
                    return L;
                  default:
                    return uu;
                }
            }
          case t:
            return uu;
        }
      }
    }
    var B = o, j = c, I = a, T = i, q = e, V = g, X = n, G = p, J = l, Q = t, tu = s, Fu = D, lu = m, nu = !1;
    function gu(y) {
      return nu || (nu = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), xu(y) || f(y) === o;
    }
    function xu(y) {
      return f(y) === c;
    }
    function vu(y) {
      return f(y) === a;
    }
    function R(y) {
      return f(y) === i;
    }
    function $(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function P(y) {
      return f(y) === g;
    }
    function W(y) {
      return f(y) === n;
    }
    function x(y) {
      return f(y) === p;
    }
    function Z(y) {
      return f(y) === l;
    }
    function S(y) {
      return f(y) === t;
    }
    function M(y) {
      return f(y) === s;
    }
    function z(y) {
      return f(y) === D;
    }
    function H(y) {
      return f(y) === m;
    }
    ou.AsyncMode = B, ou.ConcurrentMode = j, ou.ContextConsumer = I, ou.ContextProvider = T, ou.Element = q, ou.ForwardRef = V, ou.Fragment = X, ou.Lazy = G, ou.Memo = J, ou.Portal = Q, ou.Profiler = tu, ou.StrictMode = Fu, ou.Suspense = lu, ou.isAsyncMode = gu, ou.isConcurrentMode = xu, ou.isContextConsumer = vu, ou.isContextProvider = R, ou.isElement = $, ou.isForwardRef = P, ou.isFragment = W, ou.isLazy = x, ou.isMemo = Z, ou.isPortal = S, ou.isProfiler = M, ou.isStrictMode = z, ou.isSuspense = H, ou.isValidElementType = d, ou.typeOf = f;
  }()), ou;
}
process.env.NODE_ENV === "production" ? At.exports = wn() : At.exports = bn();
var jn = At.exports, kt = jn, Sn = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, _n = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Nn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, P0 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Tt = {};
Tt[kt.ForwardRef] = Nn;
Tt[kt.Memo] = P0;
function a0(u) {
  return kt.isMemo(u) ? P0 : Tt[u.$$typeof] || Sn;
}
var $n = Object.defineProperty, kn = Object.getOwnPropertyNames, o0 = Object.getOwnPropertySymbols, Tn = Object.getOwnPropertyDescriptor, Pn = Object.getPrototypeOf, l0 = Object.prototype;
function R0(u, e, t) {
  if (typeof e != "string") {
    if (l0) {
      var n = Pn(e);
      n && n !== l0 && R0(u, n, t);
    }
    var D = kn(e);
    o0 && (D = D.concat(o0(e)));
    for (var s = a0(u), i = a0(e), a = 0; a < D.length; ++a) {
      var o = D[a];
      if (!_n[o] && !(t && t[o]) && !(i && i[o]) && !(s && s[o])) {
        var c = Tn(e, o);
        try {
          $n(u, o, c);
        } catch (g) {
        }
      }
    }
  }
  return u;
}
var Rn = R0;
const In = /* @__PURE__ */ ne(Rn);
function qu() {
  return (qu = Object.assign || function(u) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (u[n] = t[n]);
    }
    return u;
  }).apply(this, arguments);
}
var c0 = function(u, e) {
  for (var t = [u[0]], n = 0, D = e.length; n < D; n += 1) t.push(e[n], u[n + 1]);
  return t;
}, pt = function(u) {
  return u !== null && typeof u == "object" && (u.toString ? u.toString() : Object.prototype.toString.call(u)) === "[object Object]" && !$t.typeOf(u);
}, He = Object.freeze([]), Xu = Object.freeze({});
function ye(u) {
  return typeof u == "function";
}
function ft(u) {
  return process.env.NODE_ENV !== "production" && typeof u == "string" && u || u.displayName || u.name || "Component";
}
function Pt(u) {
  return u && typeof u.styledComponentId == "string";
}
var de = typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Rt = typeof window != "undefined" && "HTMLElement" in window, On = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), Ln = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function Mn() {
  for (var u = arguments.length <= 0 ? void 0 : arguments[0], e = [], t = 1, n = arguments.length; t < n; t += 1) e.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
  return e.forEach(function(D) {
    u = u.replace(/%[a-z]/, D);
  }), u;
}
function fe(u) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) t[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + u + " for more information." + (t.length > 0 ? " Args: " + t.join(", ") : "")) : new Error(Mn.apply(void 0, [Ln[u]].concat(t)).trim());
}
var zn = function() {
  function u(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  var e = u.prototype;
  return e.indexOfGroup = function(t) {
    for (var n = 0, D = 0; D < t; D++) n += this.groupSizes[D];
    return n;
  }, e.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var D = this.groupSizes, s = D.length, i = s; t >= i; ) (i <<= 1) < 0 && fe(16, "" + t);
      this.groupSizes = new Uint32Array(i), this.groupSizes.set(D), this.length = i;
      for (var a = s; a < i; a++) this.groupSizes[a] = 0;
    }
    for (var o = this.indexOfGroup(t + 1), c = 0, g = n.length; c < g; c++) this.tag.insertRule(o, n[c]) && (this.groupSizes[t]++, o++);
  }, e.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], D = this.indexOfGroup(t), s = D + n;
      this.groupSizes[t] = 0;
      for (var i = D; i < s; i++) this.tag.deleteRule(D);
    }
  }, e.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0) return n;
    for (var D = this.groupSizes[t], s = this.indexOfGroup(t), i = s + D, a = s; a < i; a++) n += this.tag.getRule(a) + `/*!sc*/
`;
    return n;
  }, u;
}(), Ue = /* @__PURE__ */ new Map(), Ve = /* @__PURE__ */ new Map(), ve = 1, Te = function(u) {
  if (Ue.has(u)) return Ue.get(u);
  for (; Ve.has(ve); ) ve++;
  var e = ve++;
  return process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > 1 << 30) && fe(16, "" + e), Ue.set(u, e), Ve.set(e, u), e;
}, Un = function(u) {
  return Ve.get(u);
}, Hn = function(u, e) {
  e >= ve && (ve = e + 1), Ue.set(u, e), Ve.set(e, u);
}, Vn = "style[" + de + '][data-styled-version="5.3.11"]', Wn = new RegExp("^" + de + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Gn = function(u, e, t) {
  for (var n, D = t.split(","), s = 0, i = D.length; s < i; s++) (n = D[s]) && u.registerName(e, n);
}, Yn = function(u, e) {
  for (var t = (e.textContent || "").split(`/*!sc*/
`), n = [], D = 0, s = t.length; D < s; D++) {
    var i = t[D].trim();
    if (i) {
      var a = i.match(Wn);
      if (a) {
        var o = 0 | parseInt(a[1], 10), c = a[2];
        o !== 0 && (Hn(c, o), Gn(u, c, a[3]), u.getTag().insertRules(o, n)), n.length = 0;
      } else n.push(i);
    }
  }
}, qn = function() {
  return typeof __webpack_nonce__ != "undefined" ? __webpack_nonce__ : null;
}, I0 = function(u) {
  var e = document.head, t = u || e, n = document.createElement("style"), D = function(a) {
    for (var o = a.childNodes, c = o.length; c >= 0; c--) {
      var g = o[c];
      if (g && g.nodeType === 1 && g.hasAttribute(de)) return g;
    }
  }(t), s = D !== void 0 ? D.nextSibling : null;
  n.setAttribute(de, "active"), n.setAttribute("data-styled-version", "5.3.11");
  var i = qn();
  return i && n.setAttribute("nonce", i), t.insertBefore(n, s), n;
}, Zn = function() {
  function u(t) {
    var n = this.element = I0(t);
    n.appendChild(document.createTextNode("")), this.sheet = function(D) {
      if (D.sheet) return D.sheet;
      for (var s = document.styleSheets, i = 0, a = s.length; i < a; i++) {
        var o = s[i];
        if (o.ownerNode === D) return o;
      }
      fe(17);
    }(n), this.length = 0;
  }
  var e = u.prototype;
  return e.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch (D) {
      return !1;
    }
  }, e.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
  }, u;
}(), Kn = function() {
  function u(t) {
    var n = this.element = I0(t);
    this.nodes = n.childNodes, this.length = 0;
  }
  var e = u.prototype;
  return e.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var D = document.createTextNode(n), s = this.nodes[t];
      return this.element.insertBefore(D, s || null), this.length++, !0;
    }
    return !1;
  }, e.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, u;
}(), Xn = function() {
  function u(t) {
    this.rules = [], this.length = 0;
  }
  var e = u.prototype;
  return e.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, u;
}(), F0 = Rt, Jn = { isServer: !Rt, useCSSOMInjection: !On }, O0 = function() {
  function u(t, n, D) {
    t === void 0 && (t = Xu), n === void 0 && (n = {}), this.options = qu({}, Jn, {}, t), this.gs = n, this.names = new Map(D), this.server = !!t.isServer, !this.server && Rt && F0 && (F0 = !1, function(s) {
      for (var i = document.querySelectorAll(Vn), a = 0, o = i.length; a < o; a++) {
        var c = i[a];
        c && c.getAttribute(de) !== "active" && (Yn(s, c), c.parentNode && c.parentNode.removeChild(c));
      }
    }(this));
  }
  u.registerId = function(t) {
    return Te(t);
  };
  var e = u.prototype;
  return e.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new u(qu({}, this.options, {}, t), this.gs, n && this.names || void 0);
  }, e.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.getTag = function() {
    return this.tag || (this.tag = (D = (n = this.options).isServer, s = n.useCSSOMInjection, i = n.target, t = D ? new Xn(i) : s ? new Zn(i) : new Kn(i), new zn(t)));
    var t, n, D, s, i;
  }, e.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.registerName = function(t, n) {
    if (Te(t), this.names.has(t)) this.names.get(t).add(n);
    else {
      var D = /* @__PURE__ */ new Set();
      D.add(n), this.names.set(t, D);
    }
  }, e.insertRules = function(t, n, D) {
    this.registerName(t, n), this.getTag().insertRules(Te(t), D);
  }, e.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.clearRules = function(t) {
    this.getTag().clearGroup(Te(t)), this.clearNames(t);
  }, e.clearTag = function() {
    this.tag = void 0;
  }, e.toString = function() {
    return function(t) {
      for (var n = t.getTag(), D = n.length, s = "", i = 0; i < D; i++) {
        var a = Un(i);
        if (a !== void 0) {
          var o = t.names.get(a), c = n.getGroup(i);
          if (o && c && o.size) {
            var g = de + ".g" + i + '[id="' + a + '"]', m = "";
            o !== void 0 && o.forEach(function(v) {
              v.length > 0 && (m += v + ",");
            }), s += "" + c + g + '{content:"' + m + `"}/*!sc*/
`;
          }
        }
      }
      return s;
    }(this);
  }, u;
}(), Qn = /(a)(d)/gi, E0 = function(u) {
  return String.fromCharCode(u + (u > 25 ? 39 : 97));
};
function ht(u) {
  var e, t = "";
  for (e = Math.abs(u); e > 52; e = e / 52 | 0) t = E0(e % 52) + t;
  return (E0(e % 52) + t).replace(Qn, "$1-$2");
}
var ee = function(u, e) {
  for (var t = e.length; t; ) u = 33 * u ^ e.charCodeAt(--t);
  return u;
}, L0 = function(u) {
  return ee(5381, u);
};
function uD(u) {
  for (var e = 0; e < u.length; e += 1) {
    var t = u[e];
    if (ye(t) && !Pt(t)) return !1;
  }
  return !0;
}
var eD = L0("5.3.11"), tD = function() {
  function u(e, t, n) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && uD(e), this.componentId = t, this.baseHash = ee(eD, t), this.baseStyle = n, O0.registerId(t);
  }
  return u.prototype.generateAndInjectStyles = function(e, t, n) {
    var D = this.componentId, s = [];
    if (this.baseStyle && s.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) if (this.staticRulesId && t.hasNameForId(D, this.staticRulesId)) s.push(this.staticRulesId);
    else {
      var i = Ae(this.rules, e, t, n).join(""), a = ht(ee(this.baseHash, i) >>> 0);
      if (!t.hasNameForId(D, a)) {
        var o = n(i, "." + a, void 0, D);
        t.insertRules(D, a, o);
      }
      s.push(a), this.staticRulesId = a;
    }
    else {
      for (var c = this.rules.length, g = ee(this.baseHash, n.hash), m = "", v = 0; v < c; v++) {
        var l = this.rules[v];
        if (typeof l == "string") m += l, process.env.NODE_ENV !== "production" && (g = ee(g, l + v));
        else if (l) {
          var p = Ae(l, e, t, n), h = Array.isArray(p) ? p.join("") : p;
          g = ee(g, h + v), m += h;
        }
      }
      if (m) {
        var E = ht(g >>> 0);
        if (!t.hasNameForId(D, E)) {
          var w = n(m, "." + E, void 0, D);
          t.insertRules(D, E, w);
        }
        s.push(E);
      }
    }
    return s.join(" ");
  }, u;
}(), rD = /^\s*\/\/.*$/gm, nD = [":", "[", ".", "#"];
function DD(u) {
  var e, t, n, D, s = Xu, i = s.options, a = i === void 0 ? Xu : i, o = s.plugins, c = o === void 0 ? He : o, g = new gn(a), m = [], v = /* @__PURE__ */ function(h) {
    function E(w) {
      if (w) try {
        h(w + "}");
      } catch (C) {
      }
    }
    return function(w, C, d, f, B, j, I, T, q, V) {
      switch (w) {
        case 1:
          if (q === 0 && C.charCodeAt(0) === 64) return h(C + ";"), "";
          break;
        case 2:
          if (T === 0) return C + "/*|*/";
          break;
        case 3:
          switch (T) {
            case 102:
            case 112:
              return h(d[0] + C), "";
            default:
              return C + (V === 0 ? "/*|*/" : "");
          }
        case -2:
          C.split("/*|*/}").forEach(E);
      }
    };
  }(function(h) {
    m.push(h);
  }), l = function(h, E, w) {
    return E === 0 && nD.indexOf(w[t.length]) !== -1 || w.match(D) ? h : "." + e;
  };
  function p(h, E, w, C) {
    C === void 0 && (C = "&");
    var d = h.replace(rD, ""), f = E && w ? w + " " + E + " { " + d + " }" : d;
    return e = C, t = E, n = new RegExp("\\" + t + "\\b", "g"), D = new RegExp("(\\" + t + "\\b){2,}"), g(w || !E ? "" : E, f);
  }
  return g.use([].concat(c, [function(h, E, w) {
    h === 2 && w.length && w[0].lastIndexOf(t) > 0 && (w[0] = w[0].replace(n, l));
  }, v, function(h) {
    if (h === -2) {
      var E = m;
      return m = [], E;
    }
  }])), p.hash = c.length ? c.reduce(function(h, E) {
    return E.name || fe(15), ee(h, E.name);
  }, 5381).toString() : "", p;
}
var M0 = Eu.createContext();
M0.Consumer;
var z0 = Eu.createContext(), sD = (z0.Consumer, new O0()), mt = DD();
function iD() {
  return Ke(M0) || sD;
}
function aD() {
  return Ke(z0) || mt;
}
var oD = function() {
  function u(e, t) {
    var n = this;
    this.inject = function(D, s) {
      s === void 0 && (s = mt);
      var i = n.name + s.hash;
      D.hasNameForId(n.id, i) || D.insertRules(n.id, i, s(n.rules, i, "@keyframes"));
    }, this.toString = function() {
      return fe(12, String(n.name));
    }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
  }
  return u.prototype.getName = function(e) {
    return e === void 0 && (e = mt), this.name + e.hash;
  }, u;
}(), lD = /([A-Z])/, cD = /([A-Z])/g, FD = /^ms-/, ED = function(u) {
  return "-" + u.toLowerCase();
};
function C0(u) {
  return lD.test(u) ? u.replace(cD, ED).replace(FD, "-ms-") : u;
}
var d0 = function(u) {
  return u == null || u === !1 || u === "";
};
function Ae(u, e, t, n) {
  if (Array.isArray(u)) {
    for (var D, s = [], i = 0, a = u.length; i < a; i += 1) (D = Ae(u[i], e, t, n)) !== "" && (Array.isArray(D) ? s.push.apply(s, D) : s.push(D));
    return s;
  }
  if (d0(u)) return "";
  if (Pt(u)) return "." + u.styledComponentId;
  if (ye(u)) {
    if (typeof (c = u) != "function" || c.prototype && c.prototype.isReactComponent || !e) return u;
    var o = u(e);
    return process.env.NODE_ENV !== "production" && $t.isElement(o) && console.warn(ft(u) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Ae(o, e, t, n);
  }
  var c;
  return u instanceof oD ? t ? (u.inject(t, n), u.getName(n)) : u : pt(u) ? function g(m, v) {
    var l, p, h = [];
    for (var E in m) m.hasOwnProperty(E) && !d0(m[E]) && (Array.isArray(m[E]) && m[E].isCss || ye(m[E]) ? h.push(C0(E) + ":", m[E], ";") : pt(m[E]) ? h.push.apply(h, g(m[E], E)) : h.push(C0(E) + ": " + (l = E, (p = m[E]) == null || typeof p == "boolean" || p === "" ? "" : typeof p != "number" || p === 0 || l in xn || l.startsWith("--") ? String(p).trim() : p + "px") + ";"));
    return v ? [v + " {"].concat(h, ["}"]) : h;
  }(u) : u.toString();
}
var A0 = function(u) {
  return Array.isArray(u) && (u.isCss = !0), u;
};
function U0(u) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) t[n - 1] = arguments[n];
  return ye(u) || pt(u) ? A0(Ae(c0(He, [u].concat(t)))) : t.length === 0 && u.length === 1 && typeof u[0] == "string" ? u : A0(Ae(c0(u, t)));
}
var p0 = /invalid hook call/i, Pe = /* @__PURE__ */ new Set(), CD = function(u, e) {
  if (process.env.NODE_ENV !== "production") {
    var t = "The component " + u + (e ? ' with the id of "' + e + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, n = console.error;
    try {
      var D = !0;
      console.error = function(s) {
        if (p0.test(s)) D = !1, Pe.delete(t);
        else {
          for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) a[o - 1] = arguments[o];
          n.apply(void 0, [s].concat(a));
        }
      }, je(), D && !Pe.has(t) && (console.warn(t), Pe.add(t));
    } catch (s) {
      p0.test(s.message) && Pe.delete(t);
    } finally {
      console.error = n;
    }
  }
}, dD = function(u, e, t) {
  return t === void 0 && (t = Xu), u.theme !== t.theme && u.theme || e || t.theme;
}, AD = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, pD = /(^-|-$)/g;
function nt(u) {
  return u.replace(AD, "-").replace(pD, "");
}
var fD = function(u) {
  return ht(L0(u) >>> 0);
};
function Re(u) {
  return typeof u == "string" && (process.env.NODE_ENV === "production" || u.charAt(0) === u.charAt(0).toLowerCase());
}
var Bt = function(u) {
  return typeof u == "function" || typeof u == "object" && u !== null && !Array.isArray(u);
}, hD = function(u) {
  return u !== "__proto__" && u !== "constructor" && u !== "prototype";
};
function mD(u, e, t) {
  var n = u[t];
  Bt(e) && Bt(n) ? H0(n, e) : u[t] = e;
}
function H0(u) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) t[n - 1] = arguments[n];
  for (var D = 0, s = t; D < s.length; D++) {
    var i = s[D];
    if (Bt(i)) for (var a in i) hD(a) && mD(u, i[a], a);
  }
  return u;
}
var V0 = Eu.createContext();
V0.Consumer;
var Dt = {};
function W0(u, e, t) {
  var n = Pt(u), D = !Re(u), s = e.attrs, i = s === void 0 ? He : s, a = e.componentId, o = a === void 0 ? function(C, d) {
    var f = typeof C != "string" ? "sc" : nt(C);
    Dt[f] = (Dt[f] || 0) + 1;
    var B = f + "-" + fD("5.3.11" + f + Dt[f]);
    return d ? d + "-" + B : B;
  }(e.displayName, e.parentComponentId) : a, c = e.displayName, g = c === void 0 ? function(C) {
    return Re(C) ? "styled." + C : "Styled(" + ft(C) + ")";
  }(u) : c, m = e.displayName && e.componentId ? nt(e.displayName) + "-" + e.componentId : e.componentId || o, v = n && u.attrs ? Array.prototype.concat(u.attrs, i).filter(Boolean) : i, l = e.shouldForwardProp;
  n && u.shouldForwardProp && (l = e.shouldForwardProp ? function(C, d, f) {
    return u.shouldForwardProp(C, d, f) && e.shouldForwardProp(C, d, f);
  } : u.shouldForwardProp);
  var p, h = new tD(t, m, n ? u.componentStyle : void 0), E = h.isStatic && i.length === 0, w = function(C, d) {
    return function(f, B, j, I) {
      var T = f.attrs, q = f.componentStyle, V = f.defaultProps, X = f.foldedComponentIds, G = f.shouldForwardProp, J = f.styledComponentId, Q = f.target, tu = function(W, x, Z) {
        W === void 0 && (W = Xu);
        var S = qu({}, x, { theme: W }), M = {};
        return Z.forEach(function(z) {
          var H, y, uu, N = z;
          for (H in ye(N) && (N = N(S)), N) S[H] = M[H] = H === "className" ? (y = M[H], uu = N[H], y && uu ? y + " " + uu : y || uu) : N[H];
        }), [S, M];
      }(dD(B, Ke(V0), V) || Xu, B, T), Fu = tu[0], lu = tu[1], nu = function(W, x, Z, S) {
        var M = iD(), z = aD(), H = x ? W.generateAndInjectStyles(Xu, M, z) : W.generateAndInjectStyles(Z, M, z);
        return process.env.NODE_ENV !== "production" && !x && S && S(H), H;
      }(q, I, Fu, process.env.NODE_ENV !== "production" ? f.warnTooManyClasses : void 0), gu = j, xu = lu.$as || B.$as || lu.as || B.as || Q, vu = Re(xu), R = lu !== B ? qu({}, B, {}, lu) : B, $ = {};
      for (var P in R) P[0] !== "$" && P !== "as" && (P === "forwardedAs" ? $.as = R[P] : (G ? G(P, D0, xu) : !vu || D0(P)) && ($[P] = R[P]));
      return B.style && lu.style !== B.style && ($.style = qu({}, B.style, {}, lu.style)), $.className = Array.prototype.concat(X, J, nu !== J ? nu : null, B.className, lu.className).filter(Boolean).join(" "), $.ref = gu, Fn(xu, $);
    }(p, C, d, E);
  };
  return w.displayName = g, (p = Eu.forwardRef(w)).attrs = v, p.componentStyle = h, p.displayName = g, p.shouldForwardProp = l, p.foldedComponentIds = n ? Array.prototype.concat(u.foldedComponentIds, u.styledComponentId) : He, p.styledComponentId = m, p.target = n ? u.target : u, p.withComponent = function(C) {
    var d = e.componentId, f = function(j, I) {
      if (j == null) return {};
      var T, q, V = {}, X = Object.keys(j);
      for (q = 0; q < X.length; q++) T = X[q], I.indexOf(T) >= 0 || (V[T] = j[T]);
      return V;
    }(e, ["componentId"]), B = d && d + "-" + (Re(C) ? C : nt(ft(C)));
    return W0(C, qu({}, f, { attrs: v, componentId: B }), t);
  }, Object.defineProperty(p, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(C) {
    this._foldedDefaultProps = n ? H0({}, u.defaultProps, C) : C;
  } }), process.env.NODE_ENV !== "production" && (CD(g, m), p.warnTooManyClasses = /* @__PURE__ */ function(C, d) {
    var f = {}, B = !1;
    return function(j) {
      if (!B && (f[j] = !0, Object.keys(f).length >= 200)) {
        var I = d ? ' with the id of "' + d + '"' : "";
        console.warn("Over 200 classes were generated for component " + C + I + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), B = !0, f = {};
      }
    };
  }(g, m)), Object.defineProperty(p, "toString", { value: function() {
    return "." + p.styledComponentId;
  } }), D && In(p, u, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), p;
}
var we = function(u) {
  return function e(t, n, D) {
    if (D === void 0 && (D = Xu), !$t.isValidElementType(n)) return fe(1, String(n));
    var s = function() {
      return t(n, D, U0.apply(void 0, arguments));
    };
    return s.withConfig = function(i) {
      return e(t, n, qu({}, D, {}, i));
    }, s.attrs = function(i) {
      return e(t, n, qu({}, D, { attrs: Array.prototype.concat(D.attrs, i).filter(Boolean) }));
    }, s;
  }(W0, u);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(u) {
  we[u] = we(u);
});
process.env.NODE_ENV !== "production" && typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window != "undefined" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
let G0 = we;
!typeof we.div === "function" && (G0 = we.default);
const b = G0, te = b.div`
  font-family: Helvetica Neue;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.025em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;
          letter-spacing: -0.04em;
          `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 18px;
          white-space: pre-line;
        `;
  }
}};
`;
function BD(u, e = []) {
  let t = [];
  function n(s, i) {
    const a = F.createContext(i), o = t.length;
    t = [...t, i];
    function c(m) {
      const w = m, { scope: v, children: l } = w, p = Pu(w, ["scope", "children"]), h = (v == null ? void 0 : v[u][o]) || a, E = F.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ r.jsx(h.Provider, { value: E, children: l });
    }
    function g(m, v) {
      const l = (v == null ? void 0 : v[u][o]) || a, p = F.useContext(l);
      if (p) return p;
      if (i !== void 0) return i;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return c.displayName = s + "Provider", [c, g];
  }
  const D = () => {
    const s = t.map((i) => F.createContext(i));
    return function(a) {
      const o = (a == null ? void 0 : a[u]) || s;
      return F.useMemo(
        () => ({ [`__scope${u}`]: _u(U({}, a), { [u]: o }) }),
        [a, o]
      );
    };
  };
  return D.scopeName = u, [n, gD(D, ...e)];
}
function gD(...u) {
  const e = u[0];
  if (u.length === 1) return e;
  const t = () => {
    const n = u.map((D) => ({
      useScope: D(),
      scopeName: D.scopeName
    }));
    return function(s) {
      const i = n.reduce((a, { useScope: o, scopeName: c }) => {
        const m = o(s)[`__scope${c}`];
        return U(U({}, a), m);
      }, {});
      return F.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = e.scopeName, t;
}
function xD(u) {
  const e = F.useRef(u);
  return F.useEffect(() => {
    e.current = u;
  }), F.useMemo(() => (...t) => {
    var n;
    return (n = e.current) == null ? void 0 : n.call(e, ...t);
  }, []);
}
var Y0 = globalThis != null && globalThis.document ? F.useLayoutEffect : () => {
};
function vD(u, e) {
  typeof u == "function" ? u(e) : u != null && (u.current = e);
}
function yD(...u) {
  return (e) => u.forEach((t) => vD(t, e));
}
var q0 = F.forwardRef((u, e) => {
  const i = u, { children: t } = i, n = Pu(i, ["children"]), D = F.Children.toArray(t), s = D.find(bD);
  if (s) {
    const a = s.props.children, o = D.map((c) => c === s ? F.Children.count(a) > 1 ? F.Children.only(null) : F.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ r.jsx(gt, _u(U({}, n), { ref: e, children: F.isValidElement(a) ? F.cloneElement(a, void 0, o) : null }));
  }
  return /* @__PURE__ */ r.jsx(gt, _u(U({}, n), { ref: e, children: t }));
});
q0.displayName = "Slot";
var gt = F.forwardRef((u, e) => {
  const D = u, { children: t } = D, n = Pu(D, ["children"]);
  if (F.isValidElement(t)) {
    const s = SD(t);
    return F.cloneElement(t, _u(U({}, jD(n, t.props)), {
      // @ts-ignore
      ref: e ? yD(e, s) : s
    }));
  }
  return F.Children.count(t) > 1 ? F.Children.only(null) : null;
});
gt.displayName = "SlotClone";
var wD = ({ children: u }) => /* @__PURE__ */ r.jsx(r.Fragment, { children: u });
function bD(u) {
  return F.isValidElement(u) && u.type === wD;
}
function jD(u, e) {
  const t = U({}, e);
  for (const n in e) {
    const D = u[n], s = e[n];
    /^on[A-Z]/.test(n) ? D && s ? t[n] = (...a) => {
      s(...a), D(...a);
    } : D && (t[n] = D) : n === "style" ? t[n] = U(U({}, D), s) : n === "className" && (t[n] = [D, s].filter(Boolean).join(" "));
  }
  return U(U({}, u), t);
}
function SD(u) {
  var n, D;
  let e = (n = Object.getOwnPropertyDescriptor(u.props, "ref")) == null ? void 0 : n.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? u.ref : (e = (D = Object.getOwnPropertyDescriptor(u, "ref")) == null ? void 0 : D.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? u.props.ref : u.props.ref || u.ref);
}
var _D = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], It = _D.reduce((u, e) => {
  const t = F.forwardRef((n, D) => {
    const o = n, { asChild: s } = o, i = Pu(o, ["asChild"]), a = s ? q0 : e;
    return typeof window != "undefined" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ r.jsx(a, _u(U({}, i), { ref: D }));
  });
  return t.displayName = `Primitive.${e}`, _u(U({}, u), { [e]: t });
}, {}), Ot = "Avatar", [ND, yl] = BD(Ot), [$D, Z0] = ND(Ot), K0 = F.forwardRef(
  (u, e) => {
    const i = u, { __scopeAvatar: t } = i, n = Pu(i, ["__scopeAvatar"]), [D, s] = F.useState("idle");
    return /* @__PURE__ */ r.jsx(
      $D,
      {
        scope: t,
        imageLoadingStatus: D,
        onImageLoadingStatusChange: s,
        children: /* @__PURE__ */ r.jsx(It.span, _u(U({}, n), { ref: e }))
      }
    );
  }
);
K0.displayName = Ot;
var X0 = "AvatarImage", J0 = F.forwardRef(
  (u, e) => {
    const c = u, { __scopeAvatar: t, src: n, onLoadingStatusChange: D = () => {
    } } = c, s = Pu(c, ["__scopeAvatar", "src", "onLoadingStatusChange"]), i = Z0(X0, t), a = kD(n), o = xD((g) => {
      D(g), i.onImageLoadingStatusChange(g);
    });
    return Y0(() => {
      a !== "idle" && o(a);
    }, [a, o]), a === "loaded" ? /* @__PURE__ */ r.jsx(It.img, _u(U({}, s), { ref: e, src: n })) : null;
  }
);
J0.displayName = X0;
var Q0 = "AvatarFallback", ur = F.forwardRef(
  (u, e) => {
    const o = u, { __scopeAvatar: t, delayMs: n } = o, D = Pu(o, ["__scopeAvatar", "delayMs"]), s = Z0(Q0, t), [i, a] = F.useState(n === void 0);
    return F.useEffect(() => {
      if (n !== void 0) {
        const c = window.setTimeout(() => a(!0), n);
        return () => window.clearTimeout(c);
      }
    }, [n]), i && s.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ r.jsx(It.span, _u(U({}, D), { ref: e })) : null;
  }
);
ur.displayName = Q0;
function kD(u) {
  const [e, t] = F.useState("idle");
  return Y0(() => {
    if (!u) {
      t("error");
      return;
    }
    let n = !0;
    const D = new window.Image(), s = (i) => () => {
      n && t(i);
    };
    return t("loading"), D.onload = s("loaded"), D.onerror = s("error"), D.src = u, () => {
      n = !1;
    };
  }, [u]), e;
}
var TD = K0, PD = J0, RD = ur;
const ID = b(TD)`
  display: grid;
  place-content: center;
  height: 100%;

  img {
    width: 100%;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
  }
`, zu = (n) => {
  var D = n, {
    src: u,
    alt: e
  } = D, t = Pu(D, [
    "src",
    "alt"
  ]);
  const s = e.substring(0, 2).toUpperCase();
  return /* @__PURE__ */ r.jsxs(ID, _u(U({}, t), { children: [
    /* @__PURE__ */ r.jsx(PD, { src: u, alt: e }),
    /* @__PURE__ */ r.jsx(RD, { children: s })
  ] }));
}, er = ({
  username: u,
  profilePicture: e,
  locationName: t,
  small: n,
  collabs: D
}) => {
  if (Array.isArray(D) && D.length > 1) {
    let i = UD(D);
    return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center", children: /* @__PURE__ */ r.jsxs(zD, { children: [
      /* @__PURE__ */ r.jsxs(OD, { children: [
        /* @__PURE__ */ r.jsx(LD, { src: D[1].profilePictureUrl, alt: u }),
        /* @__PURE__ */ r.jsx(MD, { src: D[0].profilePictureUrl, alt: u })
      ] }),
      " ",
      i
    ] }) });
  }
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
      width: "35px",
      height: "35px"
    }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`, children: [
      /* @__PURE__ */ r.jsx(te, { $variant: "heading", children: u }),
      t && /* @__PURE__ */ r.jsx(te, { $variant: "subheading", children: t })
    ] })
  ] });
}, OD = b.div`
  overflow: hidden;
  margin-left: 10px;
  margin-right: 4px;
  width: 38px;
  height: 38px;
`, tr = b(zu)`
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
`, LD = b(tr)`
  left: 12px;

  > img {
    max-width: 24px;
    max-height: 24px;
  }
`, MD = b(tr)`
  top: -14px;
  > img {
    max-width: 24px;
    max-height: 24px;
    border: 1px solid white;
  }
`, zD = b.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
`, f0 = b.span`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
function UD(u) {
  return u.length < 2 ? null : u.length === 2 ? /* @__PURE__ */ r.jsx(f0, { children: `${u[0].username} and ${u[1].username}` }) : /* @__PURE__ */ r.jsx(f0, { children: `${u[0].username} and ${u.length - 1} others` });
}
const HD = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 20, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M15.2622 5.61017C15.2411 5.20965 14.9038 4.87236 14.4822 4.87236H11.9526V4.15563C11.9526 1.96327 10.2451 0.0871172 8.0527 0.0027957C5.75494 -0.0815258 3.85771 1.75247 3.85771 4.02915V4.87236H1.30698C1.11726 4.87236 0.927536 4.95668 0.779974 5.08316C0.611331 5.23073 0.527009 5.44153 0.527009 5.63125L0 18.6589C0 18.8697 0.0843216 19.0594 0.231884 19.207C0.379447 19.3546 0.56917 19.4389 0.779974 19.4389H15.22C15.4308 19.4389 15.6206 19.3546 15.7681 19.207C15.9157 19.0594 16 18.8486 16 18.6168L15.2622 5.61017ZM8.11594 1.56274C9.40184 1.68922 10.3505 2.80648 10.3505 4.11347V4.85128H5.43874V4.02915C5.41765 2.5746 6.6614 1.41518 8.11594 1.56274Z", fill: "white" })), VD = (u) => /* @__PURE__ */ F.createElement("svg", U({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 108.56 122.88", style: {
  enableBackground: "new 0 0 108.56 122.88"
}, xmlSpace: "preserve", fill: "#fff" }, u), /* @__PURE__ */ F.createElement("g", null, /* @__PURE__ */ F.createElement("path", { d: "M30.47,16.05h12.47l-6.35-7.16c-1.96-2.21-1.75-5.59,0.46-7.55c2.21-1.96,5.59-1.75,7.55,0.46l9.11,10.27L62.81,1.8 c1.96-2.21,5.34-2.42,7.55-0.46c2.21,1.96,2.42,5.34,0.46,7.55l-6.35,7.16h13.62c8.4,0,16.04,3.43,21.57,8.96 c5.49,5.49,8.9,13.05,8.9,21.35v46.21c0,8.3-3.41,15.86-8.9,21.35c-5.53,5.53-13.16,8.96-21.57,8.96H30.47 c-8.4,0-16.04-3.43-21.57-8.96C3.41,108.43,0,100.87,0,92.57V46.36c0-8.3,3.41-15.86,8.9-21.35 C14.43,19.48,22.07,16.05,30.47,16.05L30.47,16.05z M27.88,75.18c-2.86,0.74-5.78-0.98-6.52-3.84c-0.74-2.86,0.98-5.78,3.84-6.52 l28.8-7.45c2.86-0.74,5.78,0.98,6.52,3.84c0.14,0.53,0.19,1.07,0.17,1.59l-0.32,6.38l19.17-5.52c2.84-0.81,5.79,0.83,6.61,3.67 c0.81,2.84-0.83,5.79-3.67,6.61l-26.02,7.5c-0.64,0.23-1.34,0.34-2.06,0.31c-2.95-0.14-5.23-2.65-5.1-5.6l0.33-6.58L27.88,75.18 L27.88,75.18z M78.09,26.48H30.47c-5.4,0-10.31,2.22-13.88,5.78c-3.6,3.6-5.84,8.59-5.84,14.1v46.21c0,5.51,2.24,10.5,5.84,14.1 c3.57,3.57,8.48,5.78,13.88,5.78h47.61c5.4,0,10.31-2.22,13.88-5.78c3.6-3.6,5.84-8.59,5.84-14.1V46.36c0-5.51-2.24-10.5-5.84-14.1 C88.4,28.69,83.49,26.48,78.09,26.48L78.09,26.48z" }))), WD = (u) => /* @__PURE__ */ F.createElement("svg", U({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 122.14 122.88", style: {
  enableBackground: "new 0 0 122.14 122.88"
}, xmlSpace: "preserve", fill: "#fff" }, u), /* @__PURE__ */ F.createElement("g", null, /* @__PURE__ */ F.createElement("path", { d: "M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" }))), GD = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M0.003125 15.4988C0.04375 15.1957 0.075 14.8895 0.128125 14.5895C0.5375 12.3863 1.6875 10.6645 3.5125 9.36758C4.775 10.5645 6.2625 11.1957 8 11.1926C9.73125 11.1926 11.2156 10.5676 12.4906 9.36133C12.7438 9.56133 13.0094 9.75195 13.2531 9.96758C14.7906 11.3332 15.6969 13.0363 15.9438 15.0832C15.9594 15.2207 15.9812 15.3613 16 15.4988C16 15.6645 16 15.8332 16 15.9988C10.6656 15.9988 5.33437 15.9988 0 15.9988C0.003125 15.8332 0.003125 15.6645 0.003125 15.4988Z", fill: "white" }), /* @__PURE__ */ F.createElement("path", { d: "M8.37828 -0.000976562C8.69391 0.0615234 9.01578 0.102148 9.32203 0.189648C11.197 0.711523 12.5845 2.3709 12.7783 4.31152C13.047 7.00215 11.072 9.36465 8.36891 9.58652C5.93453 9.78965 3.69391 8.05527 3.28141 5.6459C2.83766 3.0709 4.44703 0.670898 7.00015 0.105273C7.2064 0.0583984 7.41891 0.0333984 7.62828 -0.000976562C7.87828 -0.000976563 8.12828 -0.000976562 8.37828 -0.000976562Z", fill: "white" }));
function me(u, e, t) {
  return e in u ? Object.defineProperty(u, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : u[e] = t, u;
}
const cu = 1, rr = 2, nr = 4, bu = 8, xt = 16, Ie = 32, Ou = 64, vt = {
  a: {
    content: cu | bu,
    self: !1,
    type: cu | bu | Ie | Ou
  },
  address: {
    invalid: ["h1", "h2", "h3", "h4", "h5", "h6", "address", "article", "aside", "section", "div", "header", "footer"],
    self: !1
  },
  audio: {
    children: ["track", "source"]
  },
  br: {
    type: cu | bu,
    void: !0
  },
  body: {
    content: cu | rr | nr | bu | xt | Ie | Ou
  },
  button: {
    content: bu,
    type: cu | bu | Ie | Ou
  },
  caption: {
    content: cu,
    parent: ["table"]
  },
  col: {
    parent: ["colgroup"],
    void: !0
  },
  colgroup: {
    children: ["col"],
    parent: ["table"]
  },
  details: {
    children: ["summary"],
    type: cu | Ie | Ou
  },
  dd: {
    content: cu,
    parent: ["dl"]
  },
  dl: {
    children: ["dt", "dd"],
    type: cu
  },
  dt: {
    content: cu,
    invalid: ["footer", "header"],
    parent: ["dl"]
  },
  figcaption: {
    content: cu,
    parent: ["figure"]
  },
  footer: {
    invalid: ["footer", "header"]
  },
  header: {
    invalid: ["footer", "header"]
  },
  hr: {
    type: cu,
    void: !0
  },
  img: {
    void: !0
  },
  li: {
    content: cu,
    parent: ["ul", "ol", "menu"]
  },
  main: {
    self: !1
  },
  ol: {
    children: ["li"],
    type: cu
  },
  picture: {
    children: ["source", "img"],
    type: cu | bu | xt
  },
  rb: {
    parent: ["ruby", "rtc"]
  },
  rp: {
    parent: ["ruby", "rtc"]
  },
  rt: {
    content: bu,
    parent: ["ruby", "rtc"]
  },
  rtc: {
    content: bu,
    parent: ["ruby"]
  },
  ruby: {
    children: ["rb", "rp", "rt", "rtc"]
  },
  source: {
    parent: ["audio", "video", "picture"],
    void: !0
  },
  summary: {
    content: bu,
    parent: ["details"]
  },
  table: {
    children: ["caption", "colgroup", "thead", "tbody", "tfoot", "tr"],
    type: cu
  },
  tbody: {
    parent: ["table"],
    children: ["tr"]
  },
  td: {
    content: cu,
    parent: ["tr"]
  },
  tfoot: {
    parent: ["table"],
    children: ["tr"]
  },
  th: {
    content: cu,
    parent: ["tr"]
  },
  thead: {
    parent: ["table"],
    children: ["tr"]
  },
  tr: {
    parent: ["table", "tbody", "thead", "tfoot"],
    children: ["th", "td"]
  },
  track: {
    parent: ["audio", "video"],
    void: !0
  },
  ul: {
    children: ["li"],
    type: cu
  },
  video: {
    children: ["track", "source"]
  },
  wbr: {
    type: cu | bu,
    void: !0
  }
};
function De(u) {
  return (e) => {
    vt[e] = U(U({}, u), vt[e]);
  };
}
["address", "main", "div", "figure", "p", "pre"].forEach(De({
  content: cu,
  type: cu | Ou
}));
["abbr", "b", "bdi", "bdo", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "ruby", "samp", "strong", "sub", "sup", "time", "u", "var"].forEach(De({
  content: bu,
  type: cu | bu | Ou
}));
["p", "pre"].forEach(De({
  content: bu,
  type: cu | Ou
}));
["s", "small", "span", "del", "ins"].forEach(De({
  content: bu,
  type: cu | bu
}));
["article", "aside", "footer", "header", "nav", "section", "blockquote"].forEach(De({
  content: cu,
  type: cu | rr | Ou
}));
["h1", "h2", "h3", "h4", "h5", "h6"].forEach(De({
  content: bu,
  type: cu | nr | Ou
}));
["audio", "canvas", "iframe", "img", "video"].forEach(De({
  type: cu | bu | xt | Ou
}));
const yt = Object.freeze(vt), YD = ["applet", "base", "body", "command", "embed", "frame", "frameset", "head", "html", "link", "meta", "noscript", "object", "script", "style", "title"], qD = Object.keys(yt).filter((u) => u !== "canvas" && u !== "iframe"), hu = 1, ZD = 2, ge = 3, ce = 4, Dr = 5, h0 = Object.freeze({
  alt: hu,
  cite: hu,
  class: hu,
  colspan: ge,
  controls: ce,
  datetime: hu,
  default: ce,
  disabled: ce,
  dir: hu,
  height: hu,
  href: hu,
  id: hu,
  kind: hu,
  label: hu,
  lang: hu,
  loading: hu,
  loop: ce,
  media: hu,
  muted: ce,
  poster: hu,
  rel: hu,
  role: hu,
  rowspan: ge,
  scope: hu,
  sizes: hu,
  span: ge,
  start: ge,
  style: Dr,
  src: hu,
  srclang: hu,
  srcset: hu,
  tabindex: hu,
  target: hu,
  title: hu,
  type: hu,
  width: hu
}), KD = Object.freeze({
  class: "className",
  colspan: "colSpan",
  datetime: "dateTime",
  rowspan: "rowSpan",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex"
});
function We() {
  return We = Object.assign || function(u) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (u[n] = t[n]);
    }
    return u;
  }, We.apply(this, arguments);
}
function sr({
  attributes: u = {},
  className: e,
  children: t = null,
  selfClose: n = !1,
  tagName: D
}) {
  const s = D;
  return n ? /* @__PURE__ */ Eu.createElement(s, We({
    className: e
  }, u)) : /* @__PURE__ */ Eu.createElement(s, We({
    className: e
  }, u), t);
}
class XD {
  /**
   * Filter and clean an HTML attribute value.
   */
  attribute(e, t) {
    return t;
  }
  /**
   * Filter and clean an HTML node.
   */
  node(e, t) {
    return t;
  }
}
function JD(u, e, t, n = !1) {
  const D = u.match(e instanceof RegExp ? e : new RegExp(e, "i"));
  return D ? _u(U({
    match: D[0],
    void: n
  }, t(D)), {
    index: D.index,
    length: D[0].length,
    valid: !0
  }) : null;
}
class Se {
  constructor(e, t, n) {
    if (me(this, "greedy", !1), me(this, "options", void 0), me(this, "propName", void 0), me(this, "inverseName", void 0), me(this, "factory", void 0), process.env.NODE_ENV !== "production" && (!e || e.toLowerCase() === "html"))
      throw new Error(`The matcher name "${e}" is not allowed.`);
    this.options = U({}, t), this.propName = e, this.inverseName = `no${e.charAt(0).toUpperCase() + e.slice(1)}`, this.factory = n != null ? n : null;
  }
  /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */
  createElement(e, t) {
    const n = this.factory ? /* @__PURE__ */ Eu.createElement(this.factory, t, e) : this.replaceWith(e, t);
    if (process.env.NODE_ENV !== "production" && typeof n != "string" && !/* @__PURE__ */ Eu.isValidElement(n))
      throw new Error(`Invalid React element created from ${this.constructor.name}.`);
    return n;
  }
  /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */
  doMatch(e, t, n, D = !1) {
    return JD(e, t, n, D);
  }
  /**
   * Callback triggered before parsing.
   */
  onBeforeParse(e, t) {
    return e;
  }
  /**
   * Callback triggered after parsing.
   */
  onAfterParse(e, t) {
    return e;
  }
  /**
   * Replace the match with a React element based on the matched token and optional props.
   */
}
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */
var QD = /["'&<>]/, us = es;
function es(u) {
  var e = "" + u, t = QD.exec(e);
  if (!t)
    return e;
  var n, D = "", s = 0, i = 0;
  for (s = t.index; s < e.length; s++) {
    switch (e.charCodeAt(s)) {
      case 34:
        n = "&quot;";
        break;
      case 38:
        n = "&amp;";
        break;
      case 39:
        n = "&#39;";
        break;
      case 60:
        n = "&lt;";
        break;
      case 62:
        n = "&gt;";
        break;
      default:
        continue;
    }
    i !== s && (D += e.substring(i, s)), i = s + 1, D += n;
  }
  return i !== s ? D + e.substring(i, s) : D;
}
const ts = /* @__PURE__ */ ne(us);
function Gu(u, e, t) {
  return e in u ? Object.defineProperty(u, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : u[e] = t, u;
}
const rs = /(url|image|image-set)\(/i;
class ns extends XD {
  attribute(e, t) {
    return e === "style" && Object.keys(t).forEach((n) => {
      String(t[n]).match(rs) && delete t[n];
    }), t;
  }
}
const m0 = 1, Ds = 3, ss = /^<(!doctype|(html|head|body)(\s|>))/i, is = /^(aria-|data-|\w+:)/iu, as = /{{{(\w+)\/?}}}/;
function os() {
  if (!(typeof window == "undefined" || typeof document == "undefined"))
    return document.implementation.createHTMLDocument("Interweave");
}
class ir {
  constructor(e, t = {}, n = [], D = []) {
    var s;
    if (Gu(this, "allowed", void 0), Gu(this, "banned", void 0), Gu(this, "blocked", void 0), Gu(this, "container", void 0), Gu(this, "content", []), Gu(this, "props", void 0), Gu(this, "matchers", void 0), Gu(this, "filters", void 0), Gu(this, "keyIndex", void 0), process.env.NODE_ENV !== "production" && e && typeof e != "string")
      throw new TypeError("Interweave parser requires a valid string.");
    this.props = t, this.matchers = n, this.filters = [...D, new ns()], this.keyIndex = -1, this.container = this.createContainer(e || ""), this.allowed = new Set((s = t.allowList) !== null && s !== void 0 ? s : qD), this.banned = new Set(YD), this.blocked = new Set(t.blockList);
  }
  /**
   * Loop through and apply all registered attribute filters.
   */
  applyAttributeFilters(e, t) {
    return this.filters.reduce((n, D) => n !== null && typeof D.attribute == "function" ? D.attribute(e, n) : n, t);
  }
  /**
   * Loop through and apply all registered node filters.
   */
  applyNodeFilters(e, t) {
    return this.filters.reduce((n, D) => n !== null && typeof D.node == "function" ? D.node(e, n) : n, t);
  }
  /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */
  applyMatchers(e, t) {
    const n = {}, {
      props: D
    } = this;
    let s = e, i = 0, a = null;
    return this.matchers.forEach((o) => {
      const c = o.asTag().toLowerCase(), g = this.getTagConfig(c);
      if (D[o.inverseName] || !this.isTagAllowed(c) || !this.canRenderChild(t, g))
        return;
      let m = "";
      for (; s && (a = o.match(s)); ) {
        const v = a, {
          index: l,
          length: p,
          match: h,
          valid: E,
          void: w
        } = v, C = Pu(v, [
          "index",
          "length",
          "match",
          "valid",
          "void"
        ]), d = o.propName + String(i);
        l > 0 && (m += s.slice(0, l)), E ? (m += w ? `{{{${d}/}}}` : `{{{${d}}}}${h}{{{/${d}}}}`, this.keyIndex += 1, i += 1, n[d] = {
          children: h,
          matcher: o,
          props: _u(U(U({}, D), C), {
            key: this.keyIndex
          })
        }) : m += h, o.greedy ? (s = m + s.slice(l + p), m = "") : s = s.slice(l + (p || h.length));
      }
      o.greedy || (s = m + s);
    }), i === 0 ? e : this.replaceTokens(s, n);
  }
  /**
   * Determine whether the child can be rendered within the parent.
   */
  canRenderChild(e, t) {
    return !e.tagName || !t.tagName || e.void ? !1 : e.children.length > 0 ? e.children.includes(t.tagName) : e.invalid.length > 0 && e.invalid.includes(t.tagName) ? !1 : t.parent.length > 0 ? t.parent.includes(e.tagName) : !e.self && e.tagName === t.tagName ? !1 : !!(e && e.content & t.type);
  }
  /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */
  convertLineBreaks(e) {
    const {
      noHtml: t,
      disableLineBreaks: n
    } = this.props;
    if (t || n || e.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi))
      return e;
    let D = e.replace(/\r\n/g, `
`);
    return D = D.replace(/\n{3,}/g, `


`), D = D.replace(/\n/g, "<br/>"), D;
  }
  /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */
  createContainer(e) {
    var t;
    const D = (typeof global != "undefined" && global.INTERWEAVE_SSR_POLYFILL || os)();
    if (!D)
      return;
    const s = (t = this.props.containerTagName) !== null && t !== void 0 ? t : "body", i = s === "body" || s === "fragment" ? D.body : D.createElement(s);
    if (e.match(ss)) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("HTML documents as Interweave content are not supported.");
    } else
      i.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? ts(e) : e);
    return i;
  }
  /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */
  extractAttributes(e) {
    const {
      allowAttributes: t
    } = this.props, n = {};
    let D = 0;
    return e.nodeType !== m0 || !e.attributes || ([...e.attributes].forEach((s) => {
      const {
        name: i,
        value: a
      } = s, o = i.toLowerCase(), c = h0[o] || h0[i];
      if (!this.isSafe(e) || !o.match(is) && (!t && (!c || c === ZD) || o.startsWith("on") || a.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i)))
        return;
      let g = o === "style" ? this.extractStyleAttribute(e) : a;
      c === ce ? g = !0 : c === ge ? g = Number.parseFloat(String(g)) : c !== Dr && (g = String(g)), n[KD[o] || o] = this.applyAttributeFilters(o, g), D += 1;
    }), D === 0) ? null : n;
  }
  /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */
  extractStyleAttribute(e) {
    const t = {};
    return Array.from(e.style).forEach((n) => {
      const D = e.style[n];
      (typeof D == "string" || typeof D == "number") && (t[n.replace(/-([a-z])/g, (s, i) => String(i).toUpperCase())] = D);
    }), t;
  }
  /**
   * Return configuration for a specific tag.
   */
  getTagConfig(e) {
    const t = {
      children: [],
      content: 0,
      invalid: [],
      parent: [],
      self: !0,
      tagName: "",
      type: 0,
      void: !1
    };
    return yt[e] ? _u(U(U({}, t), yt[e]), {
      tagName: e
    }) : t;
  }
  /**
   * Verify that a node is safe from XSS and injection attacks.
   */
  isSafe(e) {
    if (typeof HTMLAnchorElement != "undefined" && e instanceof HTMLAnchorElement) {
      const t = e.getAttribute("href");
      if (t != null && t.startsWith("#"))
        return !0;
      const n = e.protocol.toLowerCase();
      return n === ":" || n === "http:" || n === "https:" || n === "mailto:" || n === "tel:";
    }
    return !0;
  }
  /**
   * Verify that an HTML tag is allowed to render.
   */
  isTagAllowed(e) {
    return this.banned.has(e) || this.blocked.has(e) ? !1 : this.props.allowElements || this.allowed.has(e);
  }
  /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */
  parse() {
    return this.container ? this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase())) : [];
  }
  /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */
  parseNode(e, t) {
    const {
      noHtml: n,
      noHtmlExceptMatchers: D,
      allowElements: s,
      transform: i,
      transformOnlyAllowList: a
    } = this.props;
    let o = [], c = "";
    return [...e.childNodes].forEach((g) => {
      if (g.nodeType === m0) {
        const v = g.nodeName.toLowerCase(), l = this.getTagConfig(v);
        c && (o.push(c), c = "");
        const p = this.applyNodeFilters(v, g);
        if (!p)
          return;
        let h;
        if (i && !(a && !this.isTagAllowed(v))) {
          this.keyIndex += 1;
          const E = this.keyIndex;
          h = this.parseNode(p, l);
          const w = i(p, h, l);
          if (w === null)
            return;
          if (typeof w != "undefined") {
            o.push(/* @__PURE__ */ Eu.cloneElement(w, {
              key: E
            }));
            return;
          }
          this.keyIndex = E - 1;
        }
        if (this.banned.has(v))
          return;
        if (!(n || D && v !== "br") && this.isTagAllowed(v) && (s || this.canRenderChild(t, l))) {
          var m;
          this.keyIndex += 1;
          const E = this.extractAttributes(p), w = {
            tagName: v
          };
          E && (w.attributes = E), l.void && (w.selfClose = l.void), o.push(/* @__PURE__ */ Eu.createElement(sr, _u(U({}, w), {
            key: this.keyIndex
          }), (m = h) !== null && m !== void 0 ? m : this.parseNode(p, l)));
        } else
          o = [...o, ...this.parseNode(p, l.tagName ? l : t)];
      } else if (g.nodeType === Ds) {
        const v = n && !D ? g.textContent : (
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          this.applyMatchers(g.textContent || "", t)
        );
        Array.isArray(v) ? o = [...o, ...v] : c += v;
      }
    }), c && o.push(c), o;
  }
  /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */
  replaceTokens(e, t) {
    if (!e.includes("{{{"))
      return e;
    const n = [];
    let D = e, s = null;
    for (; s = D.match(as); ) {
      const [i, a] = s, o = s.index, c = i.includes("/");
      if (process.env.NODE_ENV !== "production" && !t[a])
        throw new Error(`Token "${a}" found but no matching element to replace with.`);
      o > 0 && (n.push(D.slice(0, o)), D = D.slice(o));
      const {
        children: g,
        matcher: m,
        props: v
      } = t[a];
      let l;
      if (c)
        l = i.length, n.push(m.createElement(g, v));
      else {
        const p = D.match(new RegExp(`{{{/${a}}}}`));
        if (process.env.NODE_ENV !== "production" && !p)
          throw new Error(`Closing token missing for interpolated element "${a}".`);
        l = p.index + p[0].length, n.push(m.createElement(this.replaceTokens(D.slice(i.length, p.index), t), v));
      }
      D = D.slice(l);
    }
    return D.length > 0 && n.push(D), n.length === 0 ? "" : n.length === 1 && typeof n[0] == "string" ? n[0] : n;
  }
}
function ls(u) {
  var e;
  const {
    attributes: t,
    className: n,
    containerTagName: D,
    content: s,
    emptyContent: i,
    parsedContent: a,
    tagName: o,
    noWrap: c
  } = u, g = (e = D != null ? D : o) !== null && e !== void 0 ? e : "span", m = g === "fragment" ? !0 : c;
  let v;
  if (a)
    v = a;
  else {
    const l = new ir(s != null ? s : "", u).parse();
    l.length > 0 && (v = l);
  }
  return v || (v = i), m ? /* @__PURE__ */ Eu.createElement(Eu.Fragment, null, v) : /* @__PURE__ */ Eu.createElement(sr, {
    attributes: t,
    className: n,
    tagName: g
  }, v);
}
function cs(u) {
  const B = u, {
    attributes: e,
    className: t,
    content: n = "",
    disableFilters: D = !1,
    disableMatchers: s = !1,
    emptyContent: i = null,
    filters: a = [],
    matchers: o = [],
    onAfterParse: c = null,
    onBeforeParse: g = null,
    tagName: m = "span",
    noWrap: v = !1
  } = B, l = Pu(B, [
    "attributes",
    "className",
    "content",
    "disableFilters",
    "disableMatchers",
    "emptyContent",
    "filters",
    "matchers",
    "onAfterParse",
    "onBeforeParse",
    "tagName",
    "noWrap"
  ]), p = s ? [] : o, h = D ? [] : a, E = g ? [g] : [], w = c ? [c] : [];
  p.forEach((j) => {
    j.onBeforeParse && E.push(j.onBeforeParse.bind(j)), j.onAfterParse && w.push(j.onAfterParse.bind(j));
  });
  const C = E.reduce((j, I) => {
    const T = I(j, u);
    if (process.env.NODE_ENV !== "production" && typeof T != "string")
      throw new TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
    return T;
  }, n != null ? n : ""), d = new ir(C, l, p, h), f = w.reduce((j, I) => {
    const T = I(j, u);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(T))
      throw new TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
    return T;
  }, d.parse());
  return /* @__PURE__ */ Eu.createElement(ls, {
    attributes: e,
    className: t,
    containerTagName: u.containerTagName,
    emptyContent: i,
    noWrap: v,
    parsedContent: f.length === 0 ? void 0 : f,
    tagName: m
  });
}
function Tu(u, e = {}) {
  var t, n;
  let D = u.map((s) => s.source).join((t = e.join) !== null && t !== void 0 ? t : "");
  return e.capture ? D = `(${D})` : e.nonCapture && (D = `(?:${D})`), e.match && (D += e.match), new RegExp(D, (n = e.flags) !== null && n !== void 0 ? n : "");
}
const B0 = /[a-z0-9]/, ar = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/, or = /(https?:\/\/)?/, lr = Tu([
  /[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/,
  // Includes colon
  /@/
], {
  capture: !0,
  match: "?"
}), cr = Tu([
  /(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/,
  // Subdomain
  /(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/,
  // Domain
  /(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/
  // TLD
], {
  capture: !0
}), Fr = /(?::(\d{1,5}))?/, Er = Tu([/\//, Tu([
  /[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/,
  /[-+a-z0-9/]/
  // Valid ending chars
], {
  match: "*",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), Cr = Tu([/\?/, Tu([
  ar,
  /[a-z0-9_&=]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), dr = Tu([/#/, Tu([
  ar,
  /[a-z0-9]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), Fs = Tu([or, lr, cr, Fr, Er, Cr, dr], {
  flags: "i"
}), Oe = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/, Es = Tu([Oe, Oe, Oe, Oe], {
  capture: !0,
  join: "\\."
});
Tu([or, lr, Es, Fr, Er, Cr, dr], {
  flags: "i"
});
const Cs = [
  // Chinese
  /[\d_\u4E00-\u9FFF-]+/,
  // Japanese
  /[\d_\u3000-\u30FF-]+/,
  // Korean
  /[\d_\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7FF-]+/,
  // Thai
  /[\d_\u0E00-\u0E7F-]+/,
  // Russian, Ukrainian
  // eslint-disable-next-line no-misleading-character-class
  /[\d_a-z\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F-]+/,
  // Latin based
  /[\d_a-z\u0080-\u00FF\u0100-\u017F\u0180-\u024F-]+/
];
Tu([/#/, Tu(Cs, {
  capture: !0,
  join: "|"
})], {
  flags: "i"
});
const ds = /[.a-z0-9!#$%&?*+=_{|}~-]*/, As = Tu([B0, ds, B0], {
  capture: !0
}), g0 = Tu([As, cr], {
  flags: "i",
  join: "@"
}), ps = new RegExp(`^${g0.source}$`, g0.flags), fs = [
  // Original
  "com",
  "org",
  "net",
  "int",
  "edu",
  "gov",
  "mil",
  // Sponsored
  "aero",
  "asia",
  "biz",
  "cat",
  "coop",
  "jobs",
  "mobi",
  "museum",
  "post",
  "tel",
  "travel",
  "xxx",
  // Misc
  "app",
  "arpa",
  "test",
  // Countries
  "ac",
  // Ascension Island
  "ad",
  // Andorra
  "ae",
  // United Arab Emirates
  "af",
  // Afghanistan
  "ag",
  // Antigua and Barbuda
  "ai",
  // Anguilla
  "al",
  // Albania
  "am",
  // Armenia
  "an",
  // Netherlands Antilles
  "ao",
  // Angola
  "aq",
  // Antarctica
  "ar",
  // Argentina
  "as",
  // American Samoa
  "at",
  // Austria
  "au",
  // Australia
  "aw",
  // Aruba
  "ax",
  // Aland Islands
  "az",
  // Azerbaijan
  "ba",
  // Bosnia and Herzegovina
  "bb",
  // Barbados
  "bd",
  // Bangladesh
  "be",
  // Belgium
  "bf",
  // Burkina Faso
  "bg",
  // Bulgaria
  "bh",
  // Bahrain
  "bi",
  // Burundi
  "bj",
  // Benin
  "bl",
  // Saint Barthelemy
  "bm",
  // Bermuda
  "bn",
  // Brunei Darussalam
  "bo",
  // Bolivia
  "bq",
  // Bonaire, Sint Eustatius and Saba
  "br",
  // Brazil
  "bs",
  // Bahamas
  "bt",
  // Bhutan
  "bv",
  // Bouvet Island
  "bw",
  // Botswana
  "by",
  // Belarus
  "bz",
  // Belize
  "ca",
  // Canada
  "cc",
  // Cocos (Keeling) Islands
  "cd",
  // Congo, The Democratic Republic of the
  "cf",
  // Central African Republic
  "cg",
  // Congo
  "ch",
  // Switzerland
  "ci",
  // Cote d'Ivoire
  "ck",
  // Cook Islands
  "cl",
  // Chile
  "cm",
  // Cameroon
  "cn",
  // China
  "co",
  // Colombia
  "cr",
  // Costa Rica
  "cu",
  // Cuba
  "cv",
  // Cape Verde
  "cw",
  // Curaçao
  "cx",
  // Christmas Island
  "cy",
  // Cyprus
  "cz",
  // Czech Republic
  "de",
  // Germany
  "dj",
  // Djibouti
  "dk",
  // Denmark
  "dm",
  // Dominica
  "do",
  // Dominican Republic
  "dz",
  // Algeria
  "ec",
  // Ecuador
  "ee",
  // Estonia
  "eg",
  // Egypt
  "eh",
  // Western Sahara
  "er",
  // Eritrea
  "es",
  // Spain
  "et",
  // Ethiopia
  "eu",
  // European Union
  "fi",
  // Finland
  "fj",
  // Fiji
  "fk",
  // Falkland Islands (Malvinas)
  "fm",
  // Micronesia, Federated States of
  "fo",
  // Faroe Islands
  "fr",
  // France
  "ga",
  // Gabon
  "gb",
  // United Kingdom
  "gd",
  // Grenada
  "ge",
  // Georgia
  "gf",
  // French Guiana
  "gg",
  // Guernsey
  "gh",
  // Ghana
  "gi",
  // Gibraltar
  "gl",
  // Greenland
  "gm",
  // Gambia
  "gn",
  // Guinea
  "gp",
  // Guadeloupe
  "gq",
  // Equatorial Guinea
  "gr",
  // Greece
  "gs",
  // South Georgia and the South Sandwich Islands
  "gt",
  // Guatemala
  "gu",
  // Guam
  "gw",
  // Guinea-Bissau
  "gy",
  // Guyana
  "hk",
  // Hong Kong
  "hm",
  // Heard Island and McDonald Islands
  "hn",
  // Honduras
  "hr",
  // Croatia
  "ht",
  // Haiti
  "hu",
  // Hungary
  "id",
  // Indonesia
  "ie",
  // Ireland
  "il",
  // Israel
  "im",
  // Isle of Man
  "in",
  // India
  "io",
  // British Indian Ocean Territory
  "iq",
  // Iraq
  "ir",
  // Iran, Islamic Republic of
  "is",
  // Iceland
  "it",
  // Italy
  "je",
  // Jersey
  "jm",
  // Jamaica
  "jo",
  // Jordan
  "jp",
  // Japan
  "ke",
  // Kenya
  "kg",
  // Kyrgyzstan
  "kh",
  // Cambodia
  "ki",
  // Kiribati
  "km",
  // Comoros
  "kn",
  // Saint Kitts and Nevis
  "kp",
  // Korea, Democratic People's Republic of
  "kr",
  // Korea, Republic of
  "kw",
  // Kuwait
  "ky",
  // Cayman Islands
  "kz",
  // Kazakhstan
  "la",
  // Lao People's Democratic Republic
  "lb",
  // Lebanon
  "lc",
  // Saint Lucia
  "li",
  // Liechtenstein
  "lk",
  // Sri Lanka
  "lr",
  // Liberia
  "ls",
  // Lesotho
  "lt",
  // Lithuania
  "lu",
  // Luxembourg
  "lv",
  // Latvia
  "ly",
  // Libyan Arab Jamahiriya
  "ma",
  // Morocco
  "mc",
  // Monaco
  "md",
  // Moldova, Republic of
  "me",
  // Montenegro
  "mf",
  // Saint Martin (French part)
  "mg",
  // Madagascar
  "mh",
  // Marshall Islands
  "mk",
  // Macedonia, The Former Yugoslav Republic of
  "ml",
  // Mali
  "mm",
  // Myanmar
  "mn",
  // Mongolia
  "mo",
  // Macao
  "mp",
  // Northern Mariana Islands
  "mq",
  // Martinique
  "mr",
  // Mauritania
  "ms",
  // Montserrat
  "mt",
  // Malta
  "mu",
  // Mauritius
  "mv",
  // Maldives
  "mw",
  // Malawi
  "mx",
  // Mexico
  "my",
  // Malaysia
  "mz",
  // Mozambique
  "na",
  // Namibia
  "nc",
  // New Caledonia
  "ne",
  // Niger
  "nf",
  // Norfolk Island
  "ng",
  // Nigeria
  "ni",
  // Nicaragua
  "nl",
  // Netherlands
  "no",
  // Norway
  "np",
  // Nepal
  "nr",
  // Nauru
  "nu",
  // Niue
  "nz",
  // New Zealand
  "om",
  // Oman
  "pa",
  // Panama
  "pe",
  // Peru
  "pf",
  // French Polynesia
  "pg",
  // Papua New Guinea
  "ph",
  // Philippines
  "pk",
  // Pakistan
  "pl",
  // Poland
  "pm",
  // Saint Pierre and Miquelon
  "pn",
  // Pitcairn
  "pr",
  // Puerto Rico
  "ps",
  // Palestinian Territory, Occupied
  "pt",
  // Portugal
  "pw",
  // Palau
  "py",
  // Paraguay
  "qa",
  // Qatar
  "re",
  // Reunion
  "ro",
  // Romania
  "rs",
  // Serbia
  "ru",
  // Russian Federation
  "rw",
  // Rwanda
  "sa",
  // Saudi Arabia
  "sb",
  // Solomon Islands
  "sc",
  // Seychelles
  "sd",
  // Sudan
  "se",
  // Sweden
  "sg",
  // Singapore
  "sh",
  // Saint Helena
  "si",
  // Slovenia
  "sj",
  // Svalbard and Jan Mayen
  "sk",
  // Slovakia
  "sl",
  // Sierra Leone
  "sm",
  // San Marino
  "sn",
  // Senegal
  "so",
  // Somalia
  "sr",
  // Suriname
  "st",
  // Sao Tome and Principe
  "su",
  // Soviet Union (being phased out)
  "sv",
  // El Salvador
  "sx",
  // Sint Maarten (Dutch part)
  "sy",
  // Syrian Arab Republic
  "sz",
  // Swaziland
  "tc",
  // Turks and Caicos Islands
  "td",
  // Chad
  "tf",
  // French Southern Territories
  "tg",
  // Togo
  "th",
  // Thailand
  "tj",
  // Tajikistan
  "tk",
  // Tokelau
  "tl",
  // Timor-Leste
  "tm",
  // Turkmenistan
  "tn",
  // Tunisia
  "to",
  // Tonga
  "tp",
  // Portuguese Timor (being phased out)
  "tr",
  // Turkey
  "tt",
  // Trinidad and Tobago
  "tv",
  // Tuvalu
  "tw",
  // Taiwan, Province of China
  "tz",
  // Tanzania, United Republic of
  "ua",
  // Ukraine
  "ug",
  // Uganda
  "uk",
  // United Kingdom
  "um",
  // United States Minor Outlying Islands
  "us",
  // United States
  "uy",
  // Uruguay
  "uz",
  // Uzbekistan
  "va",
  // Holy See (Vatican City State)
  "vc",
  // Saint Vincent and the Grenadines
  "ve",
  // Venezuela, Bolivarian Republic of
  "vg",
  // Virgin Islands, British
  "vi",
  // Virgin Islands, U.S.
  "vn",
  // Viet Nam
  "vu",
  // Vanuatu
  "wf",
  // Wallis and Futuna
  "ws",
  // Samoa
  "ye",
  // Yemen
  "yt",
  // Mayotte
  "za",
  // South Africa
  "zm",
  // Zambia
  "zw"
  // Zimbabwe
];
function wt() {
  return wt = Object.assign || function(u) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (u[n] = t[n]);
    }
    return u;
  }, wt.apply(this, arguments);
}
function hs({
  children: u,
  href: e,
  onClick: t,
  newWindow: n
}) {
  return /* @__PURE__ */ Eu.createElement("a", {
    href: e,
    rel: "noopener noreferrer",
    target: n ? "_blank" : void 0,
    onClick: t
  }, u);
}
function ms(D) {
  var s = D, {
    children: u,
    url: e,
    urlParts: t
  } = s, n = Pu(s, [
    "children",
    "url",
    "urlParts"
  ]);
  let i = e;
  return i.match(/^https?:\/\//) || (i = `http://${i}`), /* @__PURE__ */ Eu.createElement(hs, wt({}, n, {
    href: i
  }), u);
}
class Bs extends Se {
  constructor(e, t, n) {
    super(e, U({
      customTLDs: [],
      validateTLD: !0
    }, t), n);
  }
  replaceWith(e, t) {
    return /* @__PURE__ */ Eu.createElement(ms, t, e);
  }
  asTag() {
    return "a";
  }
  match(e) {
    const t = this.doMatch(e, Fs, this.handleMatches);
    if (t != null && t.match.match(ps) && (t.valid = !1), t != null && t.valid && this.options.validateTLD) {
      var n;
      const {
        host: D
      } = t.urlParts, s = [...fs, ...(n = this.options.customTLDs) !== null && n !== void 0 ? n : []], i = D.slice(D.lastIndexOf(".") + 1).toLowerCase();
      if (!s.includes(i))
        return null;
    }
    return t;
  }
  /**
   * Package the matched response.
   */
  handleMatches(e) {
    return {
      url: e[0],
      urlParts: {
        auth: e[2] ? e[2].slice(0, -1) : "",
        fragment: e[7] || "",
        host: e[3],
        path: e[5] || "",
        port: e[4] ? e[4] : "",
        query: e[6] || "",
        scheme: e[1] ? e[1].replace("://", "") : "http"
      }
    };
  }
}
/*!
 * XRegExp 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */
const Bu = "xregexp", re = {
  astral: !1,
  namespacing: !0
}, Lu = {};
let xe = {}, Fe = {};
const bt = [], Ce = "default", x0 = "class", gs = {
  // Any native multicharacter token in default scope, or any single character
  default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
  // Any native multicharacter token in character class scope, or any single character
  class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
}, xs = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, vs = /()??/.exec("")[1] === void 0, ys = /x/.flags !== void 0;
function _e(u) {
  let e = !0;
  try {
    if (new RegExp("", u), u === "y") {
      const t = "gy";
      ".a".replace(new RegExp("a", t), ".") === ".." && (e = !1);
    }
  } catch (t) {
    e = !1;
  }
  return e;
}
const ws = _e("d"), Lt = _e("s"), Ar = _e("u"), Mt = _e("y"), pr = {
  d: ws,
  g: !0,
  i: !0,
  m: !0,
  s: Lt,
  u: Ar,
  y: Mt
}, bs = Lt ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
function fr(u, e, t, n, D) {
  if (u[Bu] = {
    captureNames: e
  }, D)
    return u;
  if (u.__proto__)
    u.__proto__ = k.prototype;
  else
    for (const s in k.prototype)
      u[s] = k.prototype[s];
  return u[Bu].source = t, u[Bu].flags = n && n.split("").sort().join(""), u;
}
function be(u) {
  return u.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
}
function se(u, e) {
  if (!k.isRegExp(u))
    throw new TypeError("Type RegExp expected");
  const t = u[Bu] || {};
  let n = js(u), D = "", s = "", i = null, a = null;
  return e = e || {}, e.removeG && (s += "g"), e.removeY && (s += "y"), s && (n = n.replace(new RegExp(`[${s}]+`, "g"), "")), e.addG && (D += "g"), e.addY && (D += "y"), D && (n = be(n + D)), e.isInternalOnly || (t.source !== void 0 && (i = t.source), t.flags != null && (a = D ? be(t.flags + D) : t.flags)), u = fr(
    new RegExp(e.source || u.source, n),
    Ss(u) ? t.captureNames.slice(0) : null,
    i,
    a,
    e.isInternalOnly
  ), u;
}
function hr(u) {
  return parseInt(u, 16);
}
function mr(u, e, t) {
  const n = u.index + u[0].length, D = u.input[u.index - 1], s = u.input[n];
  return (
    // No need to separate tokens if at the beginning or end of a group, before or after a
    // group, or before or after a `|`
    /^[()|]$/.test(D) || /^[()|]$/.test(s) || // No need to separate tokens if at the beginning or end of the pattern
    u.index === 0 || n === u.input.length || // No need to separate tokens if at the beginning of a noncapturing group or lookaround.
    // Looks only at the last 4 chars (at most) for perf when constructing long regexes.
    /\(\?(?:[:=!]|<[=!])$/.test(u.input.substring(u.index - 4, u.index)) || // Avoid separating tokens when the following token is a quantifier
    _s(u.input, n, t) ? "" : "(?:)"
  );
}
function js(u) {
  return ys ? u.flags : (
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(u))[1]
  );
}
function Ss(u) {
  return !!(u[Bu] && u[Bu].captureNames);
}
function zt(u) {
  return parseInt(u, 10).toString(16);
}
function _s(u, e, t) {
  const n = "\\(\\?#[^)]*\\)", D = "#[^#\\n]*", s = "[?*+]|{\\d+(?:,\\d*)?}";
  return (t.includes("x") ? (
    // Ignore any leading whitespace, line comments, and inline comments
    new RegExp(`^(?:\\s|${D}|${n})*(?:${s})`)
  ) : (
    // Ignore any leading inline comments
    new RegExp(`^(?:${n})*(?:${s})`)
  )).test(u.slice(e));
}
function Ge(u, e) {
  return Object.prototype.toString.call(u) === `[object ${e}]`;
}
function he(u) {
  if (u == null)
    throw new TypeError("Cannot convert null or undefined to object");
  return u;
}
function Ut(u) {
  for (; u.length < 4; )
    u = `0${u}`;
  return u;
}
function Ns(u, e) {
  if (be(e) !== e)
    throw new SyntaxError(`Invalid duplicate regex flag ${e}`);
  u = u.replace(/^\(\?([\w$]+)\)/, (t, n) => {
    if (/[dgy]/.test(n))
      throw new SyntaxError(`Cannot use flags dgy in mode modifier ${t}`);
    return e = be(e + n), "";
  });
  for (const t of e)
    if (!pr[t])
      throw new SyntaxError(`Unknown regex flag ${t}`);
  return {
    pattern: u,
    flags: e
  };
}
function Br(u) {
  const e = {};
  return Ge(u, "String") ? (k.forEach(u, /[^\s,]+/, (t) => {
    e[t] = !0;
  }), e) : u;
}
function v0(u) {
  if (!/^[\w$]$/.test(u))
    throw new Error("Flag must be a single character A-Za-z0-9_$");
  pr[u] = !0;
}
function $s(u, e, t, n, D) {
  let s = bt.length;
  const i = u[t];
  let a = null, o, c;
  for (; s--; )
    if (c = bt[s], !(c.leadChar && c.leadChar !== i || c.scope !== n && c.scope !== "all" || c.flag && !e.includes(c.flag)) && (o = k.exec(u, c.regex, t, "sticky"), o)) {
      a = {
        matchLength: o[0].length,
        output: c.handler.call(D, o, n, e),
        reparse: c.reparse
      };
      break;
    }
  return a;
}
function gr(u) {
  re.astral = u;
}
function xr(u) {
  re.namespacing = u;
}
function k(u, e) {
  if (k.isRegExp(u)) {
    if (e !== void 0)
      throw new TypeError("Cannot supply flags when copying a RegExp");
    return se(u);
  }
  if (u = u === void 0 ? "" : String(u), e = e === void 0 ? "" : String(e), k.isInstalled("astral") && !e.includes("A") && (e += "A"), Fe[u] || (Fe[u] = {}), !Fe[u][e]) {
    const n = {
      hasNamedCapture: !1,
      captureNames: []
    };
    let D = Ce, s = "", i = 0, a;
    const o = Ns(u, e);
    let c = o.pattern;
    const g = o.flags;
    for (; i < c.length; ) {
      do
        a = $s(c, g, i, D, n), a && a.reparse && (c = c.slice(0, i) + a.output + c.slice(i + a.matchLength));
      while (a && a.reparse);
      if (a)
        s += a.output, i += a.matchLength || 1;
      else {
        const [m] = k.exec(c, gs[D], i, "sticky");
        s += m, i += m.length, m === "[" && D === Ce ? D = x0 : m === "]" && D === x0 && (D = Ce);
      }
    }
    Fe[u][e] = {
      // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
      // groups are sometimes inserted during regex transpilation in order to keep tokens
      // separated. However, more than one empty group in a row is never needed.
      pattern: s.replace(/(?:\(\?:\))+/g, "(?:)"),
      // Strip all but native flags
      flags: g.replace(bs, ""),
      // `context.captureNames` has an item for each capturing group, even if unnamed
      captures: n.hasNamedCapture ? n.captureNames : null
    };
  }
  const t = Fe[u][e];
  return fr(
    new RegExp(t.pattern, t.flags),
    t.captures,
    u,
    e
  );
}
k.prototype = new RegExp();
k.version = "5.1.1";
k._clipDuplicates = be;
k._hasNativeFlag = _e;
k._dec = hr;
k._hex = zt;
k._pad4 = Ut;
k.addToken = (u, e, t) => {
  t = t || {};
  let { optionalFlags: n } = t;
  if (t.flag && v0(t.flag), n) {
    n = n.split("");
    for (const D of n)
      v0(D);
  }
  bt.push({
    regex: se(u, {
      addG: !0,
      addY: Mt,
      isInternalOnly: !0
    }),
    handler: e,
    scope: t.scope || Ce,
    flag: t.flag,
    reparse: t.reparse,
    leadChar: t.leadChar
  }), k.cache.flush("patterns");
};
k.cache = (u, e) => (xe[u] || (xe[u] = {}), xe[u][e] || (xe[u][e] = k(u, e)));
k.cache.flush = (u) => {
  u === "patterns" ? Fe = {} : xe = {};
};
k.escape = (u) => String(he(u)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, (e) => `\\u${Ut(zt(e.charCodeAt(0)))}`);
k.exec = (u, e, t, n) => {
  let D = "g", s = !1, i = !1, a;
  s = Mt && !!(n || e.sticky && n !== !1), s ? D += "y" : n && (i = !0, D += "FakeY"), e[Bu] = e[Bu] || {};
  const o = e[Bu][D] || (e[Bu][D] = se(e, {
    addG: !0,
    addY: s,
    source: i ? `${e.source}|()` : void 0,
    removeY: n === !1,
    isInternalOnly: !0
  }));
  return t = t || 0, o.lastIndex = t, a = Lu.exec.call(o, u), i && a && a.pop() === "" && (a = null), e.global && (e.lastIndex = a ? o.lastIndex : 0), a;
};
k.forEach = (u, e, t) => {
  let n = 0, D = -1, s;
  for (; s = k.exec(u, e, n); )
    t(s, ++D, u, e), n = s.index + (s[0].length || 1);
};
k.globalize = (u) => se(u, { addG: !0 });
k.install = (u) => {
  u = Br(u), !re.astral && u.astral && gr(!0), !re.namespacing && u.namespacing && xr(!0);
};
k.isInstalled = (u) => !!re[u];
k.isRegExp = (u) => Object.prototype.toString.call(u) === "[object RegExp]";
k.match = (u, e, t) => {
  const n = e.global && t !== "one" || t === "all", D = (n ? "g" : "") + (e.sticky ? "y" : "") || "noGY";
  e[Bu] = e[Bu] || {};
  const s = e[Bu][D] || (e[Bu][D] = se(e, {
    addG: !!n,
    removeG: t === "one",
    isInternalOnly: !0
  })), i = String(he(u)).match(s);
  return e.global && (e.lastIndex = t === "one" && i ? (
    // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    i.index + i[0].length
  ) : 0), n ? i || [] : i && i[0];
};
k.matchChain = (u, e) => function t(n, D) {
  const s = e[D].regex ? e[D] : { regex: e[D] }, i = [];
  function a(o) {
    if (s.backref) {
      const c = `Backreference to undefined group: ${s.backref}`, g = isNaN(s.backref);
      if (g && k.isInstalled("namespacing")) {
        if (!(o.groups && s.backref in o.groups))
          throw new ReferenceError(c);
      } else if (!o.hasOwnProperty(s.backref))
        throw new ReferenceError(c);
      const m = g && k.isInstalled("namespacing") ? o.groups[s.backref] : o[s.backref];
      i.push(m || "");
    } else
      i.push(o[0]);
  }
  for (const o of n)
    k.forEach(o, s.regex, a);
  return D === e.length - 1 || !i.length ? i : t(i, D + 1);
}([u], 0);
k.replace = (u, e, t, n) => {
  const D = k.isRegExp(e), s = e.global && n !== "one" || n === "all", i = (s ? "g" : "") + (e.sticky ? "y" : "") || "noGY";
  let a = e;
  D ? (e[Bu] = e[Bu] || {}, a = e[Bu][i] || (e[Bu][i] = se(e, {
    addG: !!s,
    removeG: n === "one",
    isInternalOnly: !0
  }))) : s && (a = new RegExp(k.escape(String(e)), "g"));
  const o = Lu.replace.call(he(u), a, t);
  return D && e.global && (e.lastIndex = 0), o;
};
k.replaceEach = (u, e) => {
  for (const t of e)
    u = k.replace(u, t[0], t[1], t[2]);
  return u;
};
k.split = (u, e, t) => Lu.split.call(he(u), e, t);
k.test = (u, e, t, n) => !!k.exec(u, e, t, n);
k.uninstall = (u) => {
  u = Br(u), re.astral && u.astral && gr(!1), re.namespacing && u.namespacing && xr(!1);
};
k.union = (u, e, t) => {
  t = t || {};
  const n = t.conjunction || "or";
  let D = 0, s, i;
  function a(m, v, l) {
    const p = i[D - s];
    if (v) {
      if (++D, p)
        return `(?<${p}>`;
    } else if (l)
      return `\\${+l + s}`;
    return m;
  }
  if (!(Ge(u, "Array") && u.length))
    throw new TypeError("Must provide a nonempty array of patterns to merge");
  const o = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, c = [];
  for (const m of u)
    k.isRegExp(m) ? (s = D, i = m[Bu] && m[Bu].captureNames || [], c.push(k(m.source).source.replace(o, a))) : c.push(k.escape(m));
  const g = n === "none" ? "" : "|";
  return k(c.join(g), e);
};
Lu.exec = function(u) {
  const e = this.lastIndex, t = RegExp.prototype.exec.apply(this, arguments);
  if (t) {
    if (!vs && t.length > 1 && t.includes("")) {
      const n = se(this, {
        removeG: !0,
        isInternalOnly: !0
      });
      String(u).slice(t.index).replace(n, (...D) => {
        const s = D.length;
        for (let i = 1; i < s - 2; ++i)
          D[i] === void 0 && (t[i] = void 0);
      });
    }
    if (this[Bu] && this[Bu].captureNames) {
      let n = t;
      k.isInstalled("namespacing") && (t.groups = /* @__PURE__ */ Object.create(null), n = t.groups);
      for (let D = 1; D < t.length; ++D) {
        const s = this[Bu].captureNames[D - 1];
        s && (n[s] = t[D]);
      }
    } else !t.groups && k.isInstalled("namespacing") && (t.groups = void 0);
    this.global && !t[0].length && this.lastIndex > t.index && (this.lastIndex = t.index);
  }
  return this.global || (this.lastIndex = e), t;
};
Lu.test = function(u) {
  return !!Lu.exec.call(this, u);
};
Lu.match = function(u) {
  if (!k.isRegExp(u))
    u = new RegExp(u);
  else if (u.global) {
    const e = String.prototype.match.apply(this, arguments);
    return u.lastIndex = 0, e;
  }
  return Lu.exec.call(u, he(this));
};
Lu.replace = function(u, e) {
  const t = k.isRegExp(u);
  let n, D, s;
  return t ? (u[Bu] && ({ captureNames: D } = u[Bu]), n = u.lastIndex) : u += "", Ge(e, "Function") ? s = String(this).replace(u, (...i) => {
    if (D) {
      let a;
      k.isInstalled("namespacing") ? (a = /* @__PURE__ */ Object.create(null), i.push(a)) : (i[0] = new String(i[0]), [a] = i);
      for (let o = 0; o < D.length; ++o)
        D[o] && (a[D[o]] = i[o + 1]);
    }
    return e(...i);
  }) : s = String(he(this)).replace(u, (...i) => {
    return String(e).replace(xs, a);
    function a(o, c, g, m) {
      c = c || g;
      const v = Ge(i[i.length - 1], "Object") ? 4 : 3, l = i.length - v;
      if (c) {
        if (/^\d+$/.test(c)) {
          const h = +c;
          if (h <= l)
            return i[h] || "";
        }
        const p = D ? D.indexOf(c) : -1;
        if (p < 0)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return i[p + 1] || "";
      }
      if (m === "" || m === " ")
        throw new SyntaxError(`Invalid token ${o}`);
      if (m === "&" || +m == 0)
        return i[0];
      if (m === "$")
        return "$";
      if (m === "`")
        return i[i.length - 1].slice(0, i[i.length - 2]);
      if (m === "'")
        return i[i.length - 1].slice(i[i.length - 2] + i[0].length);
      if (m = +m, !isNaN(m)) {
        if (m > l)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return i[m] || "";
      }
      throw new SyntaxError(`Invalid token ${o}`);
    }
  }), t && (u.global ? u.lastIndex = 0 : u.lastIndex = n), s;
};
Lu.split = function(u, e) {
  if (!k.isRegExp(u))
    return String.prototype.split.apply(this, arguments);
  const t = String(this), n = [], D = u.lastIndex;
  let s = 0, i;
  return e = (e === void 0 ? -1 : e) >>> 0, k.forEach(t, u, (a) => {
    a.index + a[0].length > s && (n.push(t.slice(s, a.index)), a.length > 1 && a.index < t.length && Array.prototype.push.apply(n, a.slice(1)), i = a[0].length, s = a.index + i);
  }), s === t.length ? (!u.test("") || i) && n.push("") : n.push(t.slice(s)), u.lastIndex = D, n.length > e ? n.slice(0, e) : n;
};
k.addToken(
  /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
  (u, e) => {
    if (u[1] === "B" && e === Ce)
      return u[0];
    throw new SyntaxError(`Invalid escape ${u[0]}`);
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
k.addToken(
  /\\u{([\dA-Fa-f]+)}/,
  (u, e, t) => {
    const n = hr(u[1]);
    if (n > 1114111)
      throw new SyntaxError(`Invalid Unicode code point ${u[0]}`);
    if (n <= 65535)
      return `\\u${Ut(zt(n))}`;
    if (Ar && t.includes("u"))
      return u[0];
    throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
k.addToken(
  /\(\?#[^)]*\)/,
  mr,
  { leadChar: "(" }
);
k.addToken(
  /\s+|#[^\n]*\n?/,
  mr,
  { flag: "x" }
);
Lt || k.addToken(
  /\./,
  () => "[\\s\\S]",
  {
    flag: "s",
    leadChar: "."
  }
);
k.addToken(
  /\\k<([^>]+)>/,
  function(u) {
    const e = isNaN(u[1]) ? this.captureNames.indexOf(u[1]) + 1 : +u[1], t = u.index + u[0].length;
    if (!e || e > this.captureNames.length)
      throw new SyntaxError(`Backreference to undefined group ${u[0]}`);
    return `\\${e}${t === u.input.length || isNaN(u.input[t]) ? "" : "(?:)"}`;
  },
  { leadChar: "\\" }
);
k.addToken(
  /\\(\d+)/,
  function(u, e) {
    if (!(e === Ce && /^[1-9]/.test(u[1]) && +u[1] <= this.captureNames.length) && u[1] !== "0")
      throw new SyntaxError(`Cannot use octal escape or backreference to undefined group ${u[0]}`);
    return u[0];
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
k.addToken(
  /\(\?P?<([\p{ID_Start}$_][\p{ID_Continue}$_\u200C\u200D]*)>/u,
  function(u) {
    if (!k.isInstalled("namespacing") && (u[1] === "length" || u[1] === "__proto__"))
      throw new SyntaxError(`Cannot use reserved word as capture name ${u[0]}`);
    if (this.captureNames.includes(u[1]))
      throw new SyntaxError(`Cannot use same name for multiple groups ${u[0]}`);
    return this.captureNames.push(u[1]), this.hasNamedCapture = !0, "(";
  },
  { leadChar: "(" }
);
k.addToken(
  /\((?!\?)/,
  function(u, e, t) {
    return t.includes("n") ? "(?:" : (this.captureNames.push(null), "(");
  },
  {
    optionalFlags: "n",
    leadChar: "("
  }
);
/*!
 * XRegExp.build 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */
const ks = (u) => {
  const e = "xregexp", t = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, n = u.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, t], "g", {
    conjunction: "or"
  });
  function D(c) {
    const g = /^(?:\(\?:\))*\^/, m = /\$(?:\(\?:\))*$/;
    return g.test(c) && m.test(c) && // Ensure that the trailing `$` isn't escaped
    m.test(c.replace(/\\[\s\S]/g, "")) ? c.replace(g, "").replace(m, "") : c;
  }
  function s(c, g) {
    const m = g ? "x" : "";
    return u.isRegExp(c) ? c[e] && c[e].captureNames ? (
      // Don't recompile, to preserve capture names
      c
    ) : (
      // Recompile as XRegExp
      u(c.source, m)
    ) : (
      // Compile string as XRegExp
      u(c, m)
    );
  }
  function i(c) {
    return c instanceof RegExp ? c : u.escape(c);
  }
  function a(c, g, m) {
    return c[`subpattern${m}`] = g, c;
  }
  function o(c, g, m) {
    const v = g < m.length - 1;
    return c + (v ? `{{subpattern${g}}}` : "");
  }
  u.tag = (c) => (g, ...m) => {
    const v = m.map(i).reduce(a, {}), l = g.raw.map(o).join("");
    return u.build(l, v, c);
  }, u.build = (c, g, m) => {
    m = m || "";
    const v = m.includes("x"), l = /^\(\?([\w$]+)\)/.exec(c);
    l && (m = u._clipDuplicates(m + l[1]));
    const p = {};
    for (const j in g)
      if (g.hasOwnProperty(j)) {
        const I = s(g[j], v);
        p[j] = {
          // Deanchoring allows embedding independently useful anchored regexes. If you
          // really need to keep your anchors, double them (i.e., `^^...$$`).
          pattern: D(I.source),
          names: I[e].captureNames || []
        };
      }
    const h = s(c, v);
    let E = 0, w, C = 0;
    const d = [0], f = h[e].captureNames || [], B = h.source.replace(n, (j, I, T, q, V) => {
      const X = I || T;
      let G, J, Q;
      if (X) {
        if (!p.hasOwnProperty(X))
          throw new ReferenceError(`Undefined property ${j}`);
        I ? (G = f[C], d[++C] = ++E, J = `(?<${G || X}>`) : J = "(?:", w = E;
        const tu = p[X].pattern.replace(t, (Fu, lu, nu) => {
          if (lu) {
            if (G = p[X].names[E - w], ++E, G)
              return `(?<${G}>`;
          } else if (nu)
            return Q = +nu - 1, p[X].names[Q] ? (
              // Need to preserve the backreference name in case using flag `n`
              `\\k<${p[X].names[Q]}>`
            ) : `\\${+nu + w}`;
          return Fu;
        });
        return `${J}${tu})`;
      }
      if (q) {
        if (G = f[C], d[++C] = ++E, G)
          return `(?<${G}>`;
      } else if (V)
        return Q = +V - 1, f[Q] ? (
          // Need to preserve the backreference name in case using flag `n`
          `\\k<${f[Q]}>`
        ) : `\\${d[+V]}`;
      return j;
    });
    return u(B, m);
  };
};
/*!
 * XRegExp.matchRecursive 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */
const Ts = (u) => {
  function e(t, n, D, s) {
    return {
      name: t,
      value: n,
      start: D,
      end: s
    };
  }
  u.matchRecursive = (t, n, D, s, i) => {
    s = s || "", i = i || {};
    const a = s.includes("g"), o = s.includes("y"), c = s.replace(/y/g, "");
    n = u(n, c), D = u(D, c);
    let g, { escapeChar: m } = i;
    if (m) {
      if (m.length > 1)
        throw new Error("Cannot use more than one escape character");
      m = u.escape(m), g = new RegExp(
        `(?:${m}[\\S\\s]|(?:(?!${// Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
        // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
        // transformation resulting from those flags was already applied to `left` and
        // `right` when they were passed through the XRegExp constructor above.
        u.union([n, D], "", { conjunction: "or" }).source})[^${m}])+)+`,
        // Flags `dgy` not needed here
        s.replace(u._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, "")
      );
    }
    let v = 0, l = 0, p = 0, h = 0, E, w, C, d;
    const f = i.valueNames, B = [];
    for (; ; ) {
      if (m && (p += (u.exec(t, g, p, "sticky") || [""])[0].length), C = u.exec(t, n, p), d = u.exec(t, D, p), C && d && (C.index <= d.index ? d = null : C = null), C || d)
        l = (C || d).index, p = l + (C || d)[0].length;
      else if (!v)
        break;
      if (o && !v && l > h)
        break;
      if (C)
        v || (E = l, w = p), v += 1;
      else if (d && v) {
        if (v -= 1, !v && (f ? (f[0] && E > h && B.push(e(f[0], t.slice(h, E), h, E)), f[1] && B.push(e(f[1], t.slice(E, w), E, w)), f[2] && B.push(e(f[2], t.slice(w, l), w, l)), f[3] && B.push(e(f[3], t.slice(l, p), l, p))) : B.push(t.slice(w, l)), h = p, !a))
          break;
      } else {
        const j = i.unbalanced || "error";
        if (j === "skip" || j === "skip-lazy")
          if (d)
            d = null;
          else {
            if (j === "skip") {
              const I = u.exec(t, n, E, "sticky")[0].length;
              p = E + (I || 1);
            } else
              p = E + 1;
            v = 0;
          }
        else if (j === "error") {
          const I = d ? "right" : "left", T = d ? l : E;
          throw new Error(`Unbalanced ${I} delimiter found in string at position ${T}`);
        } else
          throw new Error(`Unsupported value for unbalanced: ${j}`);
      }
      l === p && (p += 1);
    }
    return a && B.length > 0 && !o && f && f[0] && t.length > h && B.push(e(f[0], t.slice(h), h, t.length)), B;
  };
};
/*!
 * XRegExp Unicode Base 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */
const Ps = (u) => {
  const e = {}, t = {}, n = u._dec, D = u._hex, s = u._pad4;
  function i(v) {
    return v.replace(/[- _]+/g, "").toLowerCase();
  }
  function a(v) {
    const l = /^\\[xu](.+)/.exec(v);
    return l ? n(l[1]) : v.charCodeAt(v[0] === "\\" ? 1 : 0);
  }
  function o(v) {
    let l = "", p = -1;
    return u.forEach(
      v,
      /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,
      (h) => {
        const E = a(h[1]);
        E > p + 1 && (l += `\\u${s(D(p + 1))}`, E > p + 2 && (l += `-\\u${s(D(E - 1))}`)), p = a(h[2] || h[1]);
      }
    ), p < 65535 && (l += `\\u${s(D(p + 1))}`, p < 65534 && (l += "-\\uFFFF")), l;
  }
  function c(v) {
    const l = "b!";
    return e[v][l] || (e[v][l] = o(e[v].bmp));
  }
  function g(v, l) {
    const p = e[v];
    let h = "";
    return p.bmp && !p.isBmpLast && (h = `[${p.bmp}]${p.astral ? "|" : ""}`), p.astral && (h += p.astral), p.isBmpLast && p.bmp && (h += `${p.astral ? "|" : ""}[${p.bmp}]`), l ? `(?:(?!${h})(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-￿]))` : `(?:${h})`;
  }
  function m(v, l) {
    const p = l ? "a!" : "a=";
    return e[v][p] || (e[v][p] = g(v, l));
  }
  u.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/,
    (v, l, p) => {
      const h = "Invalid double negation ", E = "Unknown Unicode token ", w = "Unicode token missing data ", C = "Astral mode required for Unicode token ", d = "Astral mode does not support Unicode tokens within character classes", [
        f,
        B,
        j,
        I,
        T,
        q
      ] = v;
      let V = B === "P" || !!j;
      const X = p.includes("A");
      let G = i(q || T), J = e[G];
      if (B === "P" && j)
        throw new SyntaxError(h + f);
      if (!e.hasOwnProperty(G))
        throw new SyntaxError(E + f);
      if (I && !(t[I] && t[I][G]))
        throw new SyntaxError(E + f);
      if (J.inverseOf) {
        if (G = i(J.inverseOf), !e.hasOwnProperty(G))
          throw new ReferenceError(`${w + f} -> ${J.inverseOf}`);
        J = e[G], V = !V;
      }
      if (!(J.bmp || X))
        throw new SyntaxError(C + f);
      if (X) {
        if (l === "class")
          throw new SyntaxError(d);
        return m(G, V);
      }
      return l === "class" ? V ? c(G) : J.bmp : `${(V ? "[^" : "[") + J.bmp}]`;
    },
    {
      scope: "all",
      optionalFlags: "A",
      leadChar: "\\"
    }
  ), u.addUnicodeData = (v, l) => {
    const p = "Unicode token requires name", h = "Unicode token has no character data ";
    l && (t[l] = {});
    for (const E of v) {
      if (!E.name)
        throw new Error(p);
      if (!(E.inverseOf || E.bmp || E.astral))
        throw new Error(h + E.name);
      const w = i(E.name);
      if (e[w] = E, l && (t[l][w] = !0), E.alias) {
        const C = i(E.alias);
        e[C] = E, l && (t[l][C] = !0);
      }
    }
    u.cache.flush("patterns");
  }, u._getUnicodeProperty = (v) => {
    const l = i(v);
    return e[l];
  };
};
var Rs = [
  {
    name: "C",
    alias: "Other",
    isBmpLast: !0,
    bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
    astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCBD\uDCC3-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]"
  },
  {
    name: "Cc",
    alias: "Control",
    bmp: "\0--"
  },
  {
    name: "Cf",
    alias: "Format",
    bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯\uFEFF￹-￻",
    astral: "\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]"
  },
  {
    name: "Cn",
    alias: "Unassigned",
    bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
    astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCC3-\uDCCC\uDCCE\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F\uDC39-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]"
  },
  {
    name: "Co",
    alias: "Private_Use",
    bmp: "-",
    astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]"
  },
  {
    name: "Cs",
    alias: "Surrogate",
    bmp: "\uD800-\uDFFF"
  },
  {
    name: "L",
    alias: "Letter",
    bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "LC",
    alias: "Cased_Letter",
    bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
    astral: "\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD81B[\uDE40-\uDE7F]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD00-\uDD43]"
  },
  {
    name: "Ll",
    alias: "Lowercase_Letter",
    bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
    astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
  },
  {
    name: "Lm",
    alias: "Modifier_Letter",
    bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
    astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD838[\uDD37-\uDD3D]|𞥋"
  },
  {
    name: "Lo",
    alias: "Other_Letter",
    bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF4A\uDF50]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|𝼊|\uD838[\uDD00-\uDD2C\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Lt",
    alias: "Titlecase_Letter",
    bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
  },
  {
    name: "Lu",
    alias: "Uppercase_Letter",
    bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
    astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]"
  },
  {
    name: "M",
    alias: "Mark",
    bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
    astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "Mc",
    alias: "Spacing_Mark",
    bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
    astral: "\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD30-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]"
  },
  {
    name: "Me",
    alias: "Enclosing_Mark",
    bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
  },
  {
    name: "Mn",
    alias: "Nonspacing_Mark",
    bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
    astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "N",
    alias: "Number",
    bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
    astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]"
  },
  {
    name: "Nd",
    alias: "Decimal_Number",
    bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
    astral: "\uD801[\uDCA0-\uDCA9]|\uD803[\uDD30-\uDD39]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9\uDD50-\uDD59]|\uD807[\uDC50-\uDC59\uDD50-\uDD59\uDDA0-\uDDA9]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDD50-\uDD59]|\uD83E[\uDFF0-\uDFF9]"
  },
  {
    name: "Nl",
    alias: "Letter_Number",
    bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
    astral: "\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]"
  },
  {
    name: "No",
    alias: "Other_Number",
    bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
    astral: "\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C\uDFC0-\uDFD4]|\uD81A[\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD83A[\uDCC7-\uDCCF]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]"
  },
  {
    name: "P",
    alias: "Punctuation",
    bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
    astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
  },
  {
    name: "Pc",
    alias: "Connector_Punctuation",
    bmp: "_‿⁀⁔︳︴﹍-﹏＿"
  },
  {
    name: "Pd",
    alias: "Dash_Punctuation",
    bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
    astral: "𐺭"
  },
  {
    name: "Pe",
    alias: "Close_Punctuation",
    bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
  },
  {
    name: "Pf",
    alias: "Final_Punctuation",
    bmp: "»’”›⸃⸅⸊⸍⸝⸡"
  },
  {
    name: "Pi",
    alias: "Initial_Punctuation",
    bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
  },
  {
    name: "Po",
    alias: "Other_Punctuation",
    bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
    astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
  },
  {
    name: "Ps",
    alias: "Open_Punctuation",
    bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
  },
  {
    name: "S",
    alias: "Symbol",
    bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
    astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
  },
  {
    name: "Sc",
    alias: "Currency_Symbol",
    bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
    astral: "\uD807[\uDFDD-\uDFE0]|𞋿|𞲰"
  },
  {
    name: "Sk",
    alias: "Modifier_Symbol",
    bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
    astral: "\uD83C[\uDFFB-\uDFFF]"
  },
  {
    name: "Sm",
    alias: "Math_Symbol",
    bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
    astral: "\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]"
  },
  {
    name: "So",
    alias: "Other_Symbol",
    bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
    astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|𞅏|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
  },
  {
    name: "Z",
    alias: "Separator",
    bmp: "    - \u2028\u2029  　"
  },
  {
    name: "Zl",
    alias: "Line_Separator",
    bmp: "\u2028"
  },
  {
    name: "Zp",
    alias: "Paragraph_Separator",
    bmp: "\u2029"
  },
  {
    name: "Zs",
    alias: "Space_Separator",
    bmp: "    -   　"
  }
];
const Is = /* @__PURE__ */ ne(Rs);
/*!
 * XRegExp Unicode Categories 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const Os = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
  u.addUnicodeData(Is);
};
var Ls = [
  {
    name: "ASCII",
    bmp: "\0-"
  },
  {
    name: "Alphabetic",
    bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC45\uDC71-\uDC75\uDC82-\uDCB8\uDCC2\uDCD0-\uDCE8\uDD00-\uDD32\uDD44-\uDD47\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDCE\uDDCF\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2A\uDF40-\uDF46]|\uD806[\uDC00-\uDC38\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B\uDD3C\uDD3F-\uDD42\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDDF\uDDE1\uDDE3\uDDE4\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE97\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD96\uDD98\uDEE0-\uDEF6\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Any",
    isBmpLast: !0,
    bmp: "\0-￿",
    astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]"
  },
  {
    name: "Default_Ignorable_Code_Point",
    bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️\uFEFFﾠ￰-￸",
    astral: "\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]"
  },
  {
    name: "Lowercase",
    bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
    astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDF80\uDF83-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
  },
  {
    name: "Noncharacter_Code_Point",
    bmp: "﷐-﷯￾￿",
    astral: "[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]"
  },
  {
    name: "Uppercase",
    bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
    astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]"
  },
  {
    name: "White_Space",
    bmp: "	-\r    - \u2028\u2029  　"
  }
];
const Ms = /* @__PURE__ */ ne(Ls);
/*!
 * XRegExp Unicode Properties 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const zs = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
  const e = Ms;
  e.push({
    name: "Assigned",
    // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
    // Categories addon is required to use this property
    inverseOf: "Cn"
  }), u.addUnicodeData(e);
};
var Us = [
  {
    name: "Adlam",
    astral: "\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]"
  },
  {
    name: "Ahom",
    astral: "\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF46]"
  },
  {
    name: "Anatolian_Hieroglyphs",
    astral: "\uD811[\uDC00-\uDE46]"
  },
  {
    name: "Arabic",
    bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
    astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]"
  },
  {
    name: "Armenian",
    bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
  },
  {
    name: "Avestan",
    astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]"
  },
  {
    name: "Balinese",
    bmp: "ᬀ-ᭌ᭐-᭾"
  },
  {
    name: "Bamum",
    bmp: "ꚠ-꛷",
    astral: "\uD81A[\uDC00-\uDE38]"
  },
  {
    name: "Bassa_Vah",
    astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]"
  },
  {
    name: "Batak",
    bmp: "ᯀ-᯳᯼-᯿"
  },
  {
    name: "Bengali",
    bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
  },
  {
    name: "Bhaiksuki",
    astral: "\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]"
  },
  {
    name: "Bopomofo",
    bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
  },
  {
    name: "Brahmi",
    astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC75\uDC7F]"
  },
  {
    name: "Braille",
    bmp: "⠀-⣿"
  },
  {
    name: "Buginese",
    bmp: "ᨀ-ᨛ᨞᨟"
  },
  {
    name: "Buhid",
    bmp: "ᝀ-ᝓ"
  },
  {
    name: "Canadian_Aboriginal",
    bmp: "᐀-ᙿᢰ-ᣵ",
    astral: "\uD806[\uDEB0-\uDEBF]"
  },
  {
    name: "Carian",
    astral: "\uD800[\uDEA0-\uDED0]"
  },
  {
    name: "Caucasian_Albanian",
    astral: "\uD801[\uDD30-\uDD63\uDD6F]"
  },
  {
    name: "Chakma",
    astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD47]"
  },
  {
    name: "Cham",
    bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
  },
  {
    name: "Cherokee",
    bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
  },
  {
    name: "Chorasmian",
    astral: "\uD803[\uDFB0-\uDFCB]"
  },
  {
    name: "Common",
    bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫\uFEFF！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
    astral: "\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9C\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDEE0-\uDEF3\uDF00-\uDF56\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83B[\uDC71-\uDCB4\uDD01-\uDD3D]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDDAD\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA\uDFF0-\uDFF9]|\uDB40[\uDC01\uDC20-\uDC7F]"
  },
  {
    name: "Coptic",
    bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
  },
  {
    name: "Cuneiform",
    astral: "\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]"
  },
  {
    name: "Cypriot",
    astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]"
  },
  {
    name: "Cypro_Minoan",
    astral: "\uD80B[\uDF90-\uDFF2]"
  },
  {
    name: "Cyrillic",
    bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
  },
  {
    name: "Deseret",
    astral: "\uD801[\uDC00-\uDC4F]"
  },
  {
    name: "Devanagari",
    bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
  },
  {
    name: "Dives_Akuru",
    astral: "\uD806[\uDD00-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDD50-\uDD59]"
  },
  {
    name: "Dogra",
    astral: "\uD806[\uDC00-\uDC3B]"
  },
  {
    name: "Duployan",
    astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]"
  },
  {
    name: "Egyptian_Hieroglyphs",
    astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E\uDC30-\uDC38]"
  },
  {
    name: "Elbasan",
    astral: "\uD801[\uDD00-\uDD27]"
  },
  {
    name: "Elymaic",
    astral: "\uD803[\uDFE0-\uDFF6]"
  },
  {
    name: "Ethiopic",
    bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
    astral: "\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]"
  },
  {
    name: "Georgian",
    bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
  },
  {
    name: "Glagolitic",
    bmp: "Ⰰ-ⱟ",
    astral: "\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]"
  },
  {
    name: "Gothic",
    astral: "\uD800[\uDF30-\uDF4A]"
  },
  {
    name: "Grantha",
    astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]"
  },
  {
    name: "Greek",
    bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
    astral: "\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]"
  },
  {
    name: "Gujarati",
    bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
  },
  {
    name: "Gunjala_Gondi",
    astral: "\uD807[\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9]"
  },
  {
    name: "Gurmukhi",
    bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
  },
  {
    name: "Han",
    bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
    astral: "\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
  },
  {
    name: "Hangul",
    bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
  },
  {
    name: "Hanifi_Rohingya",
    astral: "\uD803[\uDD00-\uDD27\uDD30-\uDD39]"
  },
  {
    name: "Hanunoo",
    bmp: "ᜠ-᜴"
  },
  {
    name: "Hatran",
    astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]"
  },
  {
    name: "Hebrew",
    bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
  },
  {
    name: "Hiragana",
    bmp: "ぁ-ゖゝ-ゟ",
    astral: "\uD82C[\uDC01-\uDD1F\uDD50-\uDD52]|🈀"
  },
  {
    name: "Imperial_Aramaic",
    astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]"
  },
  {
    name: "Inherited",
    bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
    astral: "\uD800[\uDDFD\uDEE0]|𑌻|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]"
  },
  {
    name: "Inscriptional_Pahlavi",
    astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]"
  },
  {
    name: "Inscriptional_Parthian",
    astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]"
  },
  {
    name: "Javanese",
    bmp: "ꦀ-꧍꧐-꧙꧞꧟"
  },
  {
    name: "Kaithi",
    astral: "\uD804[\uDC80-\uDCC2\uDCCD]"
  },
  {
    name: "Kannada",
    bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
  },
  {
    name: "Katakana",
    bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
    astral: "\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00\uDD20-\uDD22\uDD64-\uDD67]"
  },
  {
    name: "Kayah_Li",
    bmp: "꤀-꤭꤯"
  },
  {
    name: "Kharoshthi",
    astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58]"
  },
  {
    name: "Khitan_Small_Script",
    astral: "𖿤|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDCD5]"
  },
  {
    name: "Khmer",
    bmp: "ក-៝០-៩៰-៹᧠-᧿"
  },
  {
    name: "Khojki",
    astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3E]"
  },
  {
    name: "Khudawadi",
    astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]"
  },
  {
    name: "Lao",
    bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
  },
  {
    name: "Latin",
    bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
    astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD837[\uDF00-\uDF1E]"
  },
  {
    name: "Lepcha",
    bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
  },
  {
    name: "Limbu",
    bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
  },
  {
    name: "Linear_A",
    astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]"
  },
  {
    name: "Linear_B",
    astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]"
  },
  {
    name: "Lisu",
    bmp: "ꓐ-꓿",
    astral: "𑾰"
  },
  {
    name: "Lycian",
    astral: "\uD800[\uDE80-\uDE9C]"
  },
  {
    name: "Lydian",
    astral: "\uD802[\uDD20-\uDD39\uDD3F]"
  },
  {
    name: "Mahajani",
    astral: "\uD804[\uDD50-\uDD76]"
  },
  {
    name: "Makasar",
    astral: "\uD807[\uDEE0-\uDEF8]"
  },
  {
    name: "Malayalam",
    bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
  },
  {
    name: "Mandaic",
    bmp: "ࡀ-࡛࡞"
  },
  {
    name: "Manichaean",
    astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]"
  },
  {
    name: "Marchen",
    astral: "\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]"
  },
  {
    name: "Masaram_Gondi",
    astral: "\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]"
  },
  {
    name: "Medefaidrin",
    astral: "\uD81B[\uDE40-\uDE9A]"
  },
  {
    name: "Meetei_Mayek",
    bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
  },
  {
    name: "Mende_Kikakui",
    astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]"
  },
  {
    name: "Meroitic_Cursive",
    astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]"
  },
  {
    name: "Meroitic_Hieroglyphs",
    astral: "\uD802[\uDD80-\uDD9F]"
  },
  {
    name: "Miao",
    astral: "\uD81B[\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F]"
  },
  {
    name: "Modi",
    astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]"
  },
  {
    name: "Mongolian",
    bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
    astral: "\uD805[\uDE60-\uDE6C]"
  },
  {
    name: "Mro",
    astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]"
  },
  {
    name: "Multani",
    astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]"
  },
  {
    name: "Myanmar",
    bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
  },
  {
    name: "Nabataean",
    astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]"
  },
  {
    name: "Nandinagari",
    astral: "\uD806[\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4]"
  },
  {
    name: "New_Tai_Lue",
    bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
  },
  {
    name: "Newa",
    astral: "\uD805[\uDC00-\uDC5B\uDC5D-\uDC61]"
  },
  {
    name: "Nko",
    bmp: "߀-ߺ߽-߿"
  },
  {
    name: "Nushu",
    astral: "𖿡|\uD82C[\uDD70-\uDEFB]"
  },
  {
    name: "Nyiakeng_Puachue_Hmong",
    astral: "\uD838[\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDD4F]"
  },
  {
    name: "Ogham",
    bmp: " -᚜"
  },
  {
    name: "Ol_Chiki",
    bmp: "᱐-᱿"
  },
  {
    name: "Old_Hungarian",
    astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]"
  },
  {
    name: "Old_Italic",
    astral: "\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]"
  },
  {
    name: "Old_North_Arabian",
    astral: "\uD802[\uDE80-\uDE9F]"
  },
  {
    name: "Old_Permic",
    astral: "\uD800[\uDF50-\uDF7A]"
  },
  {
    name: "Old_Persian",
    astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]"
  },
  {
    name: "Old_Sogdian",
    astral: "\uD803[\uDF00-\uDF27]"
  },
  {
    name: "Old_South_Arabian",
    astral: "\uD802[\uDE60-\uDE7F]"
  },
  {
    name: "Old_Turkic",
    astral: "\uD803[\uDC00-\uDC48]"
  },
  {
    name: "Old_Uyghur",
    astral: "\uD803[\uDF70-\uDF89]"
  },
  {
    name: "Oriya",
    bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
  },
  {
    name: "Osage",
    astral: "\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]"
  },
  {
    name: "Osmanya",
    astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]"
  },
  {
    name: "Pahawh_Hmong",
    astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]"
  },
  {
    name: "Palmyrene",
    astral: "\uD802[\uDC60-\uDC7F]"
  },
  {
    name: "Pau_Cin_Hau",
    astral: "\uD806[\uDEC0-\uDEF8]"
  },
  {
    name: "Phags_Pa",
    bmp: "ꡀ-꡷"
  },
  {
    name: "Phoenician",
    astral: "\uD802[\uDD00-\uDD1B\uDD1F]"
  },
  {
    name: "Psalter_Pahlavi",
    astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]"
  },
  {
    name: "Rejang",
    bmp: "ꤰ-꥓꥟"
  },
  {
    name: "Runic",
    bmp: "ᚠ-ᛪᛮ-ᛸ"
  },
  {
    name: "Samaritan",
    bmp: "ࠀ-࠭࠰-࠾"
  },
  {
    name: "Saurashtra",
    bmp: "ꢀ-ꣅ꣎-꣙"
  },
  {
    name: "Sharada",
    astral: "\uD804[\uDD80-\uDDDF]"
  },
  {
    name: "Shavian",
    astral: "\uD801[\uDC50-\uDC7F]"
  },
  {
    name: "Siddham",
    astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]"
  },
  {
    name: "SignWriting",
    astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]"
  },
  {
    name: "Sinhala",
    bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
    astral: "\uD804[\uDDE1-\uDDF4]"
  },
  {
    name: "Sogdian",
    astral: "\uD803[\uDF30-\uDF59]"
  },
  {
    name: "Sora_Sompeng",
    astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]"
  },
  {
    name: "Soyombo",
    astral: "\uD806[\uDE50-\uDEA2]"
  },
  {
    name: "Sundanese",
    bmp: "ᮀ-ᮿ᳀-᳇"
  },
  {
    name: "Syloti_Nagri",
    bmp: "ꠀ-꠬"
  },
  {
    name: "Syriac",
    bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
  },
  {
    name: "Tagalog",
    bmp: "ᜀ-᜕ᜟ"
  },
  {
    name: "Tagbanwa",
    bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
  },
  {
    name: "Tai_Le",
    bmp: "ᥐ-ᥭᥰ-ᥴ"
  },
  {
    name: "Tai_Tham",
    bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
  },
  {
    name: "Tai_Viet",
    bmp: "ꪀ-ꫂꫛ-꫟"
  },
  {
    name: "Takri",
    astral: "\uD805[\uDE80-\uDEB9\uDEC0-\uDEC9]"
  },
  {
    name: "Tamil",
    bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
    astral: "\uD807[\uDFC0-\uDFF1\uDFFF]"
  },
  {
    name: "Tangsa",
    astral: "\uD81A[\uDE70-\uDEBE\uDEC0-\uDEC9]"
  },
  {
    name: "Tangut",
    astral: "𖿠|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEFF]|\uD823[\uDD00-\uDD08]"
  },
  {
    name: "Telugu",
    bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
  },
  {
    name: "Thaana",
    bmp: "ހ-ޱ"
  },
  {
    name: "Thai",
    bmp: "ก-ฺเ-๛"
  },
  {
    name: "Tibetan",
    bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
  },
  {
    name: "Tifinagh",
    bmp: "ⴰ-ⵧⵯ⵰⵿"
  },
  {
    name: "Tirhuta",
    astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]"
  },
  {
    name: "Toto",
    astral: "\uD838[\uDE90-\uDEAE]"
  },
  {
    name: "Ugaritic",
    astral: "\uD800[\uDF80-\uDF9D\uDF9F]"
  },
  {
    name: "Vai",
    bmp: "ꔀ-ꘫ"
  },
  {
    name: "Vithkuqi",
    astral: "\uD801[\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]"
  },
  {
    name: "Wancho",
    astral: "\uD838[\uDEC0-\uDEF9\uDEFF]"
  },
  {
    name: "Warang_Citi",
    astral: "\uD806[\uDCA0-\uDCF2\uDCFF]"
  },
  {
    name: "Yezidi",
    astral: "\uD803[\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1]"
  },
  {
    name: "Yi",
    bmp: "ꀀ-ꒌ꒐-꓆"
  },
  {
    name: "Zanabazar_Square",
    astral: "\uD806[\uDE00-\uDE47]"
  }
];
const Hs = /* @__PURE__ */ ne(Us);
/*!
 * XRegExp Unicode Scripts 5.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const Vs = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
  u.addUnicodeData(Hs, "Script");
};
ks(k);
Ts(k);
Ps(k);
Os(k);
zs(k);
Vs(k);
const Ws = k(
  // prettier-ignore
  /@\[(\d+)\]\(([^)]+)\)+/i
), Gs = k(
  // prettier-ignore
  // eslint-disable-next-line no-useless-escape
  /@\[(urn:li:(organization|person):[A-Za-z0-9\_\-]+)\]\(([^)]+)\)+/i
), Ys = k(
  // prettier-ignore
  /(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i
), qs = k(
  // prettier-ignore
  /(#+[a-zA-Z0-9(_)]{1,})/i
);
function Zs({
  host: u,
  tag: e,
  label: t
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${u}${e}`, children: t }, t);
}
function Ks({
  label: u
}) {
  return /* @__PURE__ */ r.jsx("span", { children: u }, `unknown-${u}`);
}
class Xs extends Se {
  constructor(e, t) {
    super(e), this.targetPlatform = t;
  }
  match(e) {
    const t = e.match(qs);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      urn: t[0],
      label: t[0],
      valid: !0
    };
  }
  replaceWith(e, t) {
    let {
      label: n
    } = t;
    const D = n.replace("#", "");
    let s;
    switch (this.targetPlatform) {
      case "IG":
        s = "https://www.instagram.com/explore/tags/";
        break;
      case "TW":
        s = "https://twitter.com/hashtag/";
        break;
      case "TH":
        s = "https://threads.net/search?q=", n = n.replace("#", "");
        break;
      case "LI":
        s = "https://www.linkedin.com/feed/hashtag/";
        break;
      case "TT":
        s = "https://www.tiktok.com/tag/";
        break;
      case "FB":
        s = "https://www.facebook.com/hashtag/";
        break;
      default:
        s = null;
    }
    return s ? Eu.createElement(Zs, {
      tag: D,
      host: s,
      label: n
    }, e) : Eu.createElement(Ks, {
      label: n
    }, e);
  }
  asTag() {
    return "a";
  }
}
function Js({
  host: u,
  username: e,
  label: t
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${u}/${e}`, children: t }, t);
}
class Qs extends Se {
  constructor(e, t) {
    super(e), this.targetPlatform = t;
  }
  match(e) {
    const t = e.match(Ys);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      urn: t[0],
      label: t[0],
      valid: !0
    };
  }
  replaceWith(e, t) {
    const {
      label: n
    } = t;
    let D = "";
    switch (this.targetPlatform) {
      case "IG":
        D = "https://instagram.com";
        break;
      case "TW":
        D = "https://twitter.com";
        break;
      case "TH":
        D = "https://threads.net";
        break;
      case "TT":
        D = "https://tiktok.com";
        break;
      case "PI":
        D = "https://pinterest.com";
        break;
      default:
        throw new Error(`Unsupported "targetPlatform": ${this.targetPlatform}`);
    }
    return Eu.createElement(Js, _u(U({}, t), {
      host: D,
      username: n
    }), e);
  }
  asTag() {
    return "a";
  }
}
function ui({
  urn: u,
  label: e,
  orgId: t,
  trackEvent: n
}) {
  return /* @__PURE__ */ r.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `LinkedIn organization: ${u}`, onClick: () => {
    n && n("link-preview-clicked"), window.open(`https://www.linkedin.com/company/${t}`, "_blank");
  }, children: e }, u);
}
function ei({
  label: u,
  urn: e
}) {
  return /* @__PURE__ */ r.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `Person mention for ${u}. Sked currently can't link you directly to the person's profile.`, children: u }, `unknown-${e}${u}`);
}
class ti extends Se {
  constructor(e, t, n) {
    super(e), this.targetPlatform = t, this.trackEvent = n;
  }
  match(e) {
    const t = e.match(Gs);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      urn: t[1],
      label: t[3],
      valid: !0
    };
  }
  replaceWith(e, t) {
    const {
      urn: n,
      label: D
    } = t;
    if (this.targetPlatform === "LI" && n.includes("organization")) {
      const s = n.split(":").pop();
      return Eu.createElement(ui, {
        urn: n,
        label: D,
        orgId: s,
        trackEvent: this.trackEvent
      }, e);
    } else
      return Eu.createElement(ei, {
        urn: n,
        label: D,
        trackEvent: this.trackEvent
      }, e);
  }
  asTag() {
    return "span";
  }
}
function y0({
  id: u,
  label: e
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link sked-mention-facebook", target: "_blank", rel: "noreferrer", href: `https://www.facebook.com/${u}`, children: e }, e);
}
class ri extends Se {
  constructor(e, t) {
    super(e), this.targetPlatform = t;
  }
  match(e) {
    const t = e.match(Ws);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      id: t[1],
      label: t[2],
      valid: !0
    };
  }
  replaceWith(e, t) {
    return this.targetPlatform === "FB" ? Eu.createElement(y0, t, e) : Eu.createElement(y0, t, e);
  }
  asTag() {
    return "a";
  }
}
function ni(u, e) {
  u === void 0 && (u = "");
  const t = [new Bs("url"), new Xs("hashtag", u)];
  switch (u) {
    case "IG":
    case "TW":
    case "TT":
    case "TH":
    case "PI":
      return [new Qs("socialLink", u), ...t];
    default:
      return [new ri("fb", u), new ti("li", u, e), ...t];
  }
}
function Nu({
  caption: u,
  targetPlatform: e,
  trackEvent: t
}) {
  const n = u, D = ni(e, t);
  return /* @__PURE__ */ r.jsx(cs, { content: n, matchers: D, newWindow: !0 });
}
function wl({
  caption: u,
  targetPlatform: e
}) {
  return /* @__PURE__ */ r.jsx(Di, { children: /* @__PURE__ */ r.jsx(Nu, { caption: u, targetPlatform: e }) });
}
const Di = b.div`
  .sked-mention {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, si = b.a`
  display: ${(u) => u.$isFlex ? "flex" : "inline-flex"};
  width: 100%;
  margin: auto;
`, Mu = ({
  children: u,
  href: e,
  target: t = "_blank",
  $isFlex: n = !1
}) => /* @__PURE__ */ r.jsx(si, { $isFlex: n, href: e, target: t, rel: "noreferrer", children: u }), vr = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 36, height: 34, viewBox: "0 0 36 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M2.33301 13.6667C2.33301 13.6667 5.67464 9.1137 8.3894 6.39707C11.1042 3.68045 14.8557 2 18.9997 2C27.2839 2 33.9997 8.71573 33.9997 17C33.9997 25.2843 27.2839 32 18.9997 32C12.1612 32 6.39153 27.4238 4.58595 21.1667M2.33301 13.6667V3.66667M2.33301 13.6667H12.333", stroke: "white", strokeWidth: 3.33333, strokeLinecap: "round", strokeLinejoin: "round" })), ii = ({
  src: u
}) => /* @__PURE__ */ r.jsx(Mu, { $isFlex: !0, href: u, children: /* @__PURE__ */ r.jsx(ci, { src: u }) }), ai = ({
  url: u,
  isActiveSlide: e = !0,
  videoRef: t,
  containerStyles: n
}) => {
  const [D, s] = ju(!1), [i, a] = ju(!1), [o, c] = ju(0), {
    videoCoverPreview: g,
    post: m
  } = Ke(Jr);
  if (Zu(() => {
    g && (s(!1), a(!1), c((p) => p + 1));
  }, [g]), !e)
    return null;
  const v = g !== void 0 && ((m == null ? void 0 : m.type) === "reel" || (m == null ? void 0 : m.storyType) === "reel"), l = /* @__PURE__ */ r.jsxs(Fi, { ref: t, style: n, $showVideoCover: v, children: [
    v && !D && i && /* @__PURE__ */ r.jsx(li, { children: /* @__PURE__ */ r.jsx(vr, { onClick: () => {
      s(!1), a(!1), c((p) => p + 1);
    } }) }),
    /* @__PURE__ */ r.jsx(Ru, { playing: !0, onPlay: () => {
      s(!0), a(!0);
    }, onPause: () => s(!1), light: v ? g : void 0, controls: !0, url: u, className: "sp-relative sp-w-full react-player", width: "100%", height: "auto", style: v ? {
      display: "flex",
      placeContent: "center",
      minHeight: "500px",
      background: "grey",
      position: "absolute",
      top: 0,
      left: 0
    } : {
      display: "flex",
      position: "absolute",
      top: 0,
      left: 0
    } }, o)
  ] });
  return v ? /* @__PURE__ */ r.jsx(oi, { children: l }) : l;
}, oi = b.div`
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 711px;
  width: 100%;
  height: calc((100vh - 270px) - 1rem);
  background: grey;
  display: flex;
`, li = b.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, Ne = ({
  media: u,
  isActiveSlide: e = !0,
  videoRef: t,
  videoContainerStyles: n
}) => u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(ai, { videoRef: t, url: u.url, isActiveSlide: e, containerStyles: n }) : /* @__PURE__ */ r.jsx(ii, { src: u.url }), ci = b.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, Fi = b.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100% !important;

  ${(u) => u.$showVideoCover && U0([".react-player__preview{height:calc(-270px - 1rem + 100vh) !important;background-repeat:no-repeat !important;}"])}
`, yr = (u) => /* @__PURE__ */ F.createElement("svg", U({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, u), /* @__PURE__ */ F.createElement("path", { d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z" })), wr = (u) => /* @__PURE__ */ F.createElement("svg", U({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, u), /* @__PURE__ */ F.createElement("path", { d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z" })), pe = ({
  direction: u,
  onClick: e
}) => /* @__PURE__ */ r.jsx(Ei, { direction: u, children: u === "left" ? /* @__PURE__ */ r.jsx(yr, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer", onClick: e }) : /* @__PURE__ */ r.jsx(wr, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer", onClick: e }) }), Ei = b.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(u) => u.direction === "left" ? "left: 1rem;" : "right: 1rem;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, Ci = ({
  media: u,
  slideNo: e,
  isActiveSlide: t,
  getVideoWrapHeight: n
}) => {
  const D = je(null), s = {
    order: e,
    flex: "1 0 100%"
  };
  return Zu(() => {
    setTimeout(() => {
      u.isVideo && D.current && n(D.current.clientHeight);
    }, 500);
  }), /* @__PURE__ */ r.jsx("div", { style: s, children: /* @__PURE__ */ r.jsx(Ne, { videoRef: D, media: u, isActiveSlide: t }) });
}, di = ({
  medias: u,
  currentSlide: e,
  getVideoWrapHeight: t
}) => u.map((n, D) => /* @__PURE__ */ r.jsx(Ci, { getVideoWrapHeight: t, media: n, slideNo: D + 1, isActiveSlide: e === D + 1 }, D)), Ai = ({
  current: u
}) => /* @__PURE__ */ r.jsx("div", { className: `${u ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), pi = ({
  count: u,
  current: e
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4", style: {
  marginBottom: "-42px",
  height: "42px"
}, children: [...Array(u)].map((t, n) => /* @__PURE__ */ r.jsx(Ai, { current: n + 1 === e }, n)) }), fi = ({
  medias: u,
  count: e,
  getIsFirstSlide: t
}) => {
  const [n, D] = ju(1), s = je(null);
  Zu(() => {
    n > u.length && D(u.length);
  }, [u.length]);
  const i = {
    left: "100%",
    transform: `translateX(${n * -100}%)`
  };
  Zu(() => {
    s.current.style.height = "auto", t && t(n === 1);
  }, [n]);
  const a = (o) => {
    s.current.style.height = o + "px";
  };
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      n !== 1 && /* @__PURE__ */ r.jsx(pe, { direction: "left", onClick: () => D(n - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative sp-items-center", style: i, ref: s, children: /* @__PURE__ */ r.jsx(di, { medias: u, currentSlide: n, getVideoWrapHeight: a }) }),
      n !== u.length && /* @__PURE__ */ r.jsx(pe, { direction: "right", onClick: () => D(n + 1) })
    ] }),
    /* @__PURE__ */ r.jsx(pi, { count: e, current: n })
  ] });
}, hi = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-p-4 sp-text-gray-800", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-grow sp-items-center", children: [
    /* @__PURE__ */ r.jsx(Le, { icon: "icon-instagram-heart", className: "sp-mr-6" }),
    /* @__PURE__ */ r.jsx(Le, { icon: "icon-instagram-comment", className: "sp-mr-6" }),
    /* @__PURE__ */ r.jsx(Le, { icon: "icon-instagram-share", className: "sp-mr-6" })
  ] }),
  /* @__PURE__ */ r.jsx(Le, { icon: "icon-instagram-bookmark" })
] }), Le = ({
  icon: u,
  className: e
}) => /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-items-center sp-justify-center ${e}`, children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-4xl sp-font-normal ${u}` }) }), mi = b.button`
  border: none;
  display: flex;
  align-items: center;
  background: #504e4c;
  border-radius: 4px;
  padding: 9px 7px;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-width: 100px;
  justify-content: center;

  svg {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 500;
    color: white;
    font-size: 12px;
  }
`, Bi = b.div`
  position: absolute;
  z-index: 2;
  top: ${(u) => u.top && u.top}%;
  left: ${(u) => u.left && u.left}%;
  font-family: Helvetica Neue;
  background: #504e4c;
  color: white;
  font-weight: 500;
  font-size: 14px;
  padding: 9px 13px;
  border-radius: 4px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #504e4c;
  }

  .sked-mention.sked-mention-link {
    color: white;
  }
`, gi = ({
  medias: u,
  storyType: e,
  productTags: t,
  userTags: n
}) => {
  const D = u.collection, s = D.length, i = s > 1, [a, o] = ju(!0);
  let c = t && t.length > 0 ? "productTags" : void 0;
  n && n.length > 0 && (c = "userTags");
  const g = c === "productTags" ? t : n, [m, v] = ju(!1);
  return /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
      e && e === "reel" && /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ r.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ r.jsx(WD, {}) }),
        /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " Reel"
        ] })
      ] }),
      e && e === "igtv" && /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ r.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ r.jsx(VD, {}) }),
        /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " IGTV"
        ] })
      ] }),
      a && g.length > 0 && /* @__PURE__ */ r.jsxs(mi, { onClick: () => v((l) => !l), children: [
        c === "productTags" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(HD, {}),
          /* @__PURE__ */ r.jsxs("p", { children: [
            m ? "Hide" : "Show",
            " product tags"
          ] })
        ] }),
        c === "userTags" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(GD, {}),
          /* @__PURE__ */ r.jsxs("p", { children: [
            m ? "Hide" : "Show",
            " user tags"
          ] })
        ] })
      ] }),
      g.length > 0 && m && /* @__PURE__ */ r.jsx("div", { children: g.map(({
        top: l,
        left: p,
        value: h
      }) => /* @__PURE__ */ r.jsx(Bi, { top: l, left: p, children: c === "userTags" ? /* @__PURE__ */ r.jsx(Nu, { caption: `@${h}`, targetPlatform: "IG" }) : h }, h)) }),
      /* @__PURE__ */ r.jsx("div", { onClick: () => v(!1), children: i ? /* @__PURE__ */ r.jsx(fi, { medias: D, count: s, getIsFirstSlide: (l) => {
        o(l);
      } }) : /* @__PURE__ */ r.jsx(Ne, { media: D[0] }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(hi, {}) })
  ] });
}, xi = ({
  post: u
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-flex sp-flex-col", children: [
  /* @__PURE__ */ r.jsx(er, { collabs: u.collaboratingIgUsers, username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
  /* @__PURE__ */ r.jsx(gi, { medias: u.medias, storyType: u.storyType || null, productTags: u.providedPost.productTags || [], userTags: u.providedPost.tags || [] }),
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: [
    /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-whitespace-pre-line sp-mb-2 sp-break-words", children: [
      /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
      /* @__PURE__ */ r.jsx(Nu, { caption: u.caption, targetPlatform: "IG" })
    ] }),
    u.comment && /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
      /* @__PURE__ */ r.jsx(Nu, { caption: u.comment, targetPlatform: "IG" })
    ] })
  ] })
] }), br = (u) => /* @__PURE__ */ F.createElement("svg", U({ viewBox: "0 0 33 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M13 0.463379L9 4.36582H3.23171C1.71834 4.36582 0.5 5.58417 0.5 7.09753L0.500002 27C0.500002 28.5134 1.71834 29.7317 3.23171 29.7317H29.7683C31.2817 29.7317 32.5 28.5134 32.5 27L32.5 7.09753C32.5 5.58417 31.2817 4.36582 29.7683 4.36582H24L20 0.463379H13ZM16.5 8.30487C21.0122 8.30487 24.6951 11.9878 24.6951 16.5C24.6951 21.0122 21.0122 24.6951 16.5 24.6951C11.9878 24.6951 8.30488 21.0122 8.30488 16.5C8.30488 11.9878 11.9879 8.30487 16.5 8.30487ZM16.5 10.6463C13.2533 10.6463 10.6463 13.2533 10.6463 16.5C10.6463 19.7467 13.2533 22.3537 16.5 22.3537C19.7468 22.3537 22.3537 19.7467 22.3537 16.5C22.3537 13.2533 19.7468 10.6463 16.5 10.6463Z", fill: "white" })), vi = (u) => /* @__PURE__ */ F.createElement("svg", U({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", fill: "#1a9bfb" }, u), /* @__PURE__ */ F.createElement("path", { d: "M 19.625 0.15625 C 17.996094 0.234375 16.429688 0.945313 15.21875 2.15625 L 10.46875 6.90625 C 11.214844 6.15625 13.984375 6.671875 14.65625 7.34375 L 17.53125 4.46875 C 18.167969 3.832031 18.964844 3.441406 19.78125 3.40625 C 20.335938 3.378906 21.121094 3.496094 21.8125 4.1875 C 22.457031 4.832031 22.59375 5.582031 22.59375 6.09375 C 22.59375 6.949219 22.203125 7.800781 21.53125 8.46875 L 16.53125 13.5 C 15.273438 14.757813 13.359375 14.859375 12.25 13.75 C 11.617188 13.117188 10.574219 13.113281 9.9375 13.75 C 9.300781 14.386719 9.300781 15.425781 9.9375 16.0625 C 11.078125 17.203125 12.578125 17.78125 14.125 17.78125 C 15.796875 17.78125 17.503906 17.097656 18.8125 15.78125 L 23.84375 10.78125 C 25.121094 9.507813 25.84375 7.804688 25.84375 6.09375 C 25.84375 4.503906 25.242188 2.992188 24.125 1.875 C 22.929688 0.679688 21.324219 0.078125 19.625 0.15625 Z M 11.875 8.21875 C 10.203125 8.21875 8.46875 8.90625 7.15625 10.21875 L 2.15625 15.21875 C 0.878906 16.492188 0.15625 18.195313 0.15625 19.90625 C 0.15625 21.496094 0.757813 23.007813 1.875 24.125 C 3.070313 25.320313 4.675781 25.921875 6.375 25.84375 C 8.003906 25.765625 9.570313 25.054688 10.78125 23.84375 L 15.53125 19.09375 C 14.78125 19.84375 12.015625 19.328125 11.34375 18.65625 L 8.46875 21.53125 C 7.832031 22.167969 7.035156 22.554688 6.21875 22.59375 C 5.664063 22.621094 4.878906 22.503906 4.1875 21.8125 C 3.542969 21.167969 3.40625 20.414063 3.40625 19.90625 C 3.40625 19.050781 3.796875 18.199219 4.46875 17.53125 L 9.46875 12.5 C 10.726563 11.242188 12.640625 11.144531 13.75 12.25 C 14.386719 12.886719 15.429688 12.886719 16.0625 12.25 C 16.699219 11.613281 16.699219 10.574219 16.0625 9.9375 C 14.921875 8.796875 13.417969 8.21875 11.875 8.21875 Z", fill: "#1a9bfb" })), yi = (u) => {
  try {
    const {
      hostname: e
    } = new URL(u);
    return e;
  } catch (e) {
    return "Error";
  }
}, wi = () => /* @__PURE__ */ r.jsx("div", { className: "sp-w-full sp-h-2 sp-overflow-hidden", style: {
  backgroundColor: "rgba(181, 180, 176, 0.4)"
}, children: /* @__PURE__ */ r.jsx("span", { className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75", style: {
  width: "33%"
}, children: " " }) }), bi = ({
  username: u,
  profilePicture: e,
  locationName: t
}) => /* @__PURE__ */ r.jsxs("section", { className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-my-3 sp-mx-2", children: /* @__PURE__ */ r.jsx(wi, {}) }),
  /* @__PURE__ */ r.jsx(er, { username: u, profilePicture: e, locationName: t, small: !0 })
] }), ji = () => /* @__PURE__ */ r.jsx("section", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-mb-6 sp-mx-4 sp-w-full sp-text-white", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-w-full", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2", style: {
      backgroundColor: "rgba(74, 85, 104, 0.7)"
    }, children: /* @__PURE__ */ r.jsx(br, { className: "sp-h-20px sp-w-20px" }) }),
    /* @__PURE__ */ r.jsx(te, { $variant: "caption", className: "sp-font-bold sp-pl-4", children: "Send message" })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-mx-8", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-fill-current sp-mr-3 icon-instagram-share sp-flex sp-text-4xl sp-mr-8" }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex sp-mr-3 sp-mr-4", children: [...Array(3)].map((u, e) => /* @__PURE__ */ r.jsx(Mi, {}, e)) })
  ] })
] }) }), Si = ({
  url: u,
  label: e,
  height: t
}) => /* @__PURE__ */ r.jsx(Ri, { className: "sp-bg-white sp-rounded-lg sp-w-auto sp-p-2 sp-items-center sp-absolute sp-z-10", height: t * 100, children: /* @__PURE__ */ r.jsx(Ii, { href: u, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-w-auto sp-flex sp-items-center sp-p-2", children: [
  /* @__PURE__ */ r.jsx(Li, { children: /* @__PURE__ */ r.jsx(vi, {}) }),
  /* @__PURE__ */ r.jsx(Oi, { children: e || yi(u) })
] }) }) }), jr = 6.5, _i = b.div`
  top: calc(
    ${(u) => u.height ? `${u.height + jr}% - ${u.height > 60 ? "140px" : "110px"}` : "0"}
  );
  position: absolute;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: ${(u) => u.height > 60 ? "column-reverse" : "column"};
`, Ni = b.div`
  width: 100%;
  height: 145px;
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
  display: flex;
  border-top: 1px dashed rgba(255, 255, 255, 0.2);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  div {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  }
`, $i = b.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  margin: 10px 0;
`, ki = b.p`
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  margin: 0;
`, Ti = b.div`
  width: 18px;
  height: 18px;
  background: #333;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  margin-left: 8px;
  position: relative;
  :hover {
    cursor: pointer;
    div {
      visibility: visible;
    }
  }
`, Pi = b.div`
  visibility: hidden;
  width: 340px;
  background-color: rgba(51, 51, 51, 1);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: ${(u) => u.height > 60 ? "-38px" : "28px"};
  right: -62px;
  &::after {
    content: "";
    position: absolute;
    bottom: ${(u) => u.height > 60 ? "-10px" : "29px"};
    right: 66px;
    rotate: ${(u) => u.height > 60 ? "180deg" : "0"};
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 1) transparent;
  }
`, Ri = b.div`
  top: calc(${(u) => u.height && u.height + jr}% - 60px);
  max-height: 60px;
  max-width: 80%;
`, Ii = b.a`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`, Oi = b.div`
  color: #1a9bfb;
  font-size: 28px;
  font-family: Aveny, arial, sans-serif;
  position: relative;
  top: 3.5px;
  text-transform: uppercase;
`, Li = b.div`
  display: grid;
  place-items: center;
  width: 25px;
  padding-right: 5px;
`, Mi = b.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 0.2rem;
`, Sr = ({
  post: u,
  media: e,
  isActiveSlide: t,
  env: n
}) => {
  const D = {
    paddingBottom: "55px"
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center sp-h-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full", children: [
      /* @__PURE__ */ r.jsx(bi, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
      u.storyUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        n === "schedugram-client" && /* @__PURE__ */ r.jsxs(_i, { height: (u.storyStickerHeight || 0.8) * 100, children: [
          /* @__PURE__ */ r.jsx(Ni, { children: /* @__PURE__ */ r.jsx("div", {}) }),
          /* @__PURE__ */ r.jsxs($i, { children: [
            /* @__PURE__ */ r.jsx(ki, { children: "Approx. Sticker placement area" }),
            /* @__PURE__ */ r.jsxs(Ti, { children: [
              "?",
              /* @__PURE__ */ r.jsx(Pi, { height: (u.storyStickerHeight || 0.8) * 100, children: "Sticker position is approximate, to be used as a guide only." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ r.jsx(Si, { url: u.storyUrl, label: u.storyLabel, height: u.storyStickerHeight || 0.8 })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ r.jsx(Ne, { media: e, isActiveSlide: t, videoContainerStyles: D }) }),
      /* @__PURE__ */ r.jsx(ji, {})
    ] }) }),
    u.caption && /* @__PURE__ */ r.jsxs(_r, { children: [
      /* @__PURE__ */ r.jsx("strong", { children: "Notes for manual Publishing: " }),
      u.caption
    ] })
  ] });
}, _r = b.p`
  max-width: 358px;
  margin: 14px auto 0;
  font-size: 14px;
`, zi = ({
  post: u,
  media: e,
  slideNo: t,
  isActiveSlide: n
}) => {
  const D = {
    order: t,
    flex: "1 0 100%"
  };
  return /* @__PURE__ */ r.jsx("div", { style: D, children: /* @__PURE__ */ r.jsx(Sr, { post: u, media: e, isActiveSlide: n }) });
}, Ui = ({
  post: u,
  stories: e,
  currentSlide: t
}) => e.map((n, D) => /* @__PURE__ */ r.jsx(zi, { post: u, media: n, slideNo: D + 1, isActiveSlide: t === D + 1 }, D)), Hi = ({
  post: u,
  stories: e,
  count: t
}) => {
  const [n, D] = ju(1), s = 1, i = t;
  Zu(() => {
    D(1);
  }, [u]);
  const a = {
    left: "100%",
    transform: `translateX(${n * -100}%)`
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      s === n || /* @__PURE__ */ r.jsx(pe, { direction: "left", onClick: () => D(n - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative", style: a, children: /* @__PURE__ */ r.jsx(Ui, { post: u, stories: e, currentSlide: n }) }),
      i === n || /* @__PURE__ */ r.jsx(pe, { direction: "right", onClick: () => D(n + 1) })
    ] }),
    u.caption && /* @__PURE__ */ r.jsxs(_r, { children: [
      /* @__PURE__ */ r.jsx("strong", { children: "Notes for manual Publishing: " }),
      u.caption
    ] })
  ] });
}, Vi = ({
  post: u,
  env: e
}) => {
  const t = u.medias.collection, n = t.length;
  return /* @__PURE__ */ r.jsx("div", { className: "sp-pb-8", children: n > 1 ? /* @__PURE__ */ r.jsx(Hi, { post: u, stories: t, count: n }) : /* @__PURE__ */ r.jsx(Sr, { post: u, media: t[0], env: e }) });
}, Wi = b.div`
  display: flex;
  flex-direction: ${({
  $direction: u = "row"
}) => u};
  justify-content: ${({
  $justify: u = "flex-start"
}) => u};
  align-items: ${({
  $align: u = "flex-start"
}) => u};
  gap: ${({
  $gap: u = 7
}) => `${u}px`};
  margin-top: ${({
  $marginTop: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-bottom: ${({
  $marginBottom: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-left: ${({
  $marginLeft: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-right: ${({
  $marginRight: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  width: ${({
  $width: u = "auto"
}) => u};
`, Gi = ({
  media: u,
  slideNo: e,
  isActiveSlide: t,
  getVideoWrapHeight: n
}) => {
  var i;
  const D = je(null), s = {
    order: e,
    flex: "1 0 100%"
  };
  return En(() => {
    const a = D == null ? void 0 : D.current;
    if (!a) return;
    const o = () => {
      n(a.clientHeight);
    };
    let c = u.isVideo && D.current && document.querySelector(`.${a.className.replace(/ /g, ".")} video`);
    return c && c.addEventListener("loadeddata", o), function() {
      var m;
      c = u.isVideo && a && document.querySelector(`.${(m = a.className) == null ? void 0 : m.replace(/ /g, ".")} video`), c && c.removeEventListener("loadeddata", o);
    };
  }, [D == null ? void 0 : D.current, (i = D == null ? void 0 : D.current) == null ? void 0 : i.buffered]), /* @__PURE__ */ r.jsx("div", { style: s, children: /* @__PURE__ */ r.jsx(Ne, { videoRef: D, media: u, isActiveSlide: t }) });
}, Yi = ({
  medias: u,
  currentSlide: e,
  getVideoWrapHeight: t
}) => {
  const n = u.map((D, s) => /* @__PURE__ */ r.jsx(Gi, { getVideoWrapHeight: t, media: D, slideNo: s + 1, isActiveSlide: e === s + 1 }, `slide-${s}`));
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: n });
}, qi = ({
  current: u
}) => /* @__PURE__ */ r.jsx("div", { className: `${u ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), Zi = ({
  count: u,
  current: e
}) => /* @__PURE__ */ r.jsx(Xi, { className: "sp-flex sp-items-center sp-justify-center", children: [...Array(u)].map((t, n) => /* @__PURE__ */ r.jsx(qi, { current: n + 1 === e }, `dot-${n}`)) }), Ki = ({
  medias: u,
  count: e
}) => {
  const [t, n] = ju(1), D = je(null);
  Zu(() => {
    t > u.length && n(u.length);
  }, [u.length, t]);
  const s = {
    left: "100%",
    transform: `translateX(${t * -100}%)`
  };
  Zu(() => {
    D.current && (D.current.style.height = "auto");
  }, [t]);
  const i = (a) => {
    D.current && (D.current.style.height = a + "px");
  };
  return /* @__PURE__ */ r.jsxs(Wi, { $width: "100%", $direction: "column", $justify: "center", $align: "stretch", $gap: "0", className: "sp-relative", children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      t !== 1 && /* @__PURE__ */ r.jsx(pe, { direction: "left", onClick: () => n(t - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative sp-items-center", style: s, ref: D, children: /* @__PURE__ */ r.jsx(Yi, { medias: u, currentSlide: t, getVideoWrapHeight: i }) }),
      t !== u.length && /* @__PURE__ */ r.jsx(pe, { direction: "right", onClick: () => n(t + 1) })
    ] }),
    /* @__PURE__ */ r.jsx(Zi, { count: e, current: t })
  ] });
}, Xi = b.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
`, Nr = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return t > 1 ? /* @__PURE__ */ r.jsx(Ki, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(Ne, { media: e[0] });
}, Ye = b.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, Ji = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 14" }, u), /* @__PURE__ */ F.createElement("path", { d: "M0.285317 6.39974C0.194867 6.47853 0.123111 6.5721 0.0741546 6.6751C0.0251977 6.7781 6.52568e-07 6.8885 6.47695e-07 7C6.42821e-07 7.1115 0.0251977 7.2219 0.0741545 7.3249C0.123111 7.42789 0.194867 7.52146 0.285317 7.60026L7.33835 13.7514C7.52089 13.9106 7.76847 14 8.02663 14C8.28478 14 8.53236 13.9106 8.71491 13.7514C8.89745 13.5922 9 13.3762 9 13.1511C9 12.926 8.89745 12.71 8.71491 12.5508L2.35015 7L8.71491 1.44916C8.80529 1.37033 8.87699 1.27675 8.92591 1.17376C8.97482 1.07077 9 0.960378 9 0.848899C9 0.73742 8.97482 0.627033 8.92591 0.52404C8.87699 0.421046 8.80529 0.327465 8.71491 0.248637C8.62452 0.169809 8.51722 0.10728 8.39912 0.0646186C8.28103 0.0219574 8.15445 -3.86212e-08 8.02663 -4.25475e-08C7.8988 -4.64737e-08 7.77223 0.0219574 7.65413 0.0646186C7.53604 0.10728 7.42873 0.169809 7.33835 0.248637L0.285317 6.39974Z", fill: "white" })), Qi = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 21 17" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_85)" }, /* @__PURE__ */ F.createElement("path", { d: "M13.2308 23C11.4549 23 10 21.6081 10 19.9091V11.6667C10 9.96768 11.4549 8.57576 13.2308 8.57576H15.9567L17.0841 6.42661C17.1514 6.2982 17.2547 6.19026 17.3825 6.11491C17.5103 6.03955 17.6576 5.99976 17.8077 6H23.1923C23.3424 5.99976 23.4897 6.03955 23.6175 6.11491C23.7453 6.19026 23.8486 6.2982 23.9159 6.42661L25.0433 8.57576H27.7692C29.5451 8.57576 31 9.96768 31 11.6667V19.9091C31 21.6081 29.5451 23 27.7692 23H13.2308ZM13.2308 21.4545H27.7692C28.6781 21.4545 29.3846 20.7786 29.3846 19.9091V11.6667C29.3846 10.7972 28.6781 10.1212 27.7692 10.1212H24.5385C24.3883 10.1215 24.2411 10.0817 24.1133 10.0063C23.9855 9.93097 23.8822 9.82303 23.8149 9.69462L22.6875 7.54545H18.3125L17.1851 9.69462C17.1178 9.82303 17.0145 9.93097 16.8867 10.0063C16.7589 10.0817 16.6117 10.1215 16.4615 10.1212H13.2308C12.3219 10.1212 11.6154 10.7972 11.6154 11.6667V19.9091C11.6154 20.7786 12.3219 21.4545 13.2308 21.4545ZM20.5 20.1667C17.9818 20.1667 15.9231 18.1971 15.9231 15.7879C15.9231 13.3787 17.9818 11.4091 20.5 11.4091C23.0182 11.4091 25.0769 13.3787 25.0769 15.7879C25.0769 18.1971 23.0182 20.1667 20.5 20.1667ZM20.5 18.6212C22.1452 18.6212 23.4615 17.3618 23.4615 15.7879C23.4615 14.2139 22.1452 12.9546 20.5 12.9546C18.8549 12.9546 17.5385 14.2139 17.5385 15.7879C17.5385 17.3618 18.8549 18.6212 20.5 18.6212Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_85", x: 0, y: 0, width: 41, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_85" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_85", result: "shape" })))), ua = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 8 8" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_80)" }, /* @__PURE__ */ F.createElement("rect", { x: 10, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ F.createElement("rect", { x: 16, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ F.createElement("rect", { x: 13, y: 6, width: 2, height: 8, rx: 1, fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_80", x: 0, y: 0, width: 28, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_80" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_80", result: "shape" })))), ea = b.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`, ta = b.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 6px;
`, $r = ({
  profilePicture: u,
  username: e
}) => /* @__PURE__ */ r.jsxs(ea, { children: [
  /* @__PURE__ */ r.jsx(ta, { $profilePicture: u }),
  /* @__PURE__ */ r.jsxs(Ye, { className: "sp-font-bold", children: [
    e,
    " • Follow"
  ] })
] }), ra = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 18" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_66)" }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.383 6C21.3618 6 20.0001 8.32683 20.0001 8.32683C20.0001 8.32683 18.6384 6 15.6171 6C12.5107 6 10.0001 8.80976 10.0001 12.278C10.0001 15.7463 12.5958 17.722 15.1916 20.0927C19.1064 23.6927 19.3618 24 20.0001 24C20.6384 24 20.8937 23.6927 24.8086 20.0927C27.4469 17.678 30.0001 15.7024 30.0001 12.278C30.0001 8.80976 27.4894 6 24.383 6ZM23.9575 19.0829C21.6596 21.1902 20.4256 22.3756 20.0001 22.639C19.5745 22.3317 18.0426 20.9268 16.0426 19.0829C13.7022 16.9317 11.2767 15.1317 11.2767 12.2341C11.2767 9.5122 13.2341 7.27317 15.6171 7.27317C17.3618 7.27317 18.2979 8.15122 18.9788 9.11707C20.5107 11.3561 19.4894 11.3561 21.0213 9.11707C21.7022 8.15122 22.6384 7.27317 24.383 7.27317C26.766 7.27317 28.7235 9.5122 28.7235 12.2341C28.7235 15.1756 26.2979 16.9756 23.9575 19.0829Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_66", x: 610352e-10, y: 0, width: 40, height: 38, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_66" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_66", result: "shape" })))), na = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 20" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_65)" }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.9868 25.3914L28.7961 20.7137C29.5615 19.3103 29.9868 17.6944 29.9868 15.9934C29.9868 10.4651 25.5216 6 19.9934 6C14.4651 6 10 10.4651 10 15.9934C10 21.5216 14.4651 25.9868 19.9934 25.9868C21.6944 25.9868 23.3103 25.5615 24.7137 24.7961L29.3914 25.9868C29.7316 26.0718 30.0718 25.7316 29.9868 25.3914ZM28.711 15.9934C28.711 17.6944 28.2858 18.9701 27.6054 20.2459C27.5203 20.416 27.4778 20.6286 27.5203 20.8412L28.4134 24.4134L24.8838 23.5203C24.6711 23.4778 24.4585 23.4778 24.2884 23.6054C23.523 24.0306 22.0771 24.711 20.0359 24.711C15.1881 24.711 11.2758 20.7987 11.2758 15.9934C11.2758 11.1881 15.1881 7.27575 19.9934 7.27575C24.7987 7.27575 28.711 11.1881 28.711 15.9934Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_65", x: 0, y: 0, width: 40, height: 40, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_65" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_65", result: "shape" })))), Da = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 17" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_64)" }, /* @__PURE__ */ F.createElement("path", { d: "M29.5574 6H10.419C10.0363 6 9.86616 6.45544 10.1213 6.70386L16.9261 13.2456L19.2652 22.6856C19.3503 23.0582 19.8606 23.0996 20.0307 22.8098L29.9401 6.62105C30.1102 6.33123 29.8976 6 29.5574 6ZM12.503 7.2421H26.7504L17.9043 12.0035C17.7341 12.0863 17.5215 12.0449 17.3939 11.9207L12.503 7.2421ZM20.0307 20.4084L18.3295 13.5354C18.287 13.3698 18.3721 13.1628 18.5422 13.08L27.4309 8.27719L20.0307 20.4084Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_64", x: 0, y: 0, width: 40, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_64" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_64", result: "shape" })))), sa = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ F.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ F.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), ia = b.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 2;

  svg {
    width: 20px;

    &.more {
      position: relative;
      ${({
  $vertical: u
}) => u && "top: -10px;"};
    }
  }

  ${({
  $vertical: u
}) => u ? `
      flex-direction: column;
      right: 14px;
      bottom: 145px;
      gap: 40px;
      ` : `
      flex-direction: row;
      gap: 14px;
      left: 14px;
      bottom: 80px;
      `}
`, kr = ({
  vertical: u
}) => /* @__PURE__ */ r.jsxs(ia, { $vertical: u, children: [
  /* @__PURE__ */ r.jsx(ra, {}),
  /* @__PURE__ */ r.jsx(na, {}),
  /* @__PURE__ */ r.jsx(Da, {}),
  /* @__PURE__ */ r.jsx(sa, { className: "more" })
] }), aa = ({
  post: u,
  className: e
}) => {
  var n, D;
  const t = ((D = (n = u == null ? void 0 : u.medias) == null ? void 0 : n.collection) == null ? void 0 : D.length) > 1;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(oa, { className: e, children: [
      /* @__PURE__ */ r.jsxs(Ea, { children: [
        /* @__PURE__ */ r.jsx(Ji, { className: "arrow-back" }),
        /* @__PURE__ */ r.jsx(Ye, { children: "Reels" }),
        /* @__PURE__ */ r.jsx(Qi, { className: "camera" })
      ] }),
      /* @__PURE__ */ r.jsx(kr, { vertical: !0 }),
      /* @__PURE__ */ r.jsxs(la, { $isMultipleMedia: t, children: [
        /* @__PURE__ */ r.jsx($r, { profilePicture: u.profilePicture, username: u.username }),
        /* @__PURE__ */ r.jsx(Ye, { className: "caption", children: /* @__PURE__ */ r.jsx(Nu, { caption: u.caption, targetPlatform: "IG" }) }),
        /* @__PURE__ */ r.jsx(ua, {})
      ] }),
      /* @__PURE__ */ r.jsx(Nr, { medias: u.medias })
    ] }),
    u.caption && /* @__PURE__ */ r.jsxs(Fa, { children: [
      /* @__PURE__ */ r.jsxs("strong", { children: [
        u.username,
        " "
      ] }),
      /* @__PURE__ */ r.jsx(Nu, { caption: u.caption, targetPlatform: "IG" })
    ] }),
    u.comment && /* @__PURE__ */ r.jsxs(ca, { id: "post-preview-notes", children: [
      /* @__PURE__ */ r.jsxs("strong", { children: [
        u.username,
        " "
      ] }),
      /* @__PURE__ */ r.jsx(Nu, { caption: u.comment, targetPlatform: "IG" })
    ] })
  ] });
}, oa = b.div`
  box-shadow: 0 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  height: 711px;
  background: #333;
  display: flex;
`, la = b.div`
  position: absolute;
  bottom: ${(u) => u.$isMultipleMedia ? "130px" : "100px"};
  z-index: 2;
  padding: 0 0 0 12px;

  .caption {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 250px;
    height: 20px;
  }

  svg {
    width: 8px;
    margin-top: 14px;
  }
`, ca = b.div`
  margin: 14px 5px;
  font-size: 14px;
  line-height: 17px;
`, Fa = b.div`
  margin: 17px 5px 0 5px;
  font-size: 14px;
  line-height: 17px;
`, Ea = b.div`
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 2;
  justify-content: space-between;
  width: 100%;

  p {
    font-weight: 700;
  }

  .arrow-back {
    width: 14px;
    margin-left: 12px;
  }

  .camera {
    width: 21px;
    margin-right: 12px;
  }
`, Ca = b.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, da = b.div`
  position: absolute;
  top: 20px;
  z-index: 2;
  width: 100%;

  .section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;

    p {
      width: 280px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 16px;
    }

    svg.close {
      width: 17px;
    }
  }
`, Aa = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(Ca, { children: [
  /* @__PURE__ */ r.jsxs(da, { children: [
    u.caption && /* @__PURE__ */ r.jsx("div", { className: "section", children: /* @__PURE__ */ r.jsx(Ye, { children: u.caption }) }),
    /* @__PURE__ */ r.jsx("div", { className: "section", children: /* @__PURE__ */ r.jsx($r, { profilePicture: u.profilePicture, username: u.username }) })
  ] }),
  /* @__PURE__ */ r.jsx(kr, {}),
  /* @__PURE__ */ r.jsx(Nr, { medias: u.medias })
] }), pa = ({
  post: u,
  className: e,
  env: t
}) => {
  let n = u.type;
  switch (n === "story" && u.storyType && u.storyType !== "story" && (u.storyType === "reel" ? (n = "reel", u.locationName = "Reel") : u.storyType === "igtv" && (n = "igtv", u.locationName = "IGTV")), n) {
    case "image":
    case "multiMedia":
      return /* @__PURE__ */ r.jsx(xi, { post: u });
    case "video":
    case "reel":
      return /* @__PURE__ */ r.jsx(aa, { post: u, className: e });
    case "igtv":
      return /* @__PURE__ */ r.jsx(Aa, { post: u });
    case "story":
      return /* @__PURE__ */ r.jsx(Vi, { post: u, env: t });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, qe = b.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 15px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};

  .sked-mention.sked-mention-facebook {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, Tr = ({
  username: u,
  profilePicture: e,
  small: t,
  scheduled: n
}) => {
  let D = new Yu(n).format("MMM D [at] HH:mm");
  return D === "Invalid date" && (D = null), /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "", children: [
      /* @__PURE__ */ r.jsx(qe, { $variant: "heading", className: "sp-mb-1", children: u }),
      D && /* @__PURE__ */ r.jsx(qe, { $variant: "subheading", children: D })
    ] }) })
  ] });
};
function Pr(u) {
  var e, t, n = "";
  if (typeof u == "string" || typeof u == "number") n += u;
  else if (typeof u == "object") if (Array.isArray(u)) {
    var D = u.length;
    for (e = 0; e < D; e++) u[e] && (t = Pr(u[e])) && (n && (n += " "), n += t);
  } else for (t in u) u[t] && (n && (n += " "), n += t);
  return n;
}
function fa() {
  for (var u, e, t = 0, n = "", D = arguments.length; t < D; t++) (u = arguments[t]) && (e = Pr(u)) && (n && (n += " "), n += e);
  return n;
}
const ha = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, ma = b.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Ba = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: D,
  mediaCount: s
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(ma, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => D(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      s - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(ha, { src: u }) }), ga = ({
  url: u,
  isActiveSlide: e,
  isCarouselPost: t
}) => e ? /* @__PURE__ */ r.jsx("div", { className: fa({
  "sp-relative": !t
}, {
  "sp-absolute": t
}), children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, className: "sp-overflow-hidden sp-my-auto", width: "100%", height: "auto" }) }) : null, Ht = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: D,
  setShowAll: s,
  mediaCount: i,
  isActiveSlide: a = !0
}) => e && D === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(ga, { url: u.url, isActiveSlide: a, isCarouselPost: t }) : /* @__PURE__ */ r.jsx(Ba, { src: u.url, forCarousel: t, showOverlay: n, showAll: D, setShowAll: s, mediaCount: i }), xa = b.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, va = ({
  medias: u
}) => {
  const [e, t] = ju(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, D) => !e && D > 3 ? null : /* @__PURE__ */ r.jsx(xa, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Ht, { media: n, forCarousel: !0, hidden: D > 3, isActiveSlide: D === 0, mediaCount: u.length, showOverlay: D === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${D}`)) });
}, ya = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-py-4 sp-text-gray-700", children: [
  /* @__PURE__ */ r.jsx(st, { icon: "icon-facebook-like", text: "Like" }),
  /* @__PURE__ */ r.jsx(st, { icon: "icon-facebook-comment", text: "Comment" }),
  /* @__PURE__ */ r.jsx(st, { icon: "icon-facebook-share", text: "Share" })
] }), st = ({
  icon: u,
  text: e
}) => /* @__PURE__ */ r.jsxs(qe, { $variant: "icons", className: "sp-flex sp-items-center sp-justify-center sp-w-1/3 ", children: [
  /* @__PURE__ */ r.jsx("div", { className: `sp-mr-2 sp-text-3xl ${u}` }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-text-gray-700", children: e })
] }), wa = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(va, { medias: e }) : /* @__PURE__ */ r.jsx(Ht, { media: e[0], showOverlay: !1, showAll: !0, setShowAll: () => {
    }, isActiveSlide: !0, mediaCount: t }) }),
    /* @__PURE__ */ r.jsx(ya, {})
  ] });
}, ba = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", Xe = ({
  url: u
}) => /* @__PURE__ */ r.jsx(An, { url: u, apiKey: ba, size: "large", className: "sp-shadow-lg" }), ja = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(Tr, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName, scheduled: u.scheduledFor }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-mx-4 sp-pb-4", style: u.type === "text" && u.redirectUrl === "" ? {
      borderBottom: "1px solid #BFBEBE"
    } : {}, children: /* @__PURE__ */ r.jsxs(qe, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(Nu, { caption: e, targetPlatform: "FB" }),
      u.redirectUrl && u.type !== "text" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(Xe, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(wa, { medias: u.medias })
  ] });
}, Sa = () => /* @__PURE__ */ r.jsx("div", { className: "sp-w-full sp-h-1", style: {
  backgroundColor: "rgba(181, 180, 176, 0.4)"
}, children: /* @__PURE__ */ r.jsx("span", { className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75", style: {
  width: "33%"
} }) }), _a = ({
  username: u,
  profilePicture: e,
  locationName: t
}) => /* @__PURE__ */ r.jsxs("section", { className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-my-3 sp-mx-2", children: /* @__PURE__ */ r.jsx(Sa, {}) }),
  /* @__PURE__ */ r.jsx(Tr, { username: u, profilePicture: e, locationName: t, small: !0 })
] }), Na = () => /* @__PURE__ */ r.jsx("section", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-mb-6 sp-mx-4 sp-w-full sp-text-white", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-h-8 sp-w-full sp-justify-between", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex-3 sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2", style: {
      backgroundColor: "rgba(74, 85, 104, 0.7)"
    }, children: /* @__PURE__ */ r.jsx(br, { className: "sp-h-20px sp-w-20px" }) }),
    /* @__PURE__ */ r.jsx("div", { children: "Send message" })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex-1 sp-mt-2 sp-fill-current sp-mr-3 icon-instagram-share sp-text-white sp-flex sp-justify-center sp-text-2xl" }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex-1 sp-mt-2 sp-w-12 sp-flex sp-mr-3", children: [...Array(3)].map((u, e) => /* @__PURE__ */ r.jsx($a, {}, e)) })
] }) }), $a = b.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 0.2rem;
`, Rr = ({
  post: u,
  media: e
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center sp-h-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full", children: [
  /* @__PURE__ */ r.jsx(_a, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ r.jsx(Ht, { media: e }) }),
  /* @__PURE__ */ r.jsx(Na, {})
] }) }), w0 = ({
  direction: u,
  onClick: e
}) => /* @__PURE__ */ r.jsx(ka, { direction: u, children: u === "left" ? /* @__PURE__ */ r.jsx(yr, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey", onClick: e }) : /* @__PURE__ */ r.jsx(wr, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey", onClick: e }) }), ka = b.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(u) => u.direction === "left" ? "left: 1rem;" : "right: 1rem;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, Ta = ({
  post: u,
  media: e,
  slideNo: t
}) => {
  const n = {
    order: t,
    flex: "1 0 100%"
  };
  return /* @__PURE__ */ r.jsx("div", { style: n, children: /* @__PURE__ */ r.jsx(Rr, { post: u, media: e }) });
}, Pa = ({
  post: u,
  stories: e
}) => e.map((t, n) => /* @__PURE__ */ r.jsx(Ta, { post: u, media: t, slideNo: n + 1 }, n)), Ra = ({
  post: u,
  stories: e,
  count: t
}) => {
  const [n, D] = ju(1), s = 1, i = t;
  Zu(() => {
    D(1);
  }, [u]);
  const a = {
    left: "100%",
    transform: `translateX(${n * -100}%)`
  };
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
    s === n || /* @__PURE__ */ r.jsx(w0, { direction: "left", onClick: () => D(n - 1) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative", style: a, children: /* @__PURE__ */ r.jsx(Pa, { post: u, stories: e }) }),
    i === n || /* @__PURE__ */ r.jsx(w0, { direction: "right", onClick: () => D(n + 1) })
  ] });
}, Ia = ({
  post: u
}) => {
  const e = u.medias.collection, t = e.length;
  return /* @__PURE__ */ r.jsx("div", { className: "sp-pb-8", children: t > 1 ? /* @__PURE__ */ r.jsx(Ra, { post: u, stories: e, count: t }) : /* @__PURE__ */ r.jsx(Rr, { post: u, media: e[0] }) });
}, Oa = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(ja, { post: u });
    case "story":
      return /* @__PURE__ */ r.jsx(Ia, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, jt = b.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, La = ({
  username: u,
  profilePicture: e,
  small: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "sp-font-sans", children: [
    /* @__PURE__ */ r.jsx(jt, { $variant: "heading", className: "sp-mb-1", children: u }),
    /* @__PURE__ */ r.jsxs(jt, { $variant: "subheading", className: "sp-text-gray-600", children: [
      "@",
      u
    ] })
  ] }) }),
  /* @__PURE__ */ r.jsx("div", { className: "icon-twitter-down sp-mr-4 sp-text-2xl sp-text-gray-600", children: " " })
] }), Ma = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, za = b.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Ua = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: D,
  mediaCount: s
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(za, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => D(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      s - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(Ma, { src: u }) }), Ha = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, className: "sp-relative", width: "100%", height: "auto" }) }) : null, Ir = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: D,
  setShowAll: s,
  mediaCount: i,
  isActiveSlide: a = !0
}) => e && D === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(Ha, { url: u.url, forCarousel: t, isActiveSlide: a }),
  !(u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(Ua, { src: u.url, forCarousel: t, showOverlay: n, showAll: D, setShowAll: s, mediaCount: i })
] }), Va = () => /* @__PURE__ */ r.jsx("div", { className: "sp-py-8 sp-px-4 sp-w-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-text-gray-600 sp-py-4", style: {
  borderTop: "0.5px solid #ebebe4",
  borderBottom: "0.5px solid #ebebe4"
}, children: [
  /* @__PURE__ */ r.jsx(Me, { icon: "icon-twitter-reply" }),
  /* @__PURE__ */ r.jsx(Me, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ r.jsx(Me, { icon: "icon-twitter-heart" }),
  /* @__PURE__ */ r.jsx(Me, { icon: "icon-twitter-share" })
] }) }), Me = ({
  icon: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-w-1/4 ", children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-3xl ${u}` }) }), Wa = b.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Ga = ({
  medias: u
}) => {
  const [e, t] = ju(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, D) => !e && D > 3 ? null : /* @__PURE__ */ r.jsx(Wa, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Ir, { media: n, forCarousel: !0, hidden: D > 3, mediaCount: u.length, showOverlay: D === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${D}`)) });
}, Ya = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-px-4", children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(Ga, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(Ir, { media: e[0] }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(Va, {}) })
  ] });
}, qa = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(La, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ r.jsxs(jt, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(Nu, { caption: e, targetPlatform: "TW" }),
      u.redirectUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(Xe, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(Ya, { medias: u.medias })
  ] });
}, Za = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(qa, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Ze = b.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.045em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
  }
}};

  .sked-mention.sked-mention-linkedin {
    color: #0a66c2; // copied from LI home feed - in caption creator they're black but feed are #0a66c2
    cursor: pointer;
    font-weight: bold; // LI mentions are bold

    &:hover {
      text-decoration: underline;
    }
  }
`, Ka = ({
  username: u,
  profilePicture: e,
  locationName: t,
  small: n
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "48px",
    height: "48px"
  }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`, children: [
    /* @__PURE__ */ r.jsx(Ze, { $variant: "heading", children: u }),
    t && /* @__PURE__ */ r.jsx(Ze, { $variant: "subheading", className: "sp-text-gray-600", children: t })
  ] })
] }), Xa = b.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${(u) => u.backgroundColor || "var(--white)"};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -4px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -4px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -4px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -4px;
  }
`, Ja = b.div`
  width: ${(u) => u.width || "auto"};
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(u) => u.backgroundColor || "var(--white)"};
  color: white;
  position: relative;
  z-index: 998;
  box-sizing: border-box;
  font-family: Helvetica;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`, Qa = (s) => {
  var i = s, {
    backgroundColor: u,
    arrowPosition: e,
    children: t,
    width: n
  } = i, D = Pu(i, [
    "backgroundColor",
    "arrowPosition",
    "children",
    "width"
  ]);
  return /* @__PURE__ */ r.jsx(Xa, { backgroundColor: u, className: `arrow-${e}`, children: /* @__PURE__ */ r.jsx(Ja, _u(U({ backgroundColor: u, width: n }, D), { children: t })) });
}, uo = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("g", { clipPath: "url(#clip0_4697_272)" }, /* @__PURE__ */ F.createElement("path", { d: "M7.99967 10.6666V7.99992M7.99967 5.33325H8.00634M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z", stroke: "white", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("clipPath", { id: "clip0_4697_272" }, /* @__PURE__ */ F.createElement("rect", { width: 16, height: 16, fill: "white" }))));
function eo(u) {
  throw new Error('Could not dynamically require "' + u + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Or = { exports: {} };
(function(u, e) {
  (function(t, n) {
    typeof eo == "function" ? u.exports = n() : t.pluralize = n();
  })(pn, function() {
    var t = [], n = [], D = {}, s = {}, i = {};
    function a(h) {
      return typeof h == "string" ? new RegExp("^" + h + "$", "i") : h;
    }
    function o(h, E) {
      return h === E ? E : h === h.toLowerCase() ? E.toLowerCase() : h === h.toUpperCase() ? E.toUpperCase() : h[0] === h[0].toUpperCase() ? E.charAt(0).toUpperCase() + E.substr(1).toLowerCase() : E.toLowerCase();
    }
    function c(h, E) {
      return h.replace(/\$(\d{1,2})/g, function(w, C) {
        return E[C] || "";
      });
    }
    function g(h, E) {
      return h.replace(E[0], function(w, C) {
        var d = c(E[1], arguments);
        return o(w === "" ? h[C - 1] : w, d);
      });
    }
    function m(h, E, w) {
      if (!h.length || D.hasOwnProperty(h))
        return E;
      for (var C = w.length; C--; ) {
        var d = w[C];
        if (d[0].test(E)) return g(E, d);
      }
      return E;
    }
    function v(h, E, w) {
      return function(C) {
        var d = C.toLowerCase();
        return E.hasOwnProperty(d) ? o(C, d) : h.hasOwnProperty(d) ? o(C, h[d]) : m(d, C, w);
      };
    }
    function l(h, E, w, C) {
      return function(d) {
        var f = d.toLowerCase();
        return E.hasOwnProperty(f) ? !0 : h.hasOwnProperty(f) ? !1 : m(f, f, w) === f;
      };
    }
    function p(h, E, w) {
      var C = E === 1 ? p.singular(h) : p.plural(h);
      return (w ? E + " " : "") + C;
    }
    return p.plural = v(
      i,
      s,
      t
    ), p.isPlural = l(
      i,
      s,
      t
    ), p.singular = v(
      s,
      i,
      n
    ), p.isSingular = l(
      s,
      i,
      n
    ), p.addPluralRule = function(h, E) {
      t.push([a(h), E]);
    }, p.addSingularRule = function(h, E) {
      n.push([a(h), E]);
    }, p.addUncountableRule = function(h) {
      if (typeof h == "string") {
        D[h.toLowerCase()] = !0;
        return;
      }
      p.addPluralRule(h, "$0"), p.addSingularRule(h, "$0");
    }, p.addIrregularRule = function(h, E) {
      E = E.toLowerCase(), h = h.toLowerCase(), i[h] = E, s[E] = h;
    }, [
      // Pronouns.
      ["I", "we"],
      ["me", "us"],
      ["he", "they"],
      ["she", "they"],
      ["them", "them"],
      ["myself", "ourselves"],
      ["yourself", "yourselves"],
      ["itself", "themselves"],
      ["herself", "themselves"],
      ["himself", "themselves"],
      ["themself", "themselves"],
      ["is", "are"],
      ["was", "were"],
      ["has", "have"],
      ["this", "these"],
      ["that", "those"],
      // Words ending in with a consonant and `o`.
      ["echo", "echoes"],
      ["dingo", "dingoes"],
      ["volcano", "volcanoes"],
      ["tornado", "tornadoes"],
      ["torpedo", "torpedoes"],
      // Ends with `us`.
      ["genus", "genera"],
      ["viscus", "viscera"],
      // Ends with `ma`.
      ["stigma", "stigmata"],
      ["stoma", "stomata"],
      ["dogma", "dogmata"],
      ["lemma", "lemmata"],
      ["schema", "schemata"],
      ["anathema", "anathemata"],
      // Other irregular rules.
      ["ox", "oxen"],
      ["axe", "axes"],
      ["die", "dice"],
      ["yes", "yeses"],
      ["foot", "feet"],
      ["eave", "eaves"],
      ["goose", "geese"],
      ["tooth", "teeth"],
      ["quiz", "quizzes"],
      ["human", "humans"],
      ["proof", "proofs"],
      ["carve", "carves"],
      ["valve", "valves"],
      ["looey", "looies"],
      ["thief", "thieves"],
      ["groove", "grooves"],
      ["pickaxe", "pickaxes"],
      ["passerby", "passersby"]
    ].forEach(function(h) {
      return p.addIrregularRule(h[0], h[1]);
    }), [
      [/s?$/i, "s"],
      [/[^\u0000-\u007F]$/i, "$0"],
      [/([^aeiou]ese)$/i, "$1"],
      [/(ax|test)is$/i, "$1es"],
      [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
      [/(e[mn]u)s?$/i, "$1s"],
      [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
      [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
      [/(seraph|cherub)(?:im)?$/i, "$1im"],
      [/(her|at|gr)o$/i, "$1oes"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
      [/sis$/i, "ses"],
      [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
      [/([^aeiouy]|qu)y$/i, "$1ies"],
      [/([^ch][ieo][ln])ey$/i, "$1ies"],
      [/(x|ch|ss|sh|zz)$/i, "$1es"],
      [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
      [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
      [/(pe)(?:rson|ople)$/i, "$1ople"],
      [/(child)(?:ren)?$/i, "$1ren"],
      [/eaux$/i, "$0"],
      [/m[ae]n$/i, "men"],
      ["thou", "you"]
    ].forEach(function(h) {
      return p.addPluralRule(h[0], h[1]);
    }), [
      [/s$/i, ""],
      [/(ss)$/i, "$1"],
      [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
      [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
      [/ies$/i, "y"],
      [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
      [/\b(mon|smil)ies$/i, "$1ey"],
      [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
      [/(seraph|cherub)im$/i, "$1"],
      [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
      [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
      [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
      [/(test)(?:is|es)$/i, "$1is"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
      [/(alumn|alg|vertebr)ae$/i, "$1a"],
      [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
      [/(matr|append)ices$/i, "$1ix"],
      [/(pe)(rson|ople)$/i, "$1rson"],
      [/(child)ren$/i, "$1"],
      [/(eau)x?$/i, "$1"],
      [/men$/i, "man"]
    ].forEach(function(h) {
      return p.addSingularRule(h[0], h[1]);
    }), [
      // Singular words with no plurals.
      "adulthood",
      "advice",
      "agenda",
      "aid",
      "aircraft",
      "alcohol",
      "ammo",
      "analytics",
      "anime",
      "athletics",
      "audio",
      "bison",
      "blood",
      "bream",
      "buffalo",
      "butter",
      "carp",
      "cash",
      "chassis",
      "chess",
      "clothing",
      "cod",
      "commerce",
      "cooperation",
      "corps",
      "debris",
      "diabetes",
      "digestion",
      "elk",
      "energy",
      "equipment",
      "excretion",
      "expertise",
      "firmware",
      "flounder",
      "fun",
      "gallows",
      "garbage",
      "graffiti",
      "hardware",
      "headquarters",
      "health",
      "herpes",
      "highjinks",
      "homework",
      "housework",
      "information",
      "jeans",
      "justice",
      "kudos",
      "labour",
      "literature",
      "machinery",
      "mackerel",
      "mail",
      "media",
      "mews",
      "moose",
      "music",
      "mud",
      "manga",
      "news",
      "only",
      "personnel",
      "pike",
      "plankton",
      "pliers",
      "police",
      "pollution",
      "premises",
      "rain",
      "research",
      "rice",
      "salmon",
      "scissors",
      "series",
      "sewage",
      "shambles",
      "shrimp",
      "software",
      "species",
      "staff",
      "swine",
      "tennis",
      "traffic",
      "transportation",
      "trout",
      "tuna",
      "wealth",
      "welfare",
      "whiting",
      "wildebeest",
      "wildlife",
      "you",
      /pok[eé]mon$/i,
      // Regexes.
      /[^aeiou]ese$/i,
      // "chinese", "japanese"
      /deer$/i,
      // "deer", "reindeer"
      /fish$/i,
      // "fish", "blowfish", "angelfish"
      /measles$/i,
      /o[iu]s$/i,
      // "carnivorous"
      /pox$/i,
      // "chickpox", "smallpox"
      /sheep$/i
    ].forEach(p.addUncountableRule), p;
  });
})(Or);
var to = Or.exports;
const ro = /* @__PURE__ */ ne(to), no = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Do = b.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, b0 = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: D,
  mediaCount: s,
  url: i
  // override for the url we link to
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: i || u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(Do, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => D(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      s - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: i || u, children: /* @__PURE__ */ r.jsx(no, { src: u, title: "Click to see the full file in a new window." }) }), so = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-h-full", children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, className: "sp-relative", width: "100%", height: "auto" }) }) : null, Lr = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: D,
  setShowAll: s,
  mediaCount: i,
  isActiveSlide: a = !0
}) => e && D === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(so, { url: u.url, isActiveSlide: a }),
  !(u.isVideo || u.url.includes(".mp4") || u.url.includes(".pdf")) && /* @__PURE__ */ r.jsx(b0, { src: u.url, forCarousel: t, showOverlay: n != null ? n : !1, showAll: D != null ? D : !1, setShowAll: s, mediaCount: i }),
  u.url.includes(".pdf") && /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsxs(ao, { children: [
      /* @__PURE__ */ r.jsx("span", { className: "filename", title: u.fileName, children: u.fileName }),
      /* @__PURE__ */ r.jsx("span", { className: "dot", children: "●" }),
      /* @__PURE__ */ r.jsx("span", { className: "pages", children: ro("page", u.pages, !0) }),
      /* @__PURE__ */ r.jsxs(oo, { children: [
        /* @__PURE__ */ r.jsx(uo, {}),
        /* @__PURE__ */ r.jsx(lo, { id: "tooltip", children: /* @__PURE__ */ r.jsxs(Qa, { arrowPosition: "bottom", backgroundColor: "#1A1A1A", width: "250px", children: [
          "Previewing Page 1 of ",
          u.pages,
          ". The complete document will be posted to LinkedIn."
        ] }) })
      ] })
    ] }),
    u.thumbnailUrl !== void 0 && /* @__PURE__ */ r.jsx(b0, { src: u.thumbnailUrl, url: u.url, forCarousel: !1, mediaCount: i, showAll: D != null ? D : !1, setShowAll: s, showOverlay: n != null ? n : !1 }),
    /* @__PURE__ */ r.jsx(io, { children: /* @__PURE__ */ r.jsx("a", { href: u.url, target: "_blank", rel: "noreferrer", children: "Click to download and view the full document in a new tab." }) })
  ] })
] }), io = b.span`
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: flex;
`, ao = b.div`
  background: rgba(0, 0, 0, 0.4);
  padding: 4px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  .filename {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }

  .dot {
    padding: 0 4px 0 6px;
    font-size: 6px;
    position: relative;
    top: 1px;
    line-height: 16px;
  }

  .pages {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }

  svg {
    position: relative;
    top: 2px;
    margin-left: 4px;
  }
`, oo = b.div`
  position: relative;
  display: inline-block;
  line-height: normal;

  svg {
    &:hover + #tooltip {
      display: block;
    }
  }
`, lo = b.div`
  display: none;
  position: absolute;
  top: -60px;
  left: calc(-250px / 2 + 12px);
`, co = b.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Fo = ({
  medias: u
}) => {
  const [e, t] = ju(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, D) => !e && D > 3 ? null : /* @__PURE__ */ r.jsx(co, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Lr, { media: n, forCarousel: !0, hidden: D > 3, mediaCount: u.length, showOverlay: D === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${D}`)) });
}, Eo = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-items-center sp-justify-center sp-py-8 sp-text-gray-700 sp-font-bold", children: [
  /* @__PURE__ */ r.jsx(it, { icon: "icon-linkedin-like", text: "Like", className: "sp-justify-start sp-ml-8" }, "ico-like"),
  /* @__PURE__ */ r.jsx(it, { icon: "icon-linkedin-comment", text: "Comment", className: "sp-justify-center" }, "ico-comment"),
  /* @__PURE__ */ r.jsx(it, { icon: "icon-linkedin-share", text: "Share", className: "sp-justify-end sp-mr-8" }, "ico-share")
] }), it = ({
  icon: u,
  text: e,
  className: t = ""
}) => /* @__PURE__ */ r.jsxs(Ze, { $variant: "icons", className: `sp-flex sp-items-center sp-w-1/3 ${t}`, children: [
  /* @__PURE__ */ r.jsx("div", { className: `sp-mr-2 sp-text-4xl ${u}` }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-text-gray-700 sp-text-2xl", children: e })
] }), Co = ({
  medias: u,
  postType: e
}) => {
  var s, i;
  let t = (u == null ? void 0 : u.collection) || [];
  const n = t.length, D = n > 1;
  if (e === "document")
    if (t.length === 0)
      t.push({});
    else {
      const a = (s = u == null ? void 0 : u.medias) == null ? void 0 : s[0];
      a && (t[0].thumbnailUrl = a.thumbnailUrl, t[0].fileName = a.fileName, t[0].pages = (i = a.meta) == null ? void 0 : i.pages, t[0].url = a.url);
    }
  return e === "multiMedia" && n > 0 && (t = t.filter((a) => !a.url.includes(".pdf"))), /* @__PURE__ */ r.jsxs("div", { children: [
    n > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: D ? /* @__PURE__ */ r.jsx(Fo, { medias: t }) : /* @__PURE__ */ r.jsx(Lr, { media: t[0], mediaCount: n, setShowAll: () => {
    }, forCarousel: !1, showAll: !1, hidden: !1, isActiveSlide: !0, showOverlay: !1 }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(Eo, {}) })
  ] });
}, Ao = ({
  post: u,
  trackEvent: e
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
  /* @__PURE__ */ r.jsx(Ka, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
  u.caption && /* @__PURE__ */ r.jsxs(Ze, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words sp-flex sp-flex-col sp-m-8", children: [
    /* @__PURE__ */ r.jsx(Nu, { caption: u.caption, targetPlatform: "LI", trackEvent: e }),
    u.redirectUrl && u.type !== "text" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      " ",
      /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
    ] })
  ] }),
  u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(Xe, { url: u.redirectUrl }) }),
  /* @__PURE__ */ r.jsx(Co, { medias: u.medias, postType: u.type })
] }), po = ({
  post: u,
  trackEvent: e
}) => {
  switch (u.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "document":
      return /* @__PURE__ */ r.jsx(Ao, { post: u, trackEvent: e });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, ue = b.span`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "buttonlabel":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
  }
}};
`, Ee = b.div`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          color: rgba(0,0,0,.54);
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
    case "title":
      return `
          font-style: normal;
          font-weight: medium;
          font-size: 20px;
          line-height: 28px;
        `;
    case "subtitle":
      return `
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
        `;
  }
}};
`, fo = b(zu)`
  display: inherit;

  img {
    border-radius: 50%;
  }
`, ho = ({
  username: u,
  profilePicture: e
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-pb-4", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-mr-1", style: {
    width: "38x",
    height: "38px"
  }, children: [
    /* @__PURE__ */ r.jsx(fo, { src: e, alt: u }),
    /* @__PURE__ */ r.jsx("div", { style: {
      position: "relative",
      top: "25px",
      right: "25%",
      marginLeft: "auto",
      fill: "#1a73e8",
      lineHeight: "18px",
      height: "18px"
    }, children: /* @__PURE__ */ r.jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", style: {
      height: "18px"
    }, children: /* @__PURE__ */ r.jsx("path", { stroke: "#fff", d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" }) }) })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-justify-center sp-leading-tight ", style: {
    width: "auto",
    height: "36px"
  }, children: [
    /* @__PURE__ */ r.jsx(Ee, { $variant: "heading", className: "", children: u }),
    /* @__PURE__ */ r.jsx(Ee, { $variant: "subheading", className: "", children: "a minute ago" })
  ] })
] });
var Mr = {}, zr = { exports: {} }, Ur = { exports: {} };
(function(u) {
  function e(t) {
    "@babel/helpers - typeof";
    return u.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, u.exports.__esModule = !0, u.exports.default = u.exports, e(t);
  }
  u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
})(Ur);
var mo = Ur.exports;
(function(u) {
  var e = mo.default;
  function t(D) {
    if (typeof WeakMap != "function") return null;
    var s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
    return (t = function(o) {
      return o ? i : s;
    })(D);
  }
  function n(D, s) {
    if (!s && D && D.__esModule) return D;
    if (D === null || e(D) != "object" && typeof D != "function") return {
      default: D
    };
    var i = t(s);
    if (i && i.has(D)) return i.get(D);
    var a = {
      __proto__: null
    }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var c in D) if (c !== "default" && {}.hasOwnProperty.call(D, c)) {
      var g = o ? Object.getOwnPropertyDescriptor(D, c) : null;
      g && (g.get || g.set) ? Object.defineProperty(a, c, g) : a[c] = D[c];
    }
    return a.default = D, i && i.set(D, a), a;
  }
  u.exports = n, u.exports.__esModule = !0, u.exports.default = u.exports;
})(zr);
var St = zr.exports, Hr = { exports: {} };
(function(u) {
  function e(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
})(Hr);
var Vr = Hr.exports, at = { exports: {} }, j0;
function Wr() {
  return j0 || (j0 = 1, function(u) {
    function e() {
      return u.exports = e = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var D = arguments[n];
          for (var s in D) ({}).hasOwnProperty.call(D, s) && (t[s] = D[s]);
        }
        return t;
      }, u.exports.__esModule = !0, u.exports.default = u.exports, e.apply(null, arguments);
    }
    u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
  }(at)), at.exports;
}
var ot = {}, lt = {}, S0;
function Bo() {
  return S0 || (S0 = 1, function(u) {
    Object.defineProperty(u, "__esModule", {
      value: !0
    }), u.translate = i, u.infiniteIndex = a, u.clampNumber = o, u.default = v;
    var e = "linear", t = 50, n = "transitionend", D = Math.abs, s = {
      passive: !1
    };
    function i(l, p, h) {
      h === void 0 && (h = 100);
      var E = l * h * -1, w = p ? "calc(" + E + "% - " + p + "px)" : E + "%";
      return "translate3d(" + w + ", 0, 0)";
    }
    function a(l, p) {
      return l < 0 ? p - 1 : l >= p ? 0 : l;
    }
    function o(l, p, h) {
      return Math.min(Math.max(l, p), h);
    }
    function c(l) {
      return l.targetTouches ? l.targetTouches[0] : l.touches[0];
    }
    function g(l, p, h, E, w) {
      var C = p !== "" ? "transition-timing-function: " + p + ";" : "", d = l ? "transition-duration: " + l + "ms;" : "";
      return "" + C + d + "transform: " + i(h, E, w) + ";";
    }
    function m(l) {
      for (; l.childElementCount > 1; )
        l !== null && l.removeChild(l.lastChild);
      return !0;
    }
    function v(l, p) {
      var h = p.doAfterSlide, E = p.doBeforeSlide, w = p.ease, C = p.infiniteLoop, d = p.initialSlide, f = p.numOfSlides, B = p.onNext, j = p.onPrev, I = p.slidesDOMEl, T = p.slideSpeed, q = p.items;
      if (l === null) return;
      var V = d, X = !1, G = 0, J = 0, Q = 0, tu = 0;
      function Fu(M, z, H) {
        z === void 0 && (z = ""), H === void 0 && (H = 0);
        var y = 100 / f;
        I.style.cssText = g(M, z, V, H, y);
      }
      function lu(M) {
        var z = M === !0 ? 1 : -1, H = V + 1 * z;
        C && (H = a(H, q)), H = o(H, 0, q - 1), P(H);
      }
      function nu() {
      }
      function gu(M) {
        var z = c(M);
        X = void 0, Q = z.pageX, tu = z.pageY;
      }
      function xu(M) {
        if (!(M.touches.length > 1 || M.scale && M.scale !== 1)) {
          var z = c(M);
          if (G = z.pageX - Q, J = z.pageY - tu, typeof X == "undefined") {
            X = D(G) < D(J), X || (document.ontouchmove = function(H) {
              return H.preventDefault();
            });
            return;
          }
          X || (M.preventDefault(), Fu(0, e, G * -1));
        }
      }
      function vu() {
        if (document.ontouchmove = function() {
          return !0;
        }, !X) {
          var M = D(G) > t, z = G < 0, H = z === !1 && V === 0 || z === !0 && V === q - 1;
          M === !0 && H === !1 ? lu(z) : Fu(T, e);
        }
        G = J = Q = tu = 0;
      }
      function R() {
        I.addEventListener(n, nu), l.addEventListener("touchstart", gu, s), l.addEventListener("touchmove", xu, s), l.addEventListener("touchend", vu, s), V !== 0 && Fu(0);
      }
      function $() {
        return m(I);
      }
      function P(M) {
        M !== V && (M <= q && (E({
          currentSlide: V,
          nextSlide: M
        }), M > V ? B(M) : j(M), V = M), Fu(T, w), I.addEventListener(n, function z(H) {
          h({
            currentSlide: V
          }), H.currentTarget.removeEventListener(H.type, z);
        }));
      }
      function W(M) {
        M.preventDefault(), M.stopPropagation(), lu(!1);
      }
      function x(M) {
        M.preventDefault(), M.stopPropagation(), lu(!0);
      }
      function Z(M) {
        q = M;
      }
      function S() {
        l.removeEventListener("touchstart", gu, s), l.removeEventListener("touchmove", xu, s), l.removeEventListener("touchend", vu, s), I.removeEventListener(n, nu);
      }
      return R(), {
        clean: $,
        destroy: S,
        goTo: P,
        next: x,
        prev: W,
        slide: lu,
        updateItems: Z
      };
    }
  }(lt)), lt;
}
var _0;
function go() {
  return _0 || (_0 = 1, function(u) {
    var e = St, t = Vr;
    Object.defineProperty(u, "__esModule", {
      value: !0
    }), u.default = v;
    var n = t(Wr()), D = e(Eu), s = t(Bo()), i = r;
    D.default.createElement;
    function a(l) {
    }
    function o(l) {
      return Array.isArray(l) ? l : [l];
    }
    function c(l) {
      var p = l.index, h = l.maxIndex, E = l.items, w = l.itemsToPreload, C = l.numOfSlides, d = Math.max(w, C);
      if (p >= E.length - C) {
        var f = E.length > C ? E.slice(0, C - 1) : [];
        return [].concat(E.slice(0, h + d), f);
      } else
        return E.slice(0, h + d);
    }
    function g(l, p) {
      l && l.clean() && l.destroy(), p();
    }
    var m = function(p) {
      return function(h, E) {
        var w = p !== 1 ? {
          width: 100 / p + "%"
        } : {};
        return /* @__PURE__ */ (0, i.jsx)("li", {
          style: w,
          children: h
        }, E);
      };
    };
    function v(l) {
      var p = l.ArrowLeft, h = l.ArrowRight, E = l.children, w = l.classNameBase, C = l.doAfterDestroy, d = l.doAfterInit, f = l.doAfterSlide, B = l.doBeforeSlide, j = l.ease, I = l.infiniteLoop, T = l.initialSlide, q = l.itemsToPreload, V = l.keyboardNavigation, X = l.numOfSlides, G = l.showArrows, J = l.slide, Q = l.slideSpeed, tu = (0, D.useState)({
        goTo: a,
        next: a,
        prev: a,
        updateItems: a
      }), Fu = tu[0], lu = tu[1], nu = (0, D.useState)(T), gu = nu[0], xu = nu[1], vu = (0, D.useState)(T), R = vu[0], $ = vu[1], P = (0, D.useRef)(null), W = (0, D.useRef)(null), x = o(E);
      (0, D.useEffect)(
        function() {
          J !== gu && Fu.goTo(J);
        },
        [J]
        // eslint-disable-line
      ), (0, D.useEffect)(
        function() {
          var y, uu = (0, s.default)(P.current, {
            ease: j,
            doAfterSlide: f,
            doBeforeSlide: B,
            numOfSlides: X,
            slideSpeed: Q,
            infiniteLoop: I,
            slidesDOMEl: W.current,
            initialSlide: gu,
            items: x.length,
            onNext: function(L) {
              return xu(L), L > R && $(L), L;
            },
            onPrev: function(L) {
              return xu(L), L;
            }
          });
          return lu(uu), d(), V && (y = function(L) {
            L.keyCode === 39 ? uu.next(L) : L.keyCode === 37 && uu.prev(L);
          }, document.addEventListener("keydown", y)), function() {
            g(uu, C), V && document.removeEventListener("keydown", y);
          };
        },
        []
        // eslint-disable-line
      ), (0, D.useEffect)(function() {
        Fu && Fu.updateItems(x.length);
      });
      var Z = c({
        index: gu,
        maxIndex: R,
        items: x,
        itemsToPreload: q,
        numOfSlides: X
      }), S = function(uu) {
        return Fu.prev(uu);
      }, M = function(uu) {
        return x.length > X && Fu.next(uu);
      }, z = function() {
        var uu = gu === 0 && !I, N = {
          disabled: uu,
          onClick: S
        }, L = w + "-arrow " + w + "-arrowLeft";
        return p ? /* @__PURE__ */ (0, i.jsx)(p, (0, n.default)({}, N, {
          className: L
        })) : /* @__PURE__ */ (0, i.jsx)("span", (0, n.default)({
          "aria-label": "Previous",
          className: L + " " + w + "-prev",
          role: "button"
        }, N));
      }, H = function() {
        var uu = (x.length <= X || gu === x.length - 1) && !I, N = {
          disabled: uu,
          onClick: M
        }, L = w + "-arrow " + w + "-arrowRight";
        return h ? /* @__PURE__ */ (0, i.jsx)(h, (0, n.default)({}, N, {
          className: L
        })) : /* @__PURE__ */ (0, i.jsx)("span", (0, n.default)({
          "aria-label": "Next",
          className: L + " " + w + "-next",
          role: "button"
        }, N));
      };
      return /* @__PURE__ */ (0, i.jsxs)(i.Fragment, {
        children: [G && /* @__PURE__ */ (0, i.jsxs)(i.Fragment, {
          children: [z(), H()]
        }), /* @__PURE__ */ (0, i.jsx)("div", {
          ref: P,
          children: /* @__PURE__ */ (0, i.jsx)("ul", {
            ref: W,
            children: Z.map(m(X))
          })
        })]
      });
    }
  }(ot)), ot;
}
var N0 = {}, $0;
function xo() {
  return $0 || ($0 = 1, function() {
    if (typeof window != "object")
      return;
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        "isIntersecting",
        {
          get: function() {
            return this.intersectionRatio > 0;
          }
        }
      );
      return;
    }
    var u = window.document, e = [], t = null, n = null;
    function D(C) {
      this.time = C.time, this.target = C.target, this.rootBounds = l(C.rootBounds), this.boundingClientRect = l(C.boundingClientRect), this.intersectionRect = l(C.intersectionRect || v()), this.isIntersecting = !!C.intersectionRect;
      var d = this.boundingClientRect, f = d.width * d.height, B = this.intersectionRect, j = B.width * B.height;
      f ? this.intersectionRatio = Number((j / f).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    function s(C, d) {
      var f = d || {};
      if (typeof C != "function")
        throw new Error("callback must be a function");
      if (f.root && f.root.nodeType != 1)
        throw new Error("root must be an Element");
      this._checkForIntersections = a(
        this._checkForIntersections.bind(this),
        this.THROTTLE_TIMEOUT
      ), this._callback = C, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(f.rootMargin), this.thresholds = this._initThresholds(f.threshold), this.root = f.root || null, this.rootMargin = this._rootMarginValues.map(function(B) {
        return B.value + B.unit;
      }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
    }
    s.prototype.THROTTLE_TIMEOUT = 100, s.prototype.POLL_INTERVAL = null, s.prototype.USE_MUTATION_OBSERVER = !0, s._setupCrossOriginUpdater = function() {
      return t || (t = function(C, d) {
        !C || !d ? n = v() : n = p(C, d), e.forEach(function(f) {
          f._checkForIntersections();
        });
      }), t;
    }, s._resetCrossOriginUpdater = function() {
      t = null, n = null;
    }, s.prototype.observe = function(C) {
      var d = this._observationTargets.some(function(f) {
        return f.element == C;
      });
      if (!d) {
        if (!(C && C.nodeType == 1))
          throw new Error("target must be an Element");
        this._registerInstance(), this._observationTargets.push({ element: C, entry: null }), this._monitorIntersections(C.ownerDocument), this._checkForIntersections();
      }
    }, s.prototype.unobserve = function(C) {
      this._observationTargets = this._observationTargets.filter(function(d) {
        return d.element != C;
      }), this._unmonitorIntersections(C.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
    }, s.prototype.disconnect = function() {
      this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
    }, s.prototype.takeRecords = function() {
      var C = this._queuedEntries.slice();
      return this._queuedEntries = [], C;
    }, s.prototype._initThresholds = function(C) {
      var d = C || [0];
      return Array.isArray(d) || (d = [d]), d.sort().filter(function(f, B, j) {
        if (typeof f != "number" || isNaN(f) || f < 0 || f > 1)
          throw new Error("threshold must be a number between 0 and 1 inclusively");
        return f !== j[B - 1];
      });
    }, s.prototype._parseRootMargin = function(C) {
      var d = C || "0px", f = d.split(/\s+/).map(function(B) {
        var j = /^(-?\d*\.?\d+)(px|%)$/.exec(B);
        if (!j)
          throw new Error("rootMargin must be specified in pixels or percent");
        return { value: parseFloat(j[1]), unit: j[2] };
      });
      return f[1] = f[1] || f[0], f[2] = f[2] || f[0], f[3] = f[3] || f[1], f;
    }, s.prototype._monitorIntersections = function(C) {
      var d = C.defaultView;
      if (d && this._monitoringDocuments.indexOf(C) == -1) {
        var f = this._checkForIntersections, B = null, j = null;
        if (this.POLL_INTERVAL ? B = d.setInterval(f, this.POLL_INTERVAL) : (o(d, "resize", f, !0), o(C, "scroll", f, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in d && (j = new d.MutationObserver(f), j.observe(C, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        }))), this._monitoringDocuments.push(C), this._monitoringUnsubscribes.push(function() {
          var T = C.defaultView;
          T && (B && T.clearInterval(B), c(T, "resize", f, !0)), c(C, "scroll", f, !0), j && j.disconnect();
        }), C != (this.root && this.root.ownerDocument || u)) {
          var I = w(C);
          I && this._monitorIntersections(I.ownerDocument);
        }
      }
    }, s.prototype._unmonitorIntersections = function(C) {
      var d = this._monitoringDocuments.indexOf(C);
      if (d != -1) {
        var f = this.root && this.root.ownerDocument || u, B = this._observationTargets.some(function(T) {
          var q = T.element.ownerDocument;
          if (q == C)
            return !0;
          for (; q && q != f; ) {
            var V = w(q);
            if (q = V && V.ownerDocument, q == C)
              return !0;
          }
          return !1;
        });
        if (!B) {
          var j = this._monitoringUnsubscribes[d];
          if (this._monitoringDocuments.splice(d, 1), this._monitoringUnsubscribes.splice(d, 1), j(), C != f) {
            var I = w(C);
            I && this._unmonitorIntersections(I.ownerDocument);
          }
        }
      }
    }, s.prototype._unmonitorAllIntersections = function() {
      var C = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
      for (var d = 0; d < C.length; d++)
        C[d]();
    }, s.prototype._checkForIntersections = function() {
      if (!(!this.root && t && !n)) {
        var C = this._rootIsInDom(), d = C ? this._getRootRect() : v();
        this._observationTargets.forEach(function(f) {
          var B = f.element, j = m(B), I = this._rootContainsTarget(B), T = f.entry, q = C && I && this._computeTargetAndRootIntersection(B, j, d), V = f.entry = new D({
            time: i(),
            target: B,
            boundingClientRect: j,
            rootBounds: t && !this.root ? null : d,
            intersectionRect: q
          });
          T ? C && I ? this._hasCrossedThreshold(T, V) && this._queuedEntries.push(V) : T && T.isIntersecting && this._queuedEntries.push(V) : this._queuedEntries.push(V);
        }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
      }
    }, s.prototype._computeTargetAndRootIntersection = function(C, d, f) {
      if (window.getComputedStyle(C).display != "none") {
        for (var B = d, j = E(C), I = !1; !I && j; ) {
          var T = null, q = j.nodeType == 1 ? window.getComputedStyle(j) : {};
          if (q.display == "none") return null;
          if (j == this.root || j.nodeType == /* DOCUMENT */
          9)
            if (I = !0, j == this.root || j == u)
              t && !this.root ? !n || n.width == 0 && n.height == 0 ? (j = null, T = null, B = null) : T = n : T = f;
            else {
              var V = E(j), X = V && m(V), G = V && this._computeTargetAndRootIntersection(V, X, f);
              X && G ? (j = V, T = p(X, G)) : (j = null, B = null);
            }
          else {
            var J = j.ownerDocument;
            j != J.body && j != J.documentElement && q.overflow != "visible" && (T = m(j));
          }
          if (T && (B = g(T, B)), !B) break;
          j = j && E(j);
        }
        return B;
      }
    }, s.prototype._getRootRect = function() {
      var C;
      if (this.root)
        C = m(this.root);
      else {
        var d = u.documentElement, f = u.body;
        C = {
          top: 0,
          left: 0,
          right: d.clientWidth || f.clientWidth,
          width: d.clientWidth || f.clientWidth,
          bottom: d.clientHeight || f.clientHeight,
          height: d.clientHeight || f.clientHeight
        };
      }
      return this._expandRectByRootMargin(C);
    }, s.prototype._expandRectByRootMargin = function(C) {
      var d = this._rootMarginValues.map(function(B, j) {
        return B.unit == "px" ? B.value : B.value * (j % 2 ? C.width : C.height) / 100;
      }), f = {
        top: C.top - d[0],
        right: C.right + d[1],
        bottom: C.bottom + d[2],
        left: C.left - d[3]
      };
      return f.width = f.right - f.left, f.height = f.bottom - f.top, f;
    }, s.prototype._hasCrossedThreshold = function(C, d) {
      var f = C && C.isIntersecting ? C.intersectionRatio || 0 : -1, B = d.isIntersecting ? d.intersectionRatio || 0 : -1;
      if (f !== B)
        for (var j = 0; j < this.thresholds.length; j++) {
          var I = this.thresholds[j];
          if (I == f || I == B || I < f != I < B)
            return !0;
        }
    }, s.prototype._rootIsInDom = function() {
      return !this.root || h(u, this.root);
    }, s.prototype._rootContainsTarget = function(C) {
      return h(this.root || u, C) && (!this.root || this.root.ownerDocument == C.ownerDocument);
    }, s.prototype._registerInstance = function() {
      e.indexOf(this) < 0 && e.push(this);
    }, s.prototype._unregisterInstance = function() {
      var C = e.indexOf(this);
      C != -1 && e.splice(C, 1);
    };
    function i() {
      return window.performance && performance.now && performance.now();
    }
    function a(C, d) {
      var f = null;
      return function() {
        f || (f = setTimeout(function() {
          C(), f = null;
        }, d));
      };
    }
    function o(C, d, f, B) {
      typeof C.addEventListener == "function" ? C.addEventListener(d, f, B) : typeof C.attachEvent == "function" && C.attachEvent("on" + d, f);
    }
    function c(C, d, f, B) {
      typeof C.removeEventListener == "function" ? C.removeEventListener(d, f, B) : typeof C.detatchEvent == "function" && C.detatchEvent("on" + d, f);
    }
    function g(C, d) {
      var f = Math.max(C.top, d.top), B = Math.min(C.bottom, d.bottom), j = Math.max(C.left, d.left), I = Math.min(C.right, d.right), T = I - j, q = B - f;
      return T >= 0 && q >= 0 && {
        top: f,
        bottom: B,
        left: j,
        right: I,
        width: T,
        height: q
      } || null;
    }
    function m(C) {
      var d;
      try {
        d = C.getBoundingClientRect();
      } catch (f) {
      }
      return d ? (d.width && d.height || (d = {
        top: d.top,
        right: d.right,
        bottom: d.bottom,
        left: d.left,
        width: d.right - d.left,
        height: d.bottom - d.top
      }), d) : v();
    }
    function v() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    function l(C) {
      return !C || "x" in C ? C : {
        top: C.top,
        y: C.top,
        bottom: C.bottom,
        left: C.left,
        x: C.left,
        right: C.right,
        width: C.width,
        height: C.height
      };
    }
    function p(C, d) {
      var f = d.top - C.top, B = d.left - C.left;
      return {
        top: f,
        left: B,
        height: d.height,
        width: d.width,
        bottom: f + d.height,
        right: B + d.width
      };
    }
    function h(C, d) {
      for (var f = d; f; ) {
        if (f == C) return !0;
        f = E(f);
      }
      return !1;
    }
    function E(C) {
      var d = C.parentNode;
      return C.nodeType == /* DOCUMENT */
      9 && C != u ? w(C) : d && d.nodeType == 11 && d.host ? d.host : d && d.assignedSlot ? d.assignedSlot.parentNode : d;
    }
    function w(C) {
      try {
        return C.defaultView && C.defaultView.frameElement || null;
      } catch (d) {
        return null;
      }
    }
    window.IntersectionObserver = s, window.IntersectionObserverEntry = D;
  }()), N0;
}
(function(u) {
  var e = St, t = Vr;
  Object.defineProperty(u, "__esModule", {
    value: !0
  }), u.default = void 0;
  var n = t(Wr()), D = t(St), s = e(Eu), i = t(go()), a = r;
  s.default.createElement;
  function o() {
  }
  var c = {
    contain: "react-Slidy--contain",
    cover: "react-Slidy--cover",
    fullHeight: "react-Slidy--fullHeight",
    fullWidth: "react-Slidy--fullWidth"
  }, g = function(l) {
    var p = l.ArrowLeft, h = l.ArrowRight, E = l.children, w = l.classNameBase, C = w === void 0 ? "react-Slidy" : w, d = l.doAfterDestroy, f = d === void 0 ? o : d, B = l.doAfterInit, j = B === void 0 ? o : B, I = l.doAfterSlide, T = I === void 0 ? o : I, q = l.doBeforeSlide, V = q === void 0 ? o : q, X = l.imageObjectFit, G = l.infiniteLoop, J = G === void 0 ? !1 : G, Q = l.itemsToPreload, tu = Q === void 0 ? 1 : Q, Fu = l.initialSlide, lu = Fu === void 0 ? 0 : Fu, nu = l.ease, gu = nu === void 0 ? "ease" : nu, xu = l.lazyLoadSlider, vu = xu === void 0 ? !0 : xu, R = l.lazyLoadConfig, $ = R === void 0 ? {
      offset: 150
    } : R, P = l.keyboardNavigation, W = P === void 0 ? !1 : P, x = l.numOfSlides, Z = x === void 0 ? 1 : x, S = l.sanitize, M = S === void 0 ? !0 : S, z = l.slide, H = z === void 0 ? 0 : z, y = l.slideSpeed, uu = y === void 0 ? 500 : y, N = l.showArrows, L = N === void 0 ? !0 : N, Cu = l.useFullHeight, eu = Cu === void 0 ? !1 : Cu, mu = l.useFullWidth, Uu = mu === void 0 ? !0 : mu, pu = (0, s.useState)(!vu), Iu = pu[0], Hu = pu[1], Su = (0, s.useRef)(null);
    (0, s.useEffect)(
      function() {
        var $u;
        if (vu) {
          var ie = function() {
            var Ku = $.offset, Je = Ku === void 0 ? 0 : Ku;
            $u = new window.IntersectionObserver(Y, {
              rootMargin: Je + "px 0px 0px"
            }), $u.observe(Su.current);
          };
          "IntersectionObserver" in window ? ie() : Promise.resolve().then(function() {
            return (0, D.default)(xo());
          }).then(ie);
        }
        return function() {
          return $u && $u.disconnect();
        };
      },
      []
      // eslint-disable-line
    );
    var Y = function(ie, $e) {
      var Ku = ie[0];
      (Ku.isIntersecting || Ku.intersectionRatio > 0) && ($e.unobserve(Ku.target), Hu(!0));
    }, du = Math.min(Z, s.default.Children.count(E)), Ju = [C, eu && c.fullHeight, Uu && c.fullWidth, X && c[X]].filter(Boolean).join(" "), Qu = {
      ArrowLeft: p,
      ArrowRight: h,
      children: E,
      classNameBase: C,
      doAfterDestroy: f,
      doAfterInit: j,
      doAfterSlide: T,
      doBeforeSlide: V,
      ease: gu,
      infiniteLoop: J,
      initialSlide: lu,
      itemsToPreload: tu,
      keyboardNavigation: W,
      numOfSlides: Z,
      showArrows: L,
      slide: H,
      slideSpeed: uu
    };
    return /* @__PURE__ */ (0, a.jsx)("div", {
      className: Ju,
      ref: Su,
      children: Iu && /* @__PURE__ */ (0, a.jsx)(i.default, (0, n.default)({}, Qu, {
        numOfSlides: M ? du : Z,
        children: E
      }))
    });
  }, m = g;
  u.default = m;
})(Mr);
const vo = /* @__PURE__ */ ne(Mr), yo = b.img`
  object-fit: contain;
  position: relative;
  width: 100%;
  max-height: 290px;
`, Gr = ({
  src: u
}) => /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(yo, { src: u }) }), Yr = ({
  url: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-h-full", children: /* @__PURE__ */ r.jsx(Ru, { url: u, playing: !0, loop: !0, controls: !0, className: "sp-w-full", width: "100%", height: "auto" }) }), wo = ({
  media: u
}) => {
  const [e, t] = ju(0), n = u.length, D = ({
    currentSlide: s
  }) => {
    t(s);
  };
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-text-white sp-bg-black sp-rounded-lg sp-p-2 sp-text-xl sp-w-auto sp-text-center", style: {
      opacity: 0.7,
      position: "absolute",
      right: "25px",
      zIndex: 100,
      top: "10px"
    }, children: /* @__PURE__ */ r.jsxs(ue, { children: [
      e + 1,
      " / ",
      n
    ] }) }),
    /* @__PURE__ */ r.jsx(vo, { imageObjectFit: "cover", useFullWidth: !0, numOfSlides: 1.1, itemsToPreload: 2, slideSpeed: 100, doAfterSlide: D, slide: e, children: u.map((s, i) => s.isVideo || s.url.includes(".mp4") ? /* @__PURE__ */ r.jsx("div", { className: "sp-p-2", children: /* @__PURE__ */ r.jsx(Yr, { url: s.url }) }, `item-${i}`) : /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(Gr, { src: s.url }, `item-${i}`) }, `item-${i}`)) })
  ] });
}, bo = ({
  media: u
}) => u.length === 1 ? u[0].isVideo || u[0].url.includes(".mp4") ? /* @__PURE__ */ r.jsx(Yr, { url: u[0].url }) : /* @__PURE__ */ r.jsx(Gr, { src: u[0].url }) : /* @__PURE__ */ r.jsx(wo, { media: u }), jo = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  if (e && e.length > 0)
    return /* @__PURE__ */ r.jsx("div", { className: "sp-h-full sp-py-4", children: t && /* @__PURE__ */ r.jsx(bo, { media: e }) });
}, So = (u) => {
  switch (u) {
    case "BOOK":
      return "Book now";
    case "ORDER":
      return "Order online";
    case "SHOP":
      return "Buy";
    case "LEARN_MORE":
      return "Learn more";
    case "SIGN_UP":
      return "Sign up";
    case "CALL":
      return "Call now";
    default:
      return null;
  }
}, _o = ({
  post: u
}) => {
  let e = null, t = null;
  u.event && u.event.startDate && (e = new Yu(u.event.startDate), t = new Yu(u.event.endDate));
  let n = u.caption;
  const D = So(u.callToAction.actionType);
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pt-4 sp-pb-6 sp-px-6", children: [
    /* @__PURE__ */ r.jsx(ho, { username: u.username, profilePicture: u.profilePicture }),
    u.medias && u.medias.count > 0 && /* @__PURE__ */ r.jsx(jo, { medias: u.medias }),
    u.event && u.event.title && /* @__PURE__ */ r.jsxs(Ee, { $variant: "title", children: [
      u.event.title,
      " ",
      u.topicType === "OFFER" && /* @__PURE__ */ r.jsx("span", { style: {
        display: "inline-block",
        height: "20px",
        width: "20px"
      }, children: /* @__PURE__ */ r.jsx("svg", { focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#f4b400", style: {
        height: "20px"
      }, children: /* @__PURE__ */ r.jsx("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" }) }) })
    ] }),
    e && u.topicType === "EVENT" && /* @__PURE__ */ r.jsx(Ee, { $variant: "subtitle", className: "sp-text-googlegray-500 sp-font-light", children: `${Yu(e).format("MMM D, LT")} -  ${Yu(t).format("MMM D, LT")}` }),
    e && u.topicType === "OFFER" && /* @__PURE__ */ r.jsx(Ee, { $variant: "subtitle", className: "", children: `Valid ${Yu(e).format("MMM D")} -  ${Yu(t).format("MMM D")}` }),
    n && /* @__PURE__ */ r.jsx(Ee, { $variant: "caption", className: `sp-flex sp-flex-col sp-mt-6 sp-pb-6 ${e ? "sp-text-googlegray-500 sp-font-light" : null}`, style: {
      fontSize: e ? "13px" : ""
    }, children: /* @__PURE__ */ r.jsx(Nu, { caption: n }) }),
    u.topicType === "OFFER" && u.offer && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      u.offer.couponCode && /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-mb-6 sp-bg-googlegray-100 sp-border-dashed sp-border-googlegray-200 sp-p-6", children: [
        /* @__PURE__ */ r.jsx(ue, { className: "sp-text-googlegray-500 sp-text-xl sp-pb-2", children: "Show this code at the shop" }),
        /* @__PURE__ */ r.jsx(ue, { className: "sp-font-medium sp-text-5xl sp-pb-2", children: u.offer.couponCode }),
        /* @__PURE__ */ r.jsx(ue, { className: "sp-text-lg sp-font-bold", children: `Valid ${Yu(e).format("l, LT")} - ${Yu(t).format("l, LT")}` })
      ] }),
      u.offer.redeemOnlineUrl && /* @__PURE__ */ r.jsx("a", { href: u.offer.redeemOnlineUrl, className: "sp-text-blue-700 sp-no-underline sp-text-2xl", target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsx(ue, { children: "Redeem online" }) })
    ] }),
    u.callToAction && D && /* @__PURE__ */ r.jsx("div", { className: "sp-mb-2 sp-pt-4 sp-my-2", children: /* @__PURE__ */ r.jsx("a", { href: u.callToAction.url, target: "_blank", className: "sp-no-underline sp-inline", children: /* @__PURE__ */ r.jsx(ue, { $variant: "buttonlabel", style: {
      width: "auto"
    }, className: " sp-text-white sp-bg-googleblue-500 sp-py-4 sp-px-6 sp-text-xl sp-no-underline hover:sp-bg-googleblue-600 sp-rounded hover:sp-shadow-lg", children: D }) }) }),
    u.topicType === "OFFER" && u.offer && u.offer.termsConditions && /* @__PURE__ */ r.jsx("div", { className: "sp-border-googlegray-300 sp-border-solid sp-mt-4 sp-pt-4", style: {
      borderWidth: 0,
      borderTopWidth: "1px"
    }, children: /* @__PURE__ */ r.jsx(ue, { className: "sp-text-base sp-text-googlegray-400", children: u.offer.termsConditions }) })
  ] });
}, No = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "gmb":
      return /* @__PURE__ */ r.jsx(_o, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, _t = b.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 15px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, $o = ({
  username: u,
  profilePicture: e,
  small: t,
  description: n
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "", children: /* @__PURE__ */ r.jsx(_t, { $variant: "subheading", className: "sp-mb-1", children: u }) }) })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-ml-8 sp-mr-4", style: {
    paddingLeft: "40px"
  }, children: /* @__PURE__ */ r.jsx(_t, { $variant: "caption", className: "sp-mb-1", children: /* @__PURE__ */ r.jsx(Nu, { caption: n }) }) })
] }), ko = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-relative", style: {}, children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, width: "100%", height: "auto", className: "" }) }) : null, qr = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: D = !0
}) => e && n === !1 ? null : /* @__PURE__ */ r.jsx(r.Fragment, { children: (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(ko, { url: u.url, forCarousel: t, isActiveSlide: D }) }), To = b.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Po = ({
  medias: u
}) => {
  const [e, t] = ju(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, D) => !e && D > 3 ? null : /* @__PURE__ */ r.jsx(To, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(qr, { media: n, forCarousel: !0, hidden: D > 3, mediaCount: u.length, showOverlay: D === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${D}`)) });
}, Ro = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsx("div", { children: t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(Po, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(qr, { media: e[0] }) }) });
}, Io = ({
  post: u
}) => {
  let e = u.ytTitle;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pb-4", children: [
    /* @__PURE__ */ r.jsx(Ro, { medias: u.medias }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-mt-2 sp-mb-2 sp-flex sp-flex-col sp-border-0 sp-border-b sp-border-solid sp-border-gray-300", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-mt-4 sp-mb-6 sp-m-2", children: /* @__PURE__ */ r.jsx(_t, { $variant: "heading", className: "sp-whitespace-pre-line sp-break-words", children: e }) }),
      /* @__PURE__ */ r.jsx("div", {})
    ] }),
    /* @__PURE__ */ r.jsx($o, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName, description: u.caption })
  ] });
}, Oo = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
      return /* @__PURE__ */ r.jsx(Io, { post: u });
    case "image":
    case "multiMedia":
    case "text":
    case "story":
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, ct = b.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 2.5rem;
          line-height: 3rem;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.5rem;
          line-height: 2.2rem;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, Be = b.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.8rem;
          line-height: 2rem;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, Lo = ({
  username: u,
  boardTitle: e,
  boardSectionTitle: t,
  profilePicture: n,
  small: D,
  description: s,
  url: i,
  title: a
}) => {
  let o = null;
  if (i)
    try {
      const {
        hostname: c
      } = new URL(i);
      o = c;
    } catch (c) {
    }
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-p-4 sp-px-8", children: [
      i && o && /* @__PURE__ */ r.jsx("div", { className: "sp-pb-4", children: /* @__PURE__ */ r.jsxs(ct, { $variant: "caption", children: [
        "Article from",
        " ",
        /* @__PURE__ */ r.jsx("a", { href: i, target: "_blank", style: {
          color: "inherit",
          textDecoration: "none"
        }, rel: "noreferrer", children: /* @__PURE__ */ r.jsx(Be, { $variant: "bold", children: o }) })
      ] }) }),
      a && /* @__PURE__ */ r.jsx("div", { className: "sp-pb-4", children: /* @__PURE__ */ r.jsx(Mo, { url: i, children: /* @__PURE__ */ r.jsx(ct, { $variant: "heading", children: a }) }) }),
      s && /* @__PURE__ */ r.jsx(ct, { $variant: "caption", children: /* @__PURE__ */ r.jsx(Nu, { caption: s, targetPlatform: "PI" }) })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-px-8", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-4", style: {
        width: "40px",
        height: "40px",
        minWidth: "40px",
        minHeight: "40px"
      }, children: /* @__PURE__ */ r.jsx(zu, { src: n, alt: u }) }),
      /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${D ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "", children: [
        /* @__PURE__ */ r.jsxs(Be, { $variant: "bold", className: "sp-mb-1", children: [
          u,
          " "
        ] }),
        /* @__PURE__ */ r.jsx(Be, { children: "saved to " }),
        t && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(Be, { $variant: "bold", className: "sp-mb-1", children: t }),
          " ",
          "in "
        ] }),
        /* @__PURE__ */ r.jsx(Be, { $variant: "bold", className: "sp-mb-1", children: e })
      ] }) })
    ] })
  ] });
}, Mo = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), zo = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
  border-radius: 20px;
`, Uo = ({
  src: u
}) => /* @__PURE__ */ r.jsx(zo, { src: u }), Ho = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-relative", style: {
  borderRadius: "10px"
}, children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, width: "100%", height: "auto", className: "" }) }) : null, Vo = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: D = !0
}) => e && n === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(Ho, { url: u.url, forCarousel: t, isActiveSlide: D }) : /* @__PURE__ */ r.jsx(Uo, { src: u.url }), Wo = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(Go, { children: t > 0 && /* @__PURE__ */ r.jsx(Vo, { media: e[0] }) });
}, Go = b.div`
  border-radius: 20px;
  overflow: hidden;
`, Yo = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), qo = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(Zo, { className: "sp-bg-white md:sp-shadow-around sp-pb-8", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-pb-4", children: /* @__PURE__ */ r.jsx(Yo, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(Wo, { medias: u.medias }) }) }),
  /* @__PURE__ */ r.jsx(Lo, { username: u.username, small: !1, profilePicture: u.profilePicture, description: u.caption, title: u.piTitle, boardTitle: u.boardTitle, boardSectionTitle: u.boardSectionTitle, url: u.redirectUrl })
] }), Zo = b.div`
  padding: 35px 28px 28px;
`, Ko = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(qo, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Xo = b.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`, Jo = b.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, Qo = ({
  src: u
}) => /* @__PURE__ */ r.jsx(Jo, { src: u }), u1 = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Ru, { controls: !0, url: u, width: "100%", height: "auto", style: {
  display: "grid",
  placeContent: "center",
  minHeight: "600px",
  background: "grey"
} }) }) : null, e1 = ({
  media: u,
  hidden: e = !1,
  showAll: t,
  isActiveSlide: n = !0
}) => e && t === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(u1, { url: u.url, isActiveSlide: n }) : /* @__PURE__ */ r.jsx(Xo, { children: /* @__PURE__ */ r.jsx(Qo, { src: u.url }) }), t1 = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(r1, { children: t > 0 && /* @__PURE__ */ r.jsx(e1, { media: e[0] }) });
}, r1 = b.div`
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 270px - 1rem);
  background: grey;
`, Zr = b.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, n1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "10 6 14 14" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_89)" }, /* @__PURE__ */ F.createElement("path", { d: "M23.6165 19.615C23.3689 19.8635 23.04 20 22.6891 20C22.3391 20 22.0093 19.8635 21.7617 19.615L19.4195 17.2735C18.4363 17.9069 17.2914 18.2435 16.1219 18.243C14.9112 18.2432 13.7277 17.8843 12.721 17.2118C11.7143 16.5392 10.9296 15.5832 10.4662 14.4647C10.0028 13.3462 9.88143 12.1153 10.1175 10.9278C10.3536 9.74027 10.9365 8.64946 11.7925 7.79325C12.6485 6.93706 13.7392 6.35396 14.9265 6.11769C16.1139 5.88142 17.3447 6.00259 18.4632 6.46589C19.5817 6.92919 20.5378 7.71379 21.2104 8.72049C21.883 9.72718 22.242 10.9107 22.242 12.1215C22.2426 13.2902 21.907 14.4344 21.2752 15.4176L23.6165 17.76C23.8621 18.0062 24 18.3398 24 18.6875C24 19.0352 23.8621 19.3688 23.6165 19.615ZM16.1219 8.625C15.6628 8.625 15.2081 8.71545 14.7839 8.89116C14.3598 9.06687 13.9743 9.32442 13.6497 9.6491C13.325 9.97378 13.0675 10.3592 12.8918 10.7834C12.7161 11.2077 12.6257 11.6623 12.6257 12.1215C12.6257 12.5807 12.7161 13.0353 12.8918 13.4595C13.0675 13.8838 13.325 14.2692 13.6497 14.5939C13.9743 14.9186 14.3598 15.1761 14.7839 15.3519C15.2081 15.5276 15.6628 15.618 16.1219 15.618C17.0493 15.618 17.9387 15.2496 18.5944 14.5938C19.2502 13.938 19.6186 13.0485 19.6186 12.1211C19.6186 11.1936 19.2502 10.3042 18.5944 9.64836C17.9387 8.99256 17.0493 8.62412 16.1219 8.62412V8.625Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_89", x: 0, y: 0, width: 34, height: 34, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_89" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_89", result: "shape" })))), D1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M14.0463 1.18364C13.2625 0.399877 12.2228 0 11.1831 0C10.1435 0 9.11978 0.399877 8.32003 1.18364L7.64823 1.85543L6.97644 1.18364C6.19268 0.399877 5.153 0 4.11332 0C2.46583 0 0.834332 0.991695 0.178533 2.95909C-0.253334 4.28668 0.114553 5.75823 1.10625 6.74992L7.15239 12.7961C7.4243 13.068 7.84018 13.068 8.11209 12.7961L14.0143 6.89388C15.6298 5.32636 15.6298 2.75115 14.0463 1.18364Z", fill: "white" })), s1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M1.68328 11.6584C0.823728 12.0881 -0.0881374 11.1763 0.34164 10.3167L1.5049 7.99021C2.12365 6.7527 2.05895 5.2833 1.33382 4.10496L0.201123 2.26433C-0.314794 1.42596 0.56357 0.425049 1.46184 0.827721L11.0744 5.13679C11.8442 5.48188 11.8671 6.56645 11.1125 6.94373L1.68328 11.6584Z", fill: "white" })), i1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ F.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ F.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), a1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 14 8" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_103)" }, /* @__PURE__ */ F.createElement("path", { d: "M21 7C20.7545 7 20.5556 7.19899 20.5556 7.44444V9.55555H18.4444C18.199 9.55555 18 9.75453 18 10C18 10.2455 18.199 10.4444 18.4444 10.4444H20.5556V12.5556C20.5556 12.801 20.7545 13 21 13C21.2455 13 21.4444 12.801 21.4444 12.5556V10.4444H23.5555C23.801 10.4444 24 10.2455 24 10C24 9.75453 23.801 9.55555 23.5555 9.55555H21.4444V7.44444C21.4444 7.19899 21.2455 7 21 7Z", fill: "white" }), /* @__PURE__ */ F.createElement("path", { d: "M10.8872 14C11.0037 14.0002 11.1191 13.9808 11.2267 13.9429C11.3343 13.9051 11.432 13.8495 11.5141 13.7794L13.5 12.0955L15.4782 13.7729C15.6019 13.8802 15.7606 13.9537 15.9339 13.984C16.1072 14.0143 16.2872 13.9999 16.4508 13.9427C16.6144 13.8856 16.7541 13.7883 16.852 13.6633C16.9498 13.5383 17.0014 13.3913 17 13.2413V7.16129C17 6.8533 16.8557 6.55792 16.5988 6.34013C16.342 6.12235 15.9936 6 15.6304 6H11.3696C11.0063 6 10.658 6.12235 10.4011 6.34013C10.1443 6.55792 10 6.8533 10 7.16129V13.2477C10.0004 13.4471 10.094 13.6383 10.2603 13.7793C10.4266 13.9203 10.652 13.9997 10.8872 14ZM10.913 7.16129C10.913 7.05863 10.9611 6.96017 11.0468 6.88757C11.1324 6.81498 11.2485 6.77419 11.3696 6.77419H15.6304C15.7515 6.77419 15.8676 6.81498 15.9532 6.88757C16.0388 6.96017 16.0869 7.05863 16.0869 7.16129V13.1948L13.5 11.0013L10.913 13.1948V7.16129Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_103", x: 0, y: 0, width: 34, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_103" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_103", result: "shape" })))), o1 = b.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, l1 = b(Zr)`
  position: absolute;
  top: 17px;
  z-index: 2;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
    font-size: 16px;
  }

  svg {
    position: relative;
    left: -50%;
    width: 14px;
  }
`, c1 = b.div`
  position: absolute;
  right: 7px;
  bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 15px;
  }
`, Ft = b.div`
  width: 32px;
  display: grid;
  place-content: center;
  height: 32px;
`, Et = b.div`
  width: 32px;
  height: 32px;
  opacity: 0.2;
  border-radius: 50%;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: white;
  position: absolute;
`, F1 = b.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 22px;
  height: 22px;
  border-radius: 50%;
`, E1 = b.div`
  position: absolute;
  z-index: 2;
  padding: 7px;
  display: flex;
  align-items: center;
  height: 22px;
  gap: 4px;
  bottom: 45px;

  p {
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  }

  .bookmarkIconWrap {
    position: relative;
    top: -2px;
    left: 4px;
    height: 8px;

    svg {
      height: 8px;
    }
  }
`, C1 = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), d1 = ({
  medias: u,
  profilePicture: e,
  username: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ r.jsxs(l1, { children: [
    /* @__PURE__ */ r.jsx(n1, {}),
    /* @__PURE__ */ r.jsx("span", { children: "Spotlight You" })
  ] }) }),
  /* @__PURE__ */ r.jsx(t1, { medias: u }),
  /* @__PURE__ */ r.jsxs(c1, { children: [
    /* @__PURE__ */ r.jsxs(Ft, { children: [
      /* @__PURE__ */ r.jsx(Et, {}),
      /* @__PURE__ */ r.jsx(D1, {})
    ] }),
    /* @__PURE__ */ r.jsxs(Ft, { children: [
      /* @__PURE__ */ r.jsx(Et, {}),
      /* @__PURE__ */ r.jsx(s1, {})
    ] }),
    /* @__PURE__ */ r.jsxs(Ft, { children: [
      /* @__PURE__ */ r.jsx(Et, {}),
      /* @__PURE__ */ r.jsx(i1, {})
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs(E1, { children: [
    /* @__PURE__ */ r.jsx(F1, { $profilePicture: e }),
    /* @__PURE__ */ r.jsxs(Zr, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      t
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: "bookmarkIconWrap", children: /* @__PURE__ */ r.jsx(a1, {}) })
  ] })
] }), A1 = ({
  post: u
}) => /* @__PURE__ */ r.jsx(o1, { children: /* @__PURE__ */ r.jsx(C1, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(d1, { medias: u.medias, username: u.username, profilePicture: u.profilePicture }) }) }), p1 = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(A1, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, f1 = b.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, h1 = ({
  src: u
}) => /* @__PURE__ */ r.jsx(f1, { src: u }), m1 = ({
  url: u,
  isActiveSlide: e,
  videoCoverPreview: t
}) => {
  const [n, D] = ju(!1), [s, i] = ju(!1), [a, o] = ju(0);
  return Zu(() => {
    t && (D(!1), i(!1), o((c) => c + 1));
  }, [t]), e ? /* @__PURE__ */ r.jsxs(B1, { className: "sp-relative", style: {
    minHeight: "500px",
    width: "100%"
  }, children: [
    !n && s && /* @__PURE__ */ r.jsx(g1, { children: /* @__PURE__ */ r.jsx(vr, { onClick: () => {
      D(!1), i(!1), o((c) => c + 1);
    } }) }),
    /* @__PURE__ */ r.jsx(Ru, { playing: !0, onPlay: () => {
      D(!0), i(!0);
    }, onPause: () => D(!1), controls: !0, light: t, url: u, width: "100%", height: "auto", style: {
      display: t ? "flex" : "grid",
      placeContent: "center",
      minHeight: "500px",
      background: "grey"
    } }, a)
  ] }) : null;
}, B1 = b.div`
  minheight: 500px;
  width: 100%;

  .react-player__preview {
    height: calc(-270px - 1rem + 100vh) !important;
    background-repeat: no-repeat !important;
  }
`, g1 = b.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, x1 = ({
  media: u,
  hidden: e = !1,
  showAll: t,
  isActiveSlide: n = !0,
  videoCoverPreview: D
}) => e && t === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(m1, { url: u.url, isActiveSlide: n, videoCoverPreview: D }) : /* @__PURE__ */ r.jsx(h1, { src: u.url }), v1 = ({
  medias: u,
  videoCoverPreview: e
}) => {
  const t = u.collection, n = t.length;
  return /* @__PURE__ */ r.jsx(y1, { children: n > 0 && /* @__PURE__ */ r.jsx(x1, { videoCoverPreview: e, media: t[0] }) });
}, y1 = b.div`
  overflow: hidden;
  border-radius: 15px;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc((100vh - 270px) - 1rem);
  background: grey;
  display: flex;
`, Nt = b.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, w1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 52, height: 49, viewBox: "0 0 52 49", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("g", { filter: "url(#filter0_d_0_24)" }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1429 6C23.7143 6 26 9.01299 26 9.01299C26 9.01299 28.2857 6 32.8571 6C38.1905 6 42 10.1428 42 15.4156C42 21.4416 37.0188 26.8133 32.4762 30.8571C29.6716 33.3537 27.5238 35 26 35C24.4762 35 22.2674 33.3412 19.5238 30.8571C15.0583 26.814 10 21.4416 10 15.4156C10 10.1428 13.8095 6 19.1429 6Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_24", x: 0, y: 0, width: 52, height: 49, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_24" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_24", result: "shape" })))), b1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 51, height: 50, viewBox: "0 0 51 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_25)" }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1286 29.6848C39.2029 26.6131 41 23.4136 41 19.6882C41 12.1283 34.0609 6 25.5 6C16.9391 6 10 12.1283 10 19.6884C10 27.2485 17.1636 32.4385 25.7246 32.4385V34.9456C25.7246 35.74 26.5504 36.2512 27.2507 35.8726C29.4385 34.6901 33.4926 32.3184 36.1286 29.6848ZM17.9706 17.8423C19.1941 17.8423 20.1859 18.8244 20.1859 20.0341C20.1859 21.2463 19.1941 22.2284 17.9706 22.2284C16.7492 22.2284 15.7573 21.2463 15.7573 20.0341C15.7573 18.8244 16.7492 17.8423 17.9706 17.8423ZM27.7144 20.0341C27.7144 18.8244 26.7229 17.8423 25.5 17.8423C24.2772 17.8423 23.2858 18.8244 23.2858 20.0341C23.2858 21.2463 24.2773 22.2284 25.5 22.2284C26.7229 22.2284 27.7144 21.2463 27.7144 20.0341ZM33.0291 17.8423C34.2524 17.8423 35.2428 18.8244 35.2428 20.0341C35.2428 21.2463 34.2524 22.2284 33.0291 22.2284C31.8058 22.2284 30.814 21.2463 30.8142 20.0341C30.8142 18.8244 31.8058 17.8423 33.0291 17.8423Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_25", x: 0, y: 0, width: 51, height: 50, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_25" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_25", result: "shape" })))), j1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 51, height: 44, viewBox: "0 0 51 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_23)" }, /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.2228 7.13786C27.2228 6.13946 28.4318 5.62698 29.1629 6.31551L40.2873 16.7934C41.2662 17.7155 41.2321 19.2704 40.2135 20.1494L29.1259 29.7178C28.3833 30.3588 27.2228 29.8372 27.2228 28.8623V24.5263C27.2228 24.5263 15.318 22.4052 11.4993 29.3377C11.1432 29.984 9.75548 30.2101 10.0376 26.9853C11.2172 21.05 13.628 11.7838 27.2228 11.7838V7.13786Z", fill: "white" })), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("filter", { id: "filter0_d_0_23", x: 0, y: 0, width: 51, height: 44, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ F.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ F.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ F.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ F.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ F.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ F.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_23" }), /* @__PURE__ */ F.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_23", result: "shape" })))), S1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 14, height: 15, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1249 1.87579C12.1249 1.63512 11.9014 1.45676 11.6668 1.51012L5.6712 2.87348C5.5005 2.91229 5.37934 3.06409 5.37934 3.23914V12.0902H5.37897C5.3889 12.9029 4.5507 13.7484 3.35438 14.0689C2.01898 14.4267 0.743054 13.9951 0.504513 13.1048C0.265968 12.2146 1.15513 11.2028 2.49052 10.845C2.97713 10.7146 3.45585 10.6891 3.87934 10.7523V3.23914C3.87934 2.36382 4.48504 1.60493 5.33861 1.41083L11.3342 0.0474661C12.5075 -0.219354 13.6249 0.672475 13.6249 1.87579V10.2609C13.6564 11.0828 12.8123 11.9454 11.6011 12.2699C10.2657 12.6277 8.98976 12.1961 8.75123 11.3058C8.51269 10.4156 9.40185 9.4038 10.7372 9.04598C11.2234 8.91574 11.7017 8.89009 12.1249 8.95313V1.87579Z", fill: "white" })), _1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("path", { d: "M27.4365 8.78874L27.2831 7.33075C27.1539 6.10359 26.1191 5.172 24.8852 5.172H5.11487C3.88093 5.172 2.84612 6.1036 2.71695 7.33075L2.56348 8.78874", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ F.createElement("path", { d: "M11.25 1L15.625 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ F.createElement("path", { d: "M19.375 1L15 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ F.createElement("path", { d: "M2.5 23.8585L2.71692 25.9193C2.8461 27.1465 3.88091 28.0781 5.11484 28.0781H24.8851C26.1191 28.0781 27.1539 27.1465 27.283 25.9193L27.5 23.8585", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ F.createElement("path", { d: "M1.28897 21.25V11.6692H3.3146V19.5799H7.42201V21.25H1.28897ZM10.7891 11.6692V21.25H8.76346V11.6692H10.7891ZM14.1866 11.6692L16.5023 18.9484H16.5912L18.9115 11.6692H21.157L17.8542 21.25H15.2438L11.9364 11.6692H14.1866ZM22.3102 21.25V11.6692H28.766V13.3393H24.3358V15.6222H28.4339V17.2923H24.3358V19.5799H28.7847V21.25H22.3102Z", fill: "white" })), N1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 23, height: 23, viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("circle", { cx: 9.04035, cy: 9.04035, r: 8.04035, stroke: "white", strokeWidth: 2 }), /* @__PURE__ */ F.createElement("path", { d: "M21.2621 21.9124C21.6526 22.3029 22.2858 22.3029 22.6763 21.9124C23.0668 21.5219 23.0668 20.8887 22.6763 20.4982L21.2621 21.9124ZM14.1996 14.8499L21.2621 21.9124L22.6763 20.4982L15.6138 13.4357L14.1996 14.8499Z", fill: "white" })), $1 = (u) => /* @__PURE__ */ F.createElement("svg", U({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, u), /* @__PURE__ */ F.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#FF0505" }), /* @__PURE__ */ F.createElement("rect", { x: 9, y: 5, width: 2, height: 9, rx: 1, fill: "white" }), /* @__PURE__ */ F.createElement("rect", { x: 5.5, y: 10.5, width: 2, height: 9, rx: 1, transform: "rotate(-90 5.5 10.5)", fill: "white" })), k1 = b.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  ${(u) => u.$env === "schedugram-client" && `
    margin: 0 50px;
    @media (max-width: 1279px) {
      margin: 0;
    }
  `}}
`, T1 = b.div`
  position: absolute;
  top: 42px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`, P1 = b.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 600;
    color: white;
    font-family: "Inter";
  }
`, R1 = b.p`
  opacity: 0.6;
  margin: 0;
`, I1 = b.p`
  margin: 0 0 -2px 15px;
`, O1 = b.span`
  display: block;
  height: 2px;
  width: 30px;
  background-color: white;
  margin: 0 auto;
`, L1 = b.div`
  position: absolute;
  right: 10px;
  bottom: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 45px;
    height: 45px;
  }
`, M1 = b.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50%;
  position: relative;
  display: grid;
  place-items: center;
  margin-bottom: 20px;

  svg {
    position: absolute;
    bottom: -10px;
    height: auto;
  }
`, z1 = b.div`
  position: absolute;
  bottom: 8px;
  z-index: 2;
  padding: 10px;

  .description {
    line-height: 16px;
    width: 210px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  svg.musicIcon {
    margin-top: 14px;
  }
`, U1 = ({
  url: u,
  ContentItem: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), H1 = ({
  medias: u,
  profilePicture: e,
  username: t,
  description: n,
  videoCoverPreview: D
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ r.jsxs(T1, { children: [
    /* @__PURE__ */ r.jsx(_1, {}),
    /* @__PURE__ */ r.jsxs(P1, { children: [
      /* @__PURE__ */ r.jsx(R1, { children: "Following" }),
      /* @__PURE__ */ r.jsxs(I1, { children: [
        "For You ",
        /* @__PURE__ */ r.jsx(O1, {})
      ] })
    ] }),
    /* @__PURE__ */ r.jsx(N1, {})
  ] }) }),
  /* @__PURE__ */ r.jsx(v1, { medias: u, videoCoverPreview: D }),
  /* @__PURE__ */ r.jsxs(L1, { children: [
    /* @__PURE__ */ r.jsx(M1, { $profilePicture: e, children: /* @__PURE__ */ r.jsx($1, { className: "sp-w-8" }) }),
    /* @__PURE__ */ r.jsx(w1, {}),
    /* @__PURE__ */ r.jsx(b1, {}),
    /* @__PURE__ */ r.jsx(j1, {})
  ] }),
  /* @__PURE__ */ r.jsxs(z1, { children: [
    /* @__PURE__ */ r.jsxs(Nt, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      t
    ] }),
    /* @__PURE__ */ r.jsx(Nt, { className: "description", children: /* @__PURE__ */ r.jsx(Nu, { caption: n, targetPlatform: "TT" }) }),
    /* @__PURE__ */ r.jsx(S1, { className: "musicIcon" })
  ] })
] }), V1 = b.div`
  margin: 17px 5px 0 5px;
  font-size: 14px;
  line-height: 17px;
`, W1 = ({
  post: u,
  env: e,
  videoCoverPreview: t
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(k1, { $env: e, children: /* @__PURE__ */ r.jsx(U1, { ContentItem: /* @__PURE__ */ r.jsx(H1, { medias: u.medias, username: u.username, profilePicture: u.profilePicture, description: u.caption, videoCoverPreview: t }), url: u.redirectUrl }) }),
  u.caption && /* @__PURE__ */ r.jsxs(V1, { children: [
    /* @__PURE__ */ r.jsxs(Nt, { className: "sp-font-bold sp-text-black", children: [
      "@",
      u.username
    ] }),
    /* @__PURE__ */ r.jsx(Nu, { caption: u.caption, targetPlatform: "TT" })
  ] })
] }), G1 = ({
  post: u,
  env: e,
  videoCoverPreview: t
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(W1, { post: u, env: e, videoCoverPreview: t });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Kr = b.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, Y1 = ({
  username: u,
  profilePicture: e,
  small: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "sp-font-sans", children: /* @__PURE__ */ r.jsx(Kr, { $variant: "heading", className: "sp-mb-1", children: u }) }) })
] }), q1 = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Z1 = b.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, K1 = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: D,
  mediaCount: s
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(Z1, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => D(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      s - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(q1, { src: u }) }), X1 = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, className: "sp-relative", width: "100%", height: "auto" }) }) : null, Xr = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: D,
  setShowAll: s,
  mediaCount: i,
  isActiveSlide: a = !0
}) => e && D === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(X1, { url: u.url, forCarousel: t, isActiveSlide: a }),
  !(u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(K1, { src: u.url, forCarousel: t, showOverlay: n, showAll: D, setShowAll: s, mediaCount: i })
] }), J1 = () => /* @__PURE__ */ r.jsx("div", { className: "sp-py-2 sp-w-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-start sp-text-black sp-py-4 sp-pl-0", children: [
  /* @__PURE__ */ r.jsx(ze, { icon: "icon-instagram-heart" }),
  /* @__PURE__ */ r.jsx(ze, { icon: "icon-instagram-comment" }),
  /* @__PURE__ */ r.jsx(ze, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ r.jsx(ze, { icon: "icon-instagram-share" })
] }) }), ze = ({
  icon: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-start sp-pr-4 ", children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-3xl ${u}` }) }), Q1 = b.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, ul = ({
  medias: u
}) => {
  const [e, t] = ju(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, D) => !e && D > 3 ? null : /* @__PURE__ */ r.jsx(Q1, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Xr, { media: n, forCarousel: !0, hidden: D > 3, mediaCount: u.length, showOverlay: D === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${D}`)) });
}, el = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-px-4", children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(ul, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(Xr, { media: e[0] }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(J1, {}) })
  ] });
}, tl = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(Y1, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ r.jsxs(Kr, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(Nu, { caption: e, targetPlatform: "TH" }),
      u.redirectUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(Xe, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(el, { medias: u.medias })
  ] });
}, rl = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(tl, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, k0 = b.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 2.5rem;
          line-height: 3rem;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.3rem;
          line-height: 1.8rem;
          white-space: pre-line;
        `;
    case "link":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.3rem;
          line-height: 1.8rem;
          white-space: pre-line;
          font-weight: bold;
          color: black;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, nl = b.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.8rem;
          line-height: 2rem;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, Dl = ({
  username: u,
  profilePicture: e,
  small: t,
  description: n,
  url: D
}) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("div", { className: "sp-pt-4 sp-pb-2 sp-px-0 sp-flex sp-flex-row", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-px-1", children: /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-4", style: {
    width: "40px",
    height: "40px",
    minWidth: "40px",
    minHeight: "40px"
  }, children: /* @__PURE__ */ r.jsx(zu, { src: e, alt: u }) }) }),
  /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "", children: /* @__PURE__ */ r.jsxs(nl, { $variant: "bold", className: "sp-mb-1", children: [
      u,
      " "
    ] }) }) }),
    n && /* @__PURE__ */ r.jsx(k0, { $variant: "caption", children: /* @__PURE__ */ r.jsx(Nu, { caption: n }) }),
    D && /* @__PURE__ */ r.jsxs("div", { className: "sp-py-2", children: [
      " ",
      /* @__PURE__ */ r.jsx("a", { href: D, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsx(k0, { $variant: "link", children: "URL for post" }) })
    ] })
  ] })
] }) }), sl = b.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, il = ({
  src: u
}) => /* @__PURE__ */ r.jsx(sl, { src: u }), al = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-relative", style: {}, children: /* @__PURE__ */ r.jsx(Ru, { url: u, controls: !0, width: "100%", height: "auto", className: "" }) }) : null, ol = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: D = !0
}) => e && n === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(al, { url: u.url, forCarousel: t, isActiveSlide: D }) : /* @__PURE__ */ r.jsx(il, { src: u.url }), ll = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(cl, { children: t > 0 && /* @__PURE__ */ r.jsx(ol, { media: e[0] }) });
}, cl = b.div`
  overflow: hidden;
`, Fl = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), El = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(Cl, { className: "sp-bg-white md:sp-shadow-around sp-pb-6", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ r.jsx(Dl, { username: u.username, profilePicture: u.profilePicture, description: u.caption, small: !1, url: u.redirectUrl }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-pb-2", style: {
    paddingLeft: "47px"
  }, children: /* @__PURE__ */ r.jsx(Fl, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(ll, { medias: u.medias }) }) })
] }), Cl = b.div`
  padding: 1.1em;
`, dl = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(El, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
};
class Al extends Cn {
  constructor(e) {
    super(e), this.state = {
      hasError: !1
    }, this.post = e.post;
  }
  // @ts-expect-error not sure why this is here but it's not used
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(e) {
    return {
      hasError: !0
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(e, t) {
    console.log(e);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-w-full sp-border-2 sp-border-solid sp-border-gray-300 sp-rounded-lg sp-p-8 sp-h-500px sp-shadow-lg", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-text-4xl sp-mb-8 sp-text-red-500 sp-font-bold", children: "Failed to load preview" }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-text-3xl sp-text-red-500", children: "Please contact Sked support" })
    ] }) : this.props.children;
  }
}
const Jr = dn({
  post: null
}), bl = ({
  post: u,
  trackEvent: e,
  className: t,
  env: n,
  videoCoverPreview: D
}) => /* @__PURE__ */ r.jsx(fl, { children: /* @__PURE__ */ r.jsx(Al, { post: u || {}, children: /* @__PURE__ */ r.jsx(Jr.Provider, { value: {
  post: u,
  className: t,
  env: n,
  videoCoverPreview: D
}, children: /* @__PURE__ */ r.jsx(pl, { post: u, trackEvent: e, className: t, videoCoverPreview: D, env: n }, u == null ? void 0 : u.id) }) }) }), pl = ({
  post: u,
  trackEvent: e,
  className: t,
  env: n,
  videoCoverPreview: D
}) => {
  if (u === null)
    throw new Error("PreviewBuilder: null post, unknown platform");
  const s = u.platform;
  switch (s) {
    case "IG":
      return /* @__PURE__ */ r.jsx(pa, { post: u, className: t, env: n });
    case "FB":
      return /* @__PURE__ */ r.jsx(Oa, { post: u });
    case "TW":
      return /* @__PURE__ */ r.jsx(Za, { post: u });
    case "LI":
      return /* @__PURE__ */ r.jsx(po, { post: u, trackEvent: e });
    case "GMB":
      return /* @__PURE__ */ r.jsx(No, { post: u });
    case "YT":
      return /* @__PURE__ */ r.jsx(Oo, { post: u });
    case "PI":
      return /* @__PURE__ */ r.jsx(Ko, { post: u });
    case "SC":
      return /* @__PURE__ */ r.jsx(p1, { post: u });
    case "TT":
      return /* @__PURE__ */ r.jsx(G1, { post: u, env: n, videoCoverPreview: D });
    case "TH":
      return /* @__PURE__ */ r.jsx(rl, { post: u });
    case "OT":
      return /* @__PURE__ */ r.jsx(dl, { post: u });
    default:
      throw new Error(`PreviewBuilder: unknown platform ${s}`);
  }
}, fl = b.div`
  font-family: "Gotham SSm A", "Gotham SSm B", "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
class Qr {
  constructor(e) {
    this.medias = [e], e.mediaFiles && e.mediaFiles.length > 0 && (this.medias = e.mediaFiles), this.collection = this.buildCollection(this.medias), this.count = this.collection.length;
  }
  buildCollection(e) {
    let t = e.map((n) => {
      if (n.url)
        return {
          url: (n.url.toLowerCase().endsWith(".heic") || n.url.toLowerCase().endsWith(".heif")) && n.thumbnailUrl ? n.thumbnailUrl : n.url,
          type: n.type,
          isVideo: n.isVideo
        };
    });
    return t[0] ? t : [];
  }
}
class jl {
  constructor(e, t, n, D) {
    this.providedPost = e, this.id = e.post_id, this.stage = e.post_stage, this.caption = e.caption, this.currentStatusKey = e.post_status_key, this.rejectionReason = "", this.scheduledFor = e.when, this.image_url = e.url, this.comment = e.firstcomment || e.first_comment, this.locationName = e.location && e.location.name, this.redirectUrl = e.redirectUrl ? e.redirectUrl : "", this.storyUrl = e.storyUrl ? e.storyUrl : "", this.storyLabel = e.storyLabel ? e.storyLabel : "", this.storyStickerHeight = e.storyStickerHeight ? e.storyStickerHeight : null, this.medias = new Qr(e), this.callToAction = e.gmbCallToAction ? e.gmbCallToAction : "", this.event = e.gmbEvent ? e.gmbEvent : "", this.topicType = e.gmbTopicType ? e.gmbTopicType : null, this.offer = e.gmbOffer ? e.gmbOffer : null, e.gmbOffer && (this.offer.redeemOnlineUrl = e.gmbOffer.redeemOnlineUrl || e.redirectUrl), this.platform = e.platform, this.type = e.type, this.storyType = e.storyType || null, this.ytTitle = e.ytTitle || null, this.ytCategoryId = e.ytCategoryId || null, this.ytTags = e.ytTags || "", t && t.username ? (this.username = t.username, this.profilePicture = t.profile_picture_url) : e.username || e.profilePicture ? (this.username = e.username, this.profilePicture = e.profilePicture) : (this.username = "Failed to find account", this.profilePicture = "https://picsum.photos/id/1/200/200"), this.approvedKey = n, this.rejectedKey = D;
    let s = null, i = null;
    if (e.piBoards && e.piBoards.length > 0 && t.boards && t.boards.length > 0) {
      let a = t.boards.find((o) => o.id === e.piBoards[0]);
      if (a && (s = a.name, a.sections && a.sections.length > 0 && e.piSectionId)) {
        let o = a.sections.find((c) => c.id === e.piSectionId);
        o && (i = o.title);
      }
    }
    this.boardTitle = s || null, this.boardSectionTitle = i || null, this.piTitle = e.piTitle || null;
  }
  get status() {
    switch (this.currentStatusKey) {
      case this.approvedKey:
        return "approved";
      case this.rejectedKey:
        return "rejected";
      default:
        return "initial";
    }
  }
  approve() {
    this.currentStatusKey = this.approvedKey;
  }
  reject(e) {
    this.currentStatusKey = this.rejectedKey, this.rejectionReason = e;
  }
}
class Sl {
  constructor(e, t) {
    const n = e.schedule ? e.schedule : e;
    this.providedPost = n, this.id = n._id, this.stage = "draft", n.scheduledFor ? this.stage = "scheduled" : n.queued && (this.stage = "queued"), this.caption = n.caption || "", this.currentStatusKey = n.normalizedPost_status_key, this.rejectionReason = "", this.scheduledFor = n.when, this.image_url = n.url, this.comment = n.firstcomment || "", this.locationName = n.location && n.location.name, this.redirectUrl = n.redirectUrl ? n.redirectUrl : "", this.storyUrl = n.storyUrl ? n.storyUrl : "", this.storyLabel = n.storyLabel ? n.storyLabel : "", this.storyStickerHeight = n.storyStickerHeight ? n.storyStickerHeight : null, this.callToAction = n.gmbCallToAction ? n.gmbCallToAction : "", this.event = n.gmbEvent ? n.gmbEvent : "", this.topicType = n.gmbTopicType ? n.gmbTopicType : null, this.offer = n.gmbOffer ? n.gmbOffer : null, n.gmbOffer && (this.offer.redeemOnlineUrl = n.gmbOffer.redeemOnlineUrl || n.redirectUrl), this.medias = new Qr(n), this.platform = n.platformType || "IG", n.platforms && n.platforms.length > 0 && (this.platform = n.platforms[0].platformType), this.type = n.type, this.storyType = n.storyType || null, this.username = t.login, this.profilePicture = t.profilePictureUrl || "", this.ytTitle = n.ytTitle || null, this.ytCategoryId = n.ytCategoryId || null, this.ytTags = n.ytTags || "";
    let D = "", s = null;
    if (n.piBoards && n.piBoards.length > 0 && t.boards && t.boards.length > 0) {
      let i = t.boards.find((a) => a.id === n.piBoards[0]);
      if (i && (D = i.name, i.sections && i.sections.length > 0 && n.piSectionId)) {
        let a = i.sections.find((o) => o.id === n.piSectionId);
        a && (s = a.title);
      }
    }
    this.boardTitle = D || null, this.boardSectionTitle = s || null, this.piTitle = n.piTitle || null;
  }
}
export {
  jl as PostModel,
  Nu as RenderSkedCaption,
  wl as SkedCaptionPreview,
  Sl as SkedCorePostModel,
  bl as SkedPreview
};
//# sourceMappingURL=sked-preview.es.js.map
